export const pt = {
    addDatabase: {
        addDatabase: "Adicionar Base de Dados",
        addFromFile: "Adicionar a partir do ficheiro",
        analyse: "Analisar",
        analysingYourData: "A analisar dados",
        createFromExcel: "Criar a partir do Excel",
        databaseImport: "Importar Base de dados",
        databaseNotImported: "ImportaÃ§Ã£o concluÃ­da com erros",
        databasePrepared: "Base de dados preparada com sucesso",
        excelFile: "Ficheiro Excel",
        fileInformation: "InformaÃ§Ã£o de ficheiro",
        fixErrors: "Para continuar corrija os seguintes erros e tente novamente",
        importingYourData: "A importar dados",
        productFilesPath: "DiretÃ³rio de ficheiros de produto",
        productImagesPath: "DiretÃ³rio de imagens de produto"
    },
    availablePrice: {
        allPackage: "Todas as Embalagens",
        onePackage: "Uma Embalagem",
        priceType: "Tipo de preÃ§o",
        setPriceVatVisibility: "Visibilidade do IVA",
        setVisibilityAndOrder: "Definir visibilidade e ordem dos tipos de preÃ§os",
        withAndWithoutVat: "Tanto com, como sem IVA",
        withVat: "Com IVA",
        withoutVat: "Sem IVA"
    },
    barvis: {
        base: "Nome base",
        bigCanSize: "Grandes Formatos",
        coating: "Revestimento",
        identifier: "Identificador",
        laboratory: "LaboratÃ³rio",
        orderOverview: "Resumo do Pedido",
        rank: "PosiÃ§Ã£o",
        smallCanSize: "Pequenos Formatos"
    },
    basicSetup: {
        alreadyLoggedIn: "JÃ¡ estÃ¡ logado como %{login}.",
        askSupplier: "PeÃ§a ao seu fornecedor de software para lhe atribuir mais licenÃ§as.",
        asterisk: "Os artigos marcados com um asterisco devem ser preenchidos.",
        identificationKeys: "Chaves de identificaÃ§Ã£o",
        importCustomData:
            "Se aplicÃ¡vel, importe os seus dados personalizados a partir do software de dispensa anterior.",
        learnIdentification: "Aprenda as chaves de identificaÃ§Ã£o com o seu fornecedor de software.",
        login: "As seguintes etapas da definiÃ§Ã£o inicial requerem direitos de administraÃ§Ã£o.",
        noDatabase: "Ainda nÃ£o foi acrescentada nenhuma Base de Dados, pelo menos uma deve ser inserida.",
        offlineLicensing: "Licenciamento off-line",
        productSelection: "SelecÃ§Ã£o de produtos",
        registrationForm: "FormulÃ¡rio de inscriÃ§Ã£o",
        seeQuestionMark: "Ver os pequenos pontos de interrogaÃ§Ã£o para saber mais.",
        selectDefaultPrinter: "Seleccionar a impressora predefinida e definir definiÃ§Ã£o adicional.",
        selectDefaultTemplate:
            "Seleccione os modelos padrÃ£o de entre os jÃ¡ existentes, crie um novo modelo ou carregue o seu prÃ³prio.",
        selectDispenser: "Seleccione o tipo de dispensador que estÃ¡ a utilizar.",
        selectLanguage: "Seleccione o seu idioma.",
        selectProducts: "Seleccione um dos produtos disponÃ­veis que pretende Activar.",
        selectSpectroType: "Seleccione o tipo de espectrÃ³metro que estÃ¡ a utilizar.",
        setAdditionalPrinterOptions: "Definir opÃ§Ãµes adicionais de impressora.",
        setAutomaticUpdates: "Definir as opÃ§Ãµes de actualizaÃ§Ã£o automÃ¡tica.",
        setCustomItems:
            "Defina os itens personalizados e a visibilidade dos dados. DesÃ§a para baixo para ver mais opÃ§Ãµes.",
        setEnvironment: "Definir o ambiente geral do software. DesÃ§a para ver mais opÃ§Ãµes.",
        setFormulaRepresentation: "Defina a representaÃ§Ã£o da fÃ³rmula. DesÃ§a para baixo para ver mais opÃ§Ãµes.",
        summary:
            "Pode alterar estas definiÃ§Ãµes em qualquer altura e encontrar ainda mais opÃ§Ãµes de definiÃ§Ã£o. Desfrute usando %{name}!",
        summarySuccess: "Tudo preprarado !"
    },
    beforeDispenseColorantBatch: {
        batchNumber: "NÃºmero do lote: %{batchNumber}",
        colorantIsDefective: "O Lote de Corante que o depÃ³sito contÃ©m Ã© inadequado. NÃ£o o Utilize !",
        defectiveInfoLine1: "Por favor nÃ£o utilize corante",
        defectiveInfoLine2: "com este nÃºmero de lote.",
        emptyQuickTint: "Esvazie o depÃ³sito atravÃ©s do Quick Tint (Dispensa Manual).",
        warningInfoLine1: "Corante",
        warningInfoLine2: "com este nÃºmero de lote pode estar estragado."
    },
    canisterLevel: {
        canisterLevel: "NÃ­veis dos DepÃ³sitos de Corantes",
        criticalLevelCanister: "DepÃ³sito(s) com NÃ­vel CrÃ­tico",
        fillToMax: "Encher atÃ© ao NÃ­vel MÃ¡ximo",
        maxDispenseLevel: "Dispensa MÃ¡xima",
        otherCanisters: "DepÃ³sito(s) com NÃ­vel Normal",
        warningLevelCanister: "DepÃ³sito(s) com NÃ­vel de Aviso"
    },
    canisterRefillHistoryModal: {
        batchNumberOfFilling: "NÃºmero de Lote em enchimento",
        ufiCodeStatus: "Estado do CÃ³digo UFI"
    },
    canistersTab: {
        availableServiceActions: "AcÃ§Ãµes de ServiÃ§o DisponÃ­veis",
        canisterInformation: "InformaÃ§Ã£o sobre o DepÃ³sito",
        canisterPreview: "PrÃ©-visualizaÃ§Ã£o do DepÃ³sito",
        currentLevel: "NÃ­vel Actual",
        errors: "Erros",
        fillState: "% de Enchimento",
        fillToMax: "Encher atÃ© ao NÃ­vel MÃ¡ximo",
        fillingAmount: "Volume de Enchimento",
        finalLevel: "NÃ­vel Final",
        minimumAmount: "Volume MÃ­nimo",
        minimumLevel: "NÃ­vel MÃ­nimo",
        moveTableToRefill: "Mover mesa para recarregar",
        refillNoAmount: "Nenhum montante introduzido",
        refillOverLimit: "A quantidade introduzida excede a capacidade mÃ¡xima do depÃ³sito",
        refillSummary: "%{amount} %{unit} do Corante %{colorant} serÃ¡ adicionado ao DepÃ³sito %{canisterId}.",
        systemWarningAmount: "DepÃ³sito - Valor de Aviso",
        warningAmount: "Montante de advertÃªncia"
    },
    changeDatabase: {
        changeDatabase: "Mudar Base de Dados",
        databaseWarning: "Base de Dados %{databaseName} nÃ£o pode ser utilizada devido a"
    },
    changelog: {
        allVersion: "Todas as versÃµes",
        changelog: "Registo de AlteraÃ§Ãµes",
        link: "LigaÃ§Ã£o",
        links: "LigaÃ§Ãµes",
        version: "VersÃ£o",
        versionFilter: "Filtro de versÃ£o"
    },
    checkBeforeDispensing: {
        checkBeforeDispensingModal:
            "NÃ£o existe corante suficente no depÃ³sito para tintar as %{numOfPackages} embalagens.",
        fillAdditionally: "Encha Adicionalmente",
        refillToMax: "Encher atÃ© ao NÃ­vel MÃ¡ximo"
    },
    cleanChannels: {
        cleanAllChannels: "Limpar todos os bocais",
        cleanChannels: "Limpar os bocais",
        cleaningTime: "PerÃ­odo de limpeza",
        selectChannels: "Seleccionar depÃ³sito",
        startCleaning: "Iniciar limpeza"
    },
    clientServerSettings: {
        activeServer: "Servidor Activo",
        addNewServer: "Adicionar Novo Servidor",
        availableServers: "Outros Servidores DisponÃ­veis",
        clientIdentifier: "Identificador de Cliente",
        clientServerSettings: "DefiniÃ§Ãµes cliente/servidor",
        disabledStatus: "desactivado",
        editServer: "Editar servidor",
        fillRequiredFields: "Os campos obrigatÃ³rios devem ser preenchidos",
        noOtherServers: "NÃ£o existem outros servidores disponÃ­veis",
        offlineStatus: "desligado",
        onlineStatus: "ligado",
        port: "Porto",
        serverName: "Nome do servidor",
        serverNameMissing: "O nome do servidor deve ser preenchido",
        stabileConnection: "Para assegurar uma ligaÃ§Ã£o estÃ¡vel, utilizar um endereÃ§o IP estÃ¡tico.",
        wrongFormatIp: "O formato do endereÃ§o IP Ã© incorreto"
    },
    colorSearchTab: {
        notEveryItemSelected: "Um ou mais items nÃ£o estÃ£o seleccionados"
    },
    colorTab: {
        colorTone: "Tonalidade",
        fandeckPosition: "PosiÃ§Ã£o do CatÃ¡logo",
        moreInfoIcons: "Mais Ã­cones de informaÃ§Ã£o",
        notExistingFormula: "FÃ³rmula inexistente",
        orderBy: "Ordenado por",
        selectYourGrid: "Seleccione a sua grelha",
        showInPanel: "Mostrar no painel",
        warningIcon: "Ãcone de aviso para fÃ³rmula inexistente"
    },
    colorantBatchNumberSettings: {
        batchNumberByPercentage: "Utilizar nÃºmeros de lote por percentagem",
        batchNumberFromLastFilling: "Utilizar nÃºmeros de lote desde Ãºltimo enchimento",
        defectiveBatchOfColorant: "Lote de Corante Defeituoso",
        enableBatchNumber: "Activar NÃºmeros de Lote dos Corantes",
        possibleDamagedBatchOfColorant: "Lote de Corante possivelmente estragado",
        scanOrTypeBatchNumber: "Digitalize ou digite o NÃºmero de Lote"
    },
    colorantPanel: {
        manualMachine: "mÃ¡quina"
    },
    colorantsTable: {
        numberOfColorants: "NÃºmero de Corantes:",
        preview: "PrÃ©-visualizaÃ§Ã£o",
        prices: "PreÃ§os"
    },
    currencySettings: {
        addNewCurrency: "Acrescentar nova moeda",
        codePlaceholder: "CÃ³digo",
        currencySettings: "DefiniÃ§Ãµes de Moeda",
        namePlaceholder: "Nome",
        ratePlaceholder: "Taxa",
        setDecimalPlaces: "Definir o nÃºmero de casas decimais",
        setMainCurrency: "Definir moeda principal",
        setRounding: "Arredondamento",
        symbolPlaceholder: "SÃ­mbolo"
    },
    customFandecks: {
        customFandecks: "CatÃ¡logos Personalizados",
        deleteButtonWarning: "Todas as FÃ³rmulas do CatÃ¡logo serÃ£o tambÃ©m removidas.",
        deleteCustomFandeck:
            "Quer mesmo apagar este CatÃ¡logo personalizado ? Todas as fÃ³rmulas deste CatÃ¡logo serÃ£o tambÃ©m apagadas.",
        disableStandardFandecks: "Mostrar apenas CatÃ¡logos Personalizados",
        enableStandardFandecks: "Mostrar CatÃ¡logos Standard",
        fandeckName: "Nome do CatÃ¡logo"
    },
    customRedlike: {
        addColorantFromBrand: "Adicionar Corante da marca %{brandName}",
        addNewCustomer: "Adicionar Novo Cliente",
        addNewNote: "Adicionar nova Nota",
        addedDate: "Data adicionada",
        addedQuantity: "Quantidade adicionada",
        availableMachine: "MÃ¡quina disponÃ­vel",
        brand: "Marca",
        brandPlease: "Seleccione a marca",
        cancelCustomer: "Cancelar Cliente",
        colorPlease: "Selecione Cor",
        confirmCustomerData: "Confirmar os dados do Cliente",
        confirmNoteData: "Confirmar os dados da Nota",
        confirmSelectedUser: "Deseja utilizar o Cliente %{customerName} para este pedido?",
        confirmed: "Confirmado",
        controlData: "Controlo final dos dados",
        customerCellNumber: "NÃºmero de telemÃ³vel do Cliente",
        customerFilter: "Filtro do Cliente",
        customerName: "Nome do Cliente",
        customerPhone: "Telefone do Cliente",
        customerPlease: "Selecione o Cliente",
        dateFilter: "Filtro de Data",
        enterPin: "Introduza o seu cÃ³digo PIN",
        enterTheNumberOfPackages: "Introduzir o nÃºmero do DepÃ³sito",
        existingCustomer: "O Utilizador jÃ¡ existe",
        fandeckPlease: "Selecione o CatÃ¡logo de Cores",
        fillCanisterHistory: "HistÃ³rico de Enchimento do DepÃ³sito",
        findCustomer:
            "Para atribuir um CartÃ£o de FidelizaÃ§Ã£o a este pedido, leia o cÃ³digo de barras ou procure um endereÃ§o de e-mail.",
        findCustomerByEmail: "Filtrar Cliente por e-mail ou CÃ³digo de Barras.",
        finishPreviousStep: "(Termine o passo anterior)",
        formulaUnit: "Unidade de FÃ³rmula",
        getBackToList: "Voltar Ã  lista de Clientes",
        historyOfOrders: "HistÃ³rico de Pedidos",
        insertNote: "Avance para inserir Nota",
        loadHistoryOrder: "Pretende carregar o pedido seleccionado?",
        loyaltyCards: "CartÃµes de FidelizaÃ§Ã£o",
        machineIsAvailable: "A MÃQUINA ESTÃ DISPONÃVEL",
        machineIsUnavailable: "A MÃQUINA NÃO ESTÃ DISPONÃVEL",
        newLoyaltyCard: "Novo CartÃ£o de FidelizaÃ§Ã£o",
        noAvailableMachine: "A mÃ¡quina nÃ£o estÃ¡ disponÃ­vel",
        noCustomerSelected: "Nenhum Cliente selecionado. AvanÃ§ar ?",
        notePlease: "Adicione uma Nota",
        openHistory: "Abrir HistÃ³rico",
        orAdd: "ou adicionar Cliente",
        orSelect: "ou Seleccionar Cliente",
        orderModification: "O pedido original serÃ¡ modificado. AvanÃ§ar ?",
        orderOverview: "Resumo do Pedido",
        orderToMachine: "ENVIAR PEDIDO PARA A MÃQUINA",
        ordersHistory: "HistÃ³rico de Pedidos",
        packagePlease: "Selecione uma Embalagem",
        pleaseSelectBrand: "Selecione uma Marca",
        previewImage: "PrÃ©-visualizaÃ§Ã£o IMG",
        previewPackage: "PrÃ©-visualizaÃ§Ã£o da Embalagem",
        productPlease: "Selecione Produto",
        resetFilters: "Reiniciar todos os filtros",
        searchForHistoricalOrders: "Ou procure no histÃ³rico de pedidos",
        selectBrand: "Selecione Marca",
        selectColor: "Ir para SelecÃ§Ã£o de Cores",
        selectCustomer: "Ir para SelecÃ§Ã£o de Clientes",
        selectExistingCustomer: "Seleccione um Cliente existente",
        selectFandeck: "Ir para SelecÃ§Ã£o de CatÃ¡logos de Cor",
        selectManually: "Se deseja usar esta cor na marca %{brandNames} por favor seleccione-a manualmente.",
        selectPackage: "Ir para SeleÃ§Ã£o de Embalagens",
        selectProduct: "Ir para SeleÃ§Ã£o de Produtos",
        shotsCoefficient: "Coeficiente de Dispensa (shots)",
        showDetail: "Mostrar detalhe",
        showHideEshopName: "Mostrar/Ocultar o nome da loja virtual da cor numa coluna separada",
        showKeyboard: "Mostrar teclado",
        skipCustomerButton: "Ignorar a SelecÃ§Ã£o do Cliente",
        skipCustomerText: "Ignorar se nÃ£o pretender inserir Cliente",
        skipNote: "Ignorar nota e mostrar resumo",
        spectroBrand: "Procurar na Marca %{brandName}",
        statusAccepted: "aceite",
        statusCanceled: "cancelado",
        statusCreated: "criado",
        statusDone: "concluÃ­do",
        statusPartlyDone: "parcialmente concluÃ­do",
        statusPreparing: "preparando",
        summaryChosenBase: "Base",
        summaryChosenBrand: "marca",
        summaryChosenCanSize: "Formato",
        summaryChosenColor: "cor",
        summaryChosenColorCard: "CatÃ¡logo",
        summaryChosenProduct: "produto",
        summaryChosenQuantity: "quantidade",
        summaryColorPreview: "PrÃ©-visualizaÃ§Ã£o da Cor",
        summaryCustomNote: "Nota personalizada",
        summaryCustomerNumber: "NÃºmero de Cliente",
        summaryFormula: "FÃ³rmula",
        summaryFormulaNote: "Nota da FÃ³rmula",
        summaryNote: "Nota",
        sureAboutSend: "Pretende realmente enviar um pedido?",
        useCustomerInOrder: "Deseja utilizar o Cliente %{customerName} para o pedido seguinte ?",
        uuid: "UUID",
        viewSummary: "Ver resumo",
        volume: "Volume"
    },
    customRedlikeAnother: {
        pinOrderConfirmation: "Pin de confirmaÃ§Ã£o do pedido",
        pinScreenSaverConfirmation: "Pin de confirmaÃ§Ã£o do protector de ecrÃ£",
        pinSettingsConfirmation: "ConfirmaÃ§Ã£o das definiÃ§Ãµes de pin",
        printAuto: "Permitir a impressÃ£o automÃ¡tica",
        printerSettings: "DefiniÃ§Ãµes da impressora",
        selectColorWithFandeck: "SeleÃ§Ã£o conjunto de cor e catÃ¡logo",
        setKeyboard: "Definir Teclado",
        setKioskMode: "Definir Modo Kiosk",
        setLanguage: "Definir Idioma",
        setModule: "Definir MÃ³dulo",
        setQuickSelect: "Definir SelecÃ§Ã£o RÃ¡pida",
        setScreensaverTimeout: "Definir o tempo limite de protecÃ§Ã£o de ecrÃ£",
        setUnit: "Unidade definida"
    },
    customRedlikeMachine: {
        action: "AcÃ§Ã£o",
        additionalPrint: "ImpressÃ£o adicional",
        brand: "Marca",
        brandAccess: "O utilizador '%{userName}' nÃ£o pode aceder aos dados da marca '%{brandName}'",
        can: "Pode colocar",
        canistersLevel: "VisÃ£o geral do nÃ­vel das latas",
        closeDetailInformation: "Detalhe de perto",
        colorantsAmount: "Quantidade de corantes",
        confirmRefill: "Confirmar recarga de corante",
        deleteOrder: "Eliminar pedido",
        dialogNoMachine: "A mÃ¡quina nÃ£o estÃ¡ ligada",
        dialogNoRcc: "NÃ£o estÃ¡ nenhum RCC ligado",
        dispense: "Dispensar",
        dispenserInErrorState: "O Dispensador estÃ¡ em estado de erro",
        dispensingIsOk: "O dispensador estÃ¡ pronto",
        emergencyButtonPressed: "Interruptor de paragem de emergÃªncia premido",
        errorCode: "CÃ³digo de erro",
        errorEvents: "Erros do dispensador",
        errorReset: "Erro de reinicializaÃ§Ã£o",
        explanation: "ExplicaÃ§Ã£o",
        imageNotAvailable: "A imagem nÃ£o estÃ¡ disponÃ­vel",
        incorrectCanister: "Erro na leitura do cÃ³digo do DepÃ³sito",
        incorrectColorant: "Erro na leitura do cÃ³digo da Embalagem de Corante. Digitalize o Corante correto",
        lastEvents: "Ãltimos registos",
        machineActions: "Sensores do Dispensador",
        machineConfiguration: "DefiniÃ§Ã£o do Dispensador",
        machineError: "Erro da mÃ¡quina",
        machineIsBusy: "A mÃ¡quina estÃ¡ ocupada",
        machineNotAvailable: "A mÃ¡quina nÃ£o estÃ¡ disponÃ­vel",
        machineTinting: "Aguarde, dispensa em curso ...",
        manualScan: "DigitalizaÃ§Ã£o Manual",
        notEnoughSpace: "ERRO: nÃ£o hÃ¡ espaÃ§o suficiente para esta embalagem de Corante",
        numberOfCanistersUnderCriticalLevel: "O nÃºmero de depÃ³sitos sob o nÃ­vel crÃ­tico Ã© de %{0}",
        numberOfCanistersUnderWarningLevel: "O nÃºmero de depÃ³sitos sob nÃ­vel de aviso Ã© de  %{0}",
        offlinePressed: "BotÃ£o off-line premido",
        orderSettings: "DefiniÃ§Ãµes de pedido",
        otherOrderInformation: "Detalhes de pedido",
        packageCount: "NÃºmero de embalagens",
        packageWithSeparator: "Embalagem",
        received: "Recebido",
        receivedOrders: "Pedidos de recebidos",
        receivedTime: "Tempo recebido",
        recirculation: "RecirculaÃ§Ã£o",
        refillInformation: "Corante: %{0}, NÃ­vel de Enchimento: %{1}, DepÃ³sito: %{2}",
        resetErrors: "Erros de reinicializaÃ§Ã£o",
        scanCanister: "Digitalize este DepÃ³sito",
        scanColorantPackage: "Digitalize a embalagem de Corante correta",
        selectedOrder: "Pedido selecionado",
        shelfMovingDown: "Prateleira a descer",
        shelfMovingUp: "Prateleira a subir",
        solution: "SoluÃ§Ã£o",
        startDispensing: "Iniciar Dispensa",
        stirring: "AgitaÃ§Ã£o",
        touchToStartFilling: "Premir  para comeÃ§ar o enchimento do Corante",
        unknownBrand: "Marca desconhecida"
    },
    customRedlikeSettings: {
        addPos: "InformaÃ§Ã£o do POS",
        addServer: "Adicionar servidor",
        adminOperations: "OperaÃ§Ãµes de AdministraÃ§Ã£o",
        adminSettings: "DefiniÃ§Ãµes de AdministraÃ§Ã£o",
        another: "Outro",
        aslOrService: "ASL ou ServiÃ§o",
        availableMachines: "MÃ¡quinas disponÃ­veis",
        barcode: "CÃ³digo de Barras",
        basicOperations: "OperaÃ§Ãµes BÃ¡sicas",
        canisterBarcodes: "CÃ³digo de Barras dos DepÃ³sitos",
        canisterLevels: "NÃ­vel de Enchimento do DepÃ³sito",
        closeConnection: "Fechar LigaÃ§Ã£o",
        closeRedlike: "Fechar %{name}",
        databaseList: "Base de Dados",
        disabledStatus: "desactivado",
        dispenseLogicType: "Dispensador - Logic Type ",
        dropServers: "Servidores Desligados",
        editServer: "Editar servidor",
        lastEvent: "Ãltimo registo",
        logOut: "Sair",
        machineConfiguration: "DefiniÃ§Ã£o",
        maxDispenseAmount: "Montante mÃ¡ximo de Dispensa",
        offlineStatus: "desligado",
        onlineStatus: "ligado",
        openFrondesk: "Abrir Frontdesk",
        print: "DefiniÃ§Ãµes de impressÃ£o",
        rebootPC: "Reiniciar o PC",
        restartRedlike: "Reiniciar %{name}",
        restoreConnection: "Restaurar a ligaÃ§Ã£o",
        scanCanisterBarcode: "Digitalize ou Digite o CÃ³digo de Barras do DepÃ³sito",
        scanOrDeleteCanisterBarcode: "Digitalize ou Apague o CÃ³digo de Barras",
        setCanisterBarcode: "CÃ³digo de Barras dos DepÃ³sitos de Corantes",
        swVersion: "VersÃ£o do software",
        systemFunctions: "FunÃ§Ãµes do Sistema",
        userSettings: "DefiniÃ§Ãµes do Utilizador"
    },
    customTab: {
        cifCombinationCheck:
            "The color %{colorName} already exists in fandeck %{fandeckName}, but it contains different spectral data. Would you like to overwrite existing data?",
        editColor: "Editar cor",
        editColorant: "Editar Corante",
        emptyColorant: "Existe um Corante sem quantidade definida",
        formulaCombinationCheck:
            'The formula with the color name "%{colorName}" already exists. Would you like to overwrite existing formula with the new one?',
        formulaForMasterProduct: "FÃ³rmula para Produto Pai",
        formulaForMasterProductWithParam: "FÃ³rmula para Produto Pai %{productName}",
        isNotAvailable: "nÃ£o estÃ¡ disponÃ­vel",
        noBaseSelected: "A Base Ã© requerida",
        noColorantsSelected: "Nenhum Corante selecionado",
        noFandeckSelected: "O CatÃ¡logo Ã© requerido",
        noNameOrCode: "Nome e CÃ³digo da FÃ³rmula requeridos",
        noProductSelected: "O Produto Ã© requerido",
        productPreview: "PrÃ©-visualizaÃ§Ã£o do Produto",
        saveCustomRecipe: "Guardar FÃ³rmula Personalizada",
        saveIsNotAvailable: "Guardar nÃ£o estÃ¡ disponÃ­vel",
        showSiblingProducts: "Mostrar Produtos Filhos",
        siblingProducts: "Produto Filhos do Produto Pai"
    },
    customersTab: {
        addCustomer: "Adicionar Cliente",
        additionalSettings: "DefiniÃ§Ãµes adicionais",
        adress: "EndereÃ§o",
        createAndSelect: "Adicionar e seleccionar",
        createNewCustomer: "Criar novo Cliente",
        editCustomer: "Editar Cliente",
        expiration: "O Cliente %{name} expirarÃ¡ em %{dayCount} dias.",
        identificationNumber: "NÃºmero de identificaÃ§Ã£o",
        information: "InformaÃ§Ã£o de Contacto",
        listOfCustomers: "Lista de Clientes",
        rabat: "Desconto",
        selectCustomer: "Seleccionar Cliente",
        spentLastMonth: "Gasto no mÃªs passado",
        spentMoney: "Despesa",
        typeOfMargin: "Tipo de Margem",
        zipCode: "CÃ³digo Postal"
    },
    dialog: {
        cheaperColorSearch: "Procura de Cor EconÃ³mica em Curso",
        competitiveColorSearch: "Procura de Cor Competitiva em Curso",
        reallyChangeModule: "Confirme -  Alterar o mÃ³dulo?",
        reallyCloseRedlike:
            "Confirme - Fechar  %{name}? Todos os painÃ©is %{name} serÃ£o fechados, as alteraÃ§Ãµes nÃ£o guardadas serÃ£o perdidas.",
        reallyDeleteOrder: "Confirme - Eliminar este pedido? Todos os dados associados a este pedido serÃ£o perdidos.",
        reallyRebootPC:
            "Confirme - Reiniciar este PC? Todos os painÃ©is serÃ£o fechados, as alteraÃ§Ãµes nÃ£o guardadas serÃ£o perdidas.",
        reallyRestartRedlike:
            "Confirme - Reiniciar %{name}? Todos os painÃ©is serÃ£o fechados, as alteraÃ§Ãµes nÃ£o guardadas serÃ£o perdidas.",
        reallyShutdownPc:
            "Confirme - Desligar o Computador? Todos os painÃ©is %{name} serÃ£o fechados, as alteraÃ§Ãµes nÃ£o guardadas serÃ£o perdidas.",
        unlockComputer: "O computador serÃ¡ desbloqueado"
    },
    dispenseLogicTypes: {
        1: "Dispensar apenas a quantidade mÃ¡xima tintÃ¡vel ",
        2: "Permite a Dispensa manual, com ajuda de uma balanÃ§a, para quantidades superiores Ã  quantidade mÃ¡xima tintÃ¡vel.",
        3: "Abastecer ao tintar (dividir a quantidade em porÃ§Ãµes mais pequenas)",
        4: "ForÃ§ar a dispensa manual  utilizando a balanÃ§a, apenas se utilizar embalagem personalizada"
    },
    editCustomFandeck: {
        fandeckName: "Nome do CatÃ¡logo"
    },
    editFormulaRgbModal: {
        apply: "Aplicar",
        blue: "Azul",
        green: "Verde",
        modalLabel: "Editar Cor",
        red: "Vermelho",
        tryGenerateRgb: "Tente gerar RGB atravÃ©s das quantidades de corante"
    },
    environmentsSettings: {
        allowAutoCloseTab: "Fechar automaticamente o separador de fÃ³rmula",
        allowBarcodes: "Permitir CÃ³digos de Barras",
        allowBuildingSitePanel: "Permitir a construÃ§Ã£o da especificaÃ§Ã£o do Site.",
        allowCustomers: "Permitir Clientes",
        allowDeleteConfirmation: "Pedir ConfirmaÃ§Ã£o para Fechar o programa CCS Cliente",
        allowDiskSpaceNotification: "Permitir NotificaÃ§Ãµes de espaÃ§o em disco",
        allowDispensing: "Permitir Dispensa ",
        allowFileTransfer: "Permitir transferÃªncia automÃ¡tica de ficheiros",
        allowFormulaModificationPanel: "Permitir Painel de AlteraÃ§Ã£o de FÃ³rmula",
        allowFormulaStatusPanel: "Permitir Painel de Estado da FÃ³rmula",
        allowInternalNotes: "Permitir Notas Internas",
        allowLight: "Permitir %{name}",
        allowOrderNotificationModal: "Mostrar notificaÃ§Ãµes novas do Pedido",
        allowOrdering: "Permitir Pedido",
        allowPricing: "Permitir PreÃ§os",
        allowPrint: "Permitir ImpressÃ£o",
        allowProductPreviewImage: "Mostrar imagem de prÃ©-visualizaÃ§Ã£o do Produto",
        allowQualityControl: "Permitir Controlo de Qualidade",
        allowSearchCheaperColors: "Permitir procura de Cores + EconÃ³micas",
        allowSound: "Permitir notificaÃ§Ã£o sonora para o Pedido",
        allowSpectro: "Permitir EspectrofotÃ³metro",
        allowTabs: "Permitir Separadores",
        applyZoom: "Aplicar zoom",
        automaticLogout: "SaÃ­da automÃ¡tica",
        barcodeScan: "Leitura de CÃ³digo de Barras",
        canisterBarcode: "CÃ³digo de Barras dos DepÃ³sitos",
        canisterLevel: "NÃ­veis dos DepÃ³sitos de Corantes",
        changelog: "Registo de AlteraÃ§Ãµes",
        closeTab: "Fechar Separador",
        colorDifference: "DiferenÃ§a de Cor",
        colorPanelNavItem: "Paleta de Cores",
        competitiveColorSearch: "Procura de Cor Competitiva",
        customBanner: "Faixa Personalizada",
        customCurrencyFormat: "Formato da Moeda",
        customDateFormat: "Formato da Data",
        customNumberFormat: "Formato NumÃ©rico",
        customTimeFormat: "Formato da Hora",
        deltaA: "Delta A",
        deltaB: "Delta B",
        deltaE: "Delta E",
        deltaL: "Delta L",
        deltaMetamerism: "Delta Metamerismo",
        discount: "Mostrar Desconto",
        dispensingHistory: "HistÃ³rico de Dispensas",
        dispensingNotes: "Permitir Notas de Dispensas",
        enableCustomers: "Permitir Clientes",
        enableDeleteConfirmation: "Activa a ConfirmaÃ§Ã£o para Apagar",
        enableDispensing: "Activar Dispensa",
        enableLight: "Habilitar %{name}",
        enableMarginMarkup: "Habilitar Margem ou Markup",
        enableNotes: "Habilitar notas",
        enableOrdering: "Activar a encomenda",
        enableProductPreviewImage: "Activar a imagem de prÃ©-visualizaÃ§Ã£o do produto",
        enableSpectro: "Activar espectro",
        enableVirtualKeyboard: "Permitir Teclado Virtual",
        environmentsSettings: "DefiniÃ§Ãµes do Ambiente",
        exportTranslationKeys: "Exportar Chaves de TraduÃ§Ã£o",
        formulaNotes: "Permitir Notas nas FÃ³rmulas",
        hintTooltips: "SugestÃµes e Dicas",
        image: "Cor + Imagem",
        keyboardShortcuts: "Atalhos de Teclado",
        languageBased: "Baseado no Idioma",
        lockYourComputer: "Bloquear Computador",
        machineReset: "ReinicializaÃ§Ã£o da MÃ¡quina",
        manageTranslations: "Gerir TraduÃ§Ãµes",
        margin: "Mostrar Margem",
        markup: "Mostrar Markup",
        matchingRowCount: "Define o nÃºmero de ocorrÃªncias que correspondem",
        maxNumberTabs: "NÂº mÃ¡ximo de separadores de FÃ³rmula",
        memoryTabs: "Guardar separadores abertos recentemente",
        moreInfo: "Cor + Imagem / Mais informaÃ§Ã£o",
        navigationItems: "DefiniÃ§Ãµes dos items de navegaÃ§Ã£o",
        newTab: "Novo Separador",
        numberOfPriceGroups: "NÃºmero de Grupos de PreÃ§o",
        order: "Pedido",
        orderId: "ID do Pedido",
        ordersHistory: "HistÃ³rico de Pedidos",
        overwriteLastTab: "Sobreescrever o Ãºltimo separador de fÃ³rmula",
        priceCalculation: "CÃ¡lculo do preÃ§o",
        priceDefBothPurchasePrimary: "Ambos, compra primÃ¡ria",
        priceDefBothSellPrimary: "Ambos, venda primÃ¡ria",
        priceDefPurchaseOnly: "PreÃ§o de Compra apenas",
        priceDefSellOnly: "PreÃ§o de Venda apenas",
        priceDefinition: "DefiniÃ§Ã£o de PreÃ§os",
        priceGroupsEnabled: "Permitir Grupos de PreÃ§o",
        runLightAtStartUp: "Executar %{light} no arranque",
        screenSaverTimeout: "Tempo em minutos atÃ© Ã  activaÃ§Ã£o do Protector de Ãcran",
        selectedSpectro: "espectrofotÃ³metro %{spectro} selecionado.",
        selectedSpectroNone: "Nenhum espectrofotÃ³metro selecionado.",
        setAutomaticClientStart: "Executar %{name} no arranque do computador",
        setCustomHomeButton: 'Definir acÃ§Ã£o do botÃ£o "Home"',
        setDecimalPlaces: "Definir o nÃºmero de casas decimais",
        setFormulaPreview: "Definir prÃ©-visualizaÃ§Ã£o da fÃ³rmula",
        setFormulaUnit: "Definir unidade da fÃ³rmula",
        setFts: "Usar procura de texto completa",
        setInfoItemInRgb: "Dados na prÃ©-visualizaÃ§Ã£o de Cores - RGB",
        setKeyboardShortcuts: "Definir Atalhos de Teclado",
        setKioskMode: "Definir modo Kiosk",
        setKioskModeOff: "Desligar o Modo de Kiosk",
        setKioskModeOn: "Ligar o Modo de Kiosk",
        setNavigationItems: "Definir itens de navegaÃ§Ã£o",
        setNavigationItemsList: "Definir visibilidade e ordem dos itens de navegaÃ§Ã£o",
        setOrderSearchItems: "Definir parÃ¢metros de procura do pedido",
        setRounding: "Definir arredondamento",
        setSearchParameters: "Defnir parÃ¢metros de procura para fÃ³rmulas",
        setTabLimit: "Definir limite de separadores",
        setYourLanguage: "Definir Idioma",
        setZoom: "Definir Zoom",
        showLocalPrices: "Mostrar PreÃ§os Sugeridos",
        skipPlaceCanDialogEnabled:
            "'Esta definiÃ§Ã£o nÃ£o pode alterada porque a janela ''colocar lata ou embalagem'' estÃ¡ desativada nas DefiniÃ§Ãµes do Dispensador'",
        sortItems: "Ordenar Itens de NavegaÃ§Ã£o",
        startDispensing: "Iniciar Dispensa",
        stir: "Agitar"
    },
    error: {
        errorDetail: "Detalhe do erro",
        errorOccurred:
            "Ocorreu um erro inesperado. Contacte o nosso apoio em %{0}, e entraremos em contacto consigo assim que nos for possÃ­vel.",
        hideDetail: "Ocultar detalhe"
    },
    favoritesTab: {
        addFolder: "Adicionar pasta",
        closeTabToLoadFormula:
            "Feche uma das fÃ³rmulas para abrir um novo separador. Atingiu o nÃºmero mÃ¡ximo de separadores.",
        deleteFolder: "Apagar pasta",
        editFolder: "Editar pasta",
        favoriteFormulas: "FÃ³rmulas Favoritas",
        formulaNotes: "Notas de FÃ³rmula",
        message: {
            formulasFromFolder: "FÃ³rmula a partir de uma Pasta",
            moveAllFormulas: "Mover todas as fÃ³rmulas desta pasta para a pasta principal",
            removeAllFormulas: "Retirar todas as fÃ³rmulas desta pasta",
            wantToDeleteFolder: "Quer mesmo apagar esta pasta?"
        },
        newFolder: "Nova Pasta",
        packages: "Embalagens",
        pricePerPackage: "PreÃ§o por Embalagem",
        regularPrice: "PreÃ§o normal",
        removeFromFavorites: "Retirar dos Favoritos",
        specialPriceOff: "PreÃ§o especial %{number}% de desconto",
        specialPriceVIP: "PreÃ§o especial VIP"
    },
    fileTransfer: {
        afterImport: "ApÃ³s importaÃ§Ã£o",
        alreadyExists: "A tarefa para o tipo e formato introduzidos, jÃ¡ existe.",
        customFormulaSimple: "FÃ³rmula Personalizada simples",
        direction: "Sentido",
        exportTask: "ExportaÃ§Ã£o de Ficheiro",
        fileTransferNotification: "NotificaÃ§Ã£o de TransferÃªncia de Ficheiro",
        flashMessage: "Mensagem InstantÃ¢nea",
        importTask: "ImportaÃ§Ã£o de Ficheiro",
        noInformation: "Sem InformaÃ§Ã£o",
        protocol: {
            folder: "Pasta",
            ftp: "Protocolo FTP",
            ftps: "Protocolo FTPS",
            redlikeStorage: "%{softwareName} Protocolo de armazenamento FTP",
            sftp: "SFTP protocol"
        },
        protocolDescription: {
            folder: "Protocolo de VerificaÃ§Ã£o - Ficheiros em pastas definidas localmente.",
            ftp: "Protocolo de VerificaÃ§Ã£o - Ficheiros em pastas FTP Remotas usando uma ligaÃ§Ã£o FTP standard.",
            ftps: "Protocolo de VerificaÃ§Ã£o  - Ficheiros em servidor  FTPS (FTP-SSL / FTP Secure) usando uma ligaÃ§Ã£o FTP standard.",
            redlikeStorage: "Protocolo de VerificaÃ§Ã£o -  Ficheiros em  Storage RedLike %{softwareName}."
        },
        remoteFolder: "Pasta Remota",
        startType: "Tipo de arranque",
        statusbar: "InformaÃ§Ã£o da Barra de Estado",
        testConnection: "Testar LigaÃ§Ã£o",
        xMoreLeft: "(%{amount} em falta)",
        xmlImporting: "A importar o ficheiro XML"
    },
    filtering: {
        consumptionType: "Tipo de consumo",
        filter: "Filtro",
        from: "De",
        to: "AtÃ©"
    },
    findText: {
        findTextTitle: "Procurar Texto",
        removeMarks: "Remover Marcas",
        search: "Procurar Palavra"
    },
    flashMessage: {
        VMNotAllowed: "MÃ¡quina Virtual nÃ£o Permitida.",
        addedToStock: "Items adicionados ao stock com sucesso.",
        allRecordsDeleted: "Todos os registos importados foram eliminados com sucesso",
        autologinFailed: "O autologin da Base de Dados falhou.",
        autotaskDuplicateName:
            "Erro de integridade da Base de Dados: %{0} item com %{1} %{2} jÃ¡ existe, use um diferente %{3}.",
        barcodeIsUsed: "Este CÃ³digo de Barras jÃ¡ foi utilizado.",
        barcodeNotFound: "O CÃ³digo de Barras nÃ£o foi encontrado.",
        bugReportSent: "O seu relatÃ³rio de Erros foi enviado com sucesso.",
        cannoctConnectToServer: "ImpossÃ­vel ligar ao Servidor.",
        cannotWriteLicense: "ImpossÃ­vel gravar a licenÃ§a.",
        clientConnectionRejected: "LigaÃ§Ã£o recusada.",
        clientNotLoggedIn: "O Cliente nÃ£o estÃ¡ registado.",
        colorFromInactiveDatabase: "Color is from inactive database %{0}.",
        colorantPackageRemovedStock: "Embalagem de Corante removida com sucesso do stock.",
        competitiveSearchEmpty:
            "NÃ£o foi possÃ­vel localizar Cores Competitivas â¦ Mude os critÃ©rios de procura ou escolha uma cor diferente.",
        competitiveSearchSelectProduct: "Seleccione o Produto para a procura de Cores Competitivas",
        computerBackdated: "O Computador foi atualizado com uma versÃ£o anterior.",
        connectionFailed: "O Teste de LigaÃ§Ã£o falhou: %{0}",
        connectionSuccess: "O Teste de LigaÃ§Ã£o foi Bem Sucedido!",
        corruptedLicenseFile: "Ficheiro de licenÃ§a corrompido",
        customFormulaCreated: "FÃ³rmula Personalizada criada com sucesso",
        customFormulaCreationError: "Erro na criaÃ§Ã£o de FÃ³rmula Personalizada",
        customFormulaFromXmlCreationError:
            "Error while creating custom formula with colorants '%{colorants}' for combination of product '%{product}', fandeck '%{fandeck}', color '%{color}' and base '%{base}'.",
        customerNotFound: "O Cliente nÃ£o foi encontrado.",
        dataNotAvailable: "O Servidor nÃ£o consegue ligar Ã  Base de Dados.",
        datacolorMatching: {
            couldNotConnect: "Datacolor Matching - ImpossÃ­vel Ligar - Servidor ou PC offline",
            disabled: " Datacolor Matching - Inactivo",
            internalError: "Datacolor Matching - Erro Interno: '%{0}'",
            invalidCredentials: "Datacolor Matching - Credenciais invÃ¡lidas ou ausentes. Contacte o Suporte",
            noCansAvailable:
                "NÃ£o existem embalagens disponÃ­veis para o Ficheiro de Cor (Linha de Produto). Contacte o Suporte"
        },
        defaultMessage: "Ocorreu um erro inesperado durante a Ãºltima acÃ§Ã£o do Servidor.",
        deleteAll: "Apagar tudo",
        deletingImportedData: "A eliminar registos importados",
        disableWinterPlugin:
            "Pode desactivar o plugin de Inverno utilizando a lista pendente do lado direito do separador de navegaÃ§Ã£o.",
        duplicateBarcode: "Duplicado. O CÃ³digo de Barras jÃ¡ existe.",
        duplicateName: "Duplicado. O Nome jÃ¡ existe.",
        emptyFandeck: "O CatÃ¡logo seleccionado estÃ¡ vazio.",
        emptyStock: "NÃ£o existem registos em stock para o item que foi usado.",
        expiredLicense: "A licenÃ§a expirou.",
        exportSuccess: "Os dados foram exportados com sucesso.",
        fandeckExist: "O nome que atribuiu para este CatÃ¡logo Personalizado jÃ¡ existe.",
        featureNotAutorized: "O recurso nÃ£o foi autorizado.",
        fileExportComplete: "O ficheiro foi exportado com sucesso.",
        fileExportError: "Ocorreu um erro durante a exportaÃ§Ã£o do ficheiro",
        fileSaveComplete: "Ficheiro guardado com sucesso",
        fileSaveError: "Ocorreu um erro durante a salvaguarda do ficheiro",
        fileTransferCustomFormulaRecordsAdded:
            "Novos registos de FÃ³rmulas Personalizadas foram adicionados com sucesso a partir do ficheiro recebido.",
        fileTransferCustomFormulaRecordsNotFullyProcessed:
            "ImpossÃ­vel processar os dados de FÃ³rmulas Personalizadas no ficheiro: '%{0}', Consulte o ficheiro de Log para mais informaÃ§Ãµes.",
        fileTransferCustomFormulaRecordsProcessed:
            "Os novos registos de FÃ³rmulas Personalizadas (%{0} of the %{1}) foram adicionados com sucesso a partir do ficheiro recebido.",
        fileTransferCustomerRecordsAdded:
            "Os novos registos, com origem no ficheiro recebido, foram adicionados com sucesso.",
        fileTransferCustomerRecordsNotFullyProcessed:
            "ImpossÃ­vel processar os registos no ficheiro: '%{0}'. Consulte o ficheiro de Log para mais informaÃ§Ãµes.",
        fileTransferCustomerRecordsProcessed:
            "Os novos registos (%{0} de %{1}) foram adicionados com sucesso a partir do ficheiro recebido.",
        fileTransferFileNotProvided: "O ficheiro nÃ£o fornecido ou vazio.",
        fileTransferHistoryRecordsAdded:
            "Os novos registos do HistÃ³rico de Dispensa foram adicionados com sucesso a partir do ficheiro recebido.",
        fileTransferHistoryRecordsNotFullyProcessed:
            "ImpossÃ­vel processar o HistÃ³rico de Dispensa no ficheiro: '%{0}'. Consulte o ficheiro de Log para mais informaÃ§Ãµes.",
        fileTransferHistoryRecordsProcessed:
            "Os novos registos de HistÃ³rico de Dispensa (%{0} of the %{1}) foram adicionados com sucesso a partir do ficheiro recebido.",
        fileTransferInvalidFile: "ImpossÃ­vel processar dados em ficheiro, o ficheiro nÃ£o Ã© vÃ¡lido.",
        fileTransferOrderRecordsAdded:
            "Os novos registos de Pedidos foram adicionados com sucesso a partir do ficheiro recebido.",
        fileTransferOrderRecordsNotFullyProcessed:
            "ImpossÃ­vel processar os Pedidos no ficheiro: '%{0}'. Consulte o ficheiro de Log para mais informaÃ§Ãµes",
        fileTransferOrderRecordsProcessed:
            "Os novos registos de Pedidos (%{0} of the %{1}) foram adicionados com sucesso a partir do ficheiro recebido.",
        fileTransferUnknownVersion: "ImpossÃ­vel detectar a versÃ£o do ficheiro.",
        filetransferNoData: "Sem ligaÃ§Ã£o Ã  Base de Dados, verifique definiÃ§Ãµes",
        formulaDataUnavailable: "Dados da fÃ³rmula indisponÃ­veis.",
        helperDefaultMessage: "Ocorreu um erro inesperado durante a Ãºltima acÃ§Ã£o do Helper Server.",
        helperServerError: "Erro de Helper Server ",
        importAborted: "O processo de importaÃ§Ã£o foi abortado.",
        importSuccess: "Os dados foram importados com sucesso.",
        incompatibleBaseCan: "A Embalagem da Base nÃ£o Ã© compatÃ­vel com o produto especificado.",
        incorrectPassword: "A sua palavra-passe anterior nÃ£o estÃ¡ correta. Tente de novo.",
        invalidCurrency: "CÃ³digo da moeda invÃ¡lido. Euro (â¬) definido como moeda padrÃ£o.",
        invalidDatabaseName: "O nome da Base de Dados Ã© invÃ¡lido.",
        invalidEmail: "O seu e-mail Ã© invÃ¡lido.",
        invalidFormulaColorants: "ATENÃÃO !!! A FÃ³rmula pode conter Corantes invÃ¡lidos. Contacte o Suporte.",
        invalidLicenseCompanyUserKey: "Chave Empresa-Utilizador invÃ¡lida",
        invalidLicenseFile: "Ficheiro de licenÃ§a invÃ¡lido.",
        invalidLicenseIdentificationKeys: "As chaves de identificaÃ§Ã£o da sua licenÃ§a sÃ£o invÃ¡lidas.",
        invalidLicenseKey: "A sua licenÃ§a Ã© invÃ¡lida",
        invalidLicenseProduct: "O ficheiro da licenÃ§a nÃ£o corresponde ao produto.",
        invalidRccResponse: "Ocorreu um erro inesperado durante o processamento da Ãºltima resposta do RCC.",
        invalidServerResponse: "Ocorreu um erro inesperado durante o processamento da Ãºltima resposta do servidor.",
        invalidUrl: "O URL Ã© invÃ¡lido.",
        itemNotFound: "O item nÃ£o foi encontrado.",
        keyboardShortcutUsedInModal:
            "Este atalho de teclado nÃ£o pode ser usado na janela pop-up. Por favor, feche primeiro a janela pop-up.",
        keyboardShortcutValidation: "Um atalho de teclado nÃ£o pode ser definido para duas acÃ§Ãµes diferentes.",
        licenseHasBeenRevoked:
            "A sua licenÃ§a foi revogada. Para a renovar, por favor contacte o seu fornecedor de software.",
        licenseProlongationNeeded:
            "Ã necessÃ¡rio prolongar a licenÃ§a (ligue o PC Ã  Internet para obter uma nova licenÃ§a)",
        licenseUpToDate: "A sua licenÃ§a estÃ¡ em dia. NÃ£o Ã© necessÃ¡ria qualquer actualizaÃ§Ã£o.",
        licenseUpdateUnsuccessful: "ImpossÃ­vel actualizar a licenÃ§a.",
        licenseUpdated: "A licenÃ§a foi actualizada com sucesso.",
        licensedOnDifferentComputer: "Produto originalmente licenciado num computador diferente.",
        logFileArchiveDownloadComplete: "O descarregamento do arquivo de registos (log) foi concluÃ­do com Ãªxito.",
        loginError: "Ocorreu um erro inesperado ao iniciar sessÃ£o",
        logoutError: "Ocorreu um erro inesperado ao terminar sessÃ£o",
        machineIsConnecting: "A mÃ¡quina estÃ¡ a estabelecer ligaÃ§Ã£o, aguarde",
        machineIsNotConnected: "MÃ¡quina nÃ£o ligada ao RCC. Verifique a definiÃ§Ã£o do RCC.",
        malformedFormula: "FÃ³rmula invÃ¡lida",
        matching: {
            correctionNotPossible: "A CorrecÃ§Ã£o nÃ£o pode ser realizada. Use reformulaÃ§Ã£o.",
            forbidden: "O Pedido '%{0}' foi  negado",
            internalServerError: "Erro do servidor interno",
            invalidBase: "A Base Ã© invÃ¡lida para o Produto.",
            invalidBipp: "A Base Ã© invÃ¡lida para a embalagem de Produto.",
            invalidColorantId: "O Corante com o ID: %{0} Ã© InvÃ¡ido.",
            invalidColorantName: "O Corante com o nome: %{0} Ã© InvÃ¡lido.",
            invalidColorfile: "O Ficheiro de Cor com o ID: %{0} para o Produto com o ID: %{1} Ã© InvÃ¡lido.",
            invalidIlluminant: "Invalid illuminant: %{0}",
            invalidProduct: "O Produto com o ID: %{0} Ã© InvÃ¡lido.",
            invalidSpectralCurve: "Curva Espectral InvÃ¡lida.",
            noColorfiles: "Sem Ficheiros de Cor definidos para o Produto com o ID: %{0}.",
            notAuthorized: "O Pedido '%{0}'  nÃ£o foi autorizado",
            notFound: "O Pedido '%{0}'  nÃ£o foi encontrado",
            reformulationNotPossible: "A ReformulaÃ§Ã£o nÃ£o pode ser realizada",
            unknownError: "Erro desconhecido.",
            validationError: "O Pedido '%{0}' falhou devido a erros de validaÃ§Ã£o: %{0}."
        },
        maxFileSizeExceeded: "O tamanho mÃ¡ximo do ficheiro %{0} MB foi ultrapassado.",
        maxTabs: "A quantidade mÃ¡xima de separadores foi atingida, por favor feche um.",
        noTemplate: "A impressÃ£o nÃ£o pode ser realizada - nÃ£o existem modelos disponÃ­veis.",
        openNewTab: "Abra um novo separador de fÃ³rmula para carregar a fÃ³rmula usando o CÃ³digo de Barras.",
        orderAlreadyAcquired: "O pedido jÃ¡ foi adquirido e deve ser liberto primeiro.",
        orderCreated: "O pedido foi enviado com sucesso",
        passwordIsNotUnique: "A nova palavra-passe tem de diferir da antiga.",
        printCannotBeCarriedOut: "A impressÃ£o nÃ£o pode ser realizada  - o nome da impressora Ã© invÃ¡lido.",
        problemWithFileExport: "Ocorreu um erro ao guardar o ficheiro no disco.",
        productFileWarning: "O ficheiro do produto sÃ³ estÃ¡ disponÃ­vel online.",
        productNotLicensed: "O produto nÃ£o estÃ¡ licenciado.",
        rccDefaultMessage: "Ocorreu um erro inesperado durante a Ãºltima acÃ§Ã£o do RCC.",
        rccError: "Erro RCC",
        rccNeedRestart: "Reinicie o seu RCC",
        restoredSettings: "As definiÃ§Ãµes foram restauradas.",
        revokedLicense: "A licenÃ§a foi revogada.",
        runningOutOfSpace: "O computador estÃ¡ a ficar sem espaÃ§o livre em disco.",
        savedFormulaToHistory: "A FÃ³rmula foi gravada com sucesso no HistÃ³rico de Dispensas.",
        savedLogArchive: "O arquivo de Log foi gravado com sucesso na sua pasta.",
        scanning: "DigitalizaÃ§Ã£o em Curso â¦",
        serverError: "Erro de servidor",
        setClientIdentifier: "Defina primeiro o seu Identificador de Cliente",
        showLess: "Mostrar Menos",
        showMore: "Mostrar Mais",
        spectroIsDisconnecting: "O espectrofotÃ³metro estÃ¡ a desligar. Aguarde â¦",
        spectroIsNotConnected: "De momento, o  seu espectrofotÃ³metro NÃO ESTÃ LIGADO. Verifique a definiÃ§Ã£o do RCC.",
        spectroIsNotSelected: "De momento, o seu espectrofotÃ³metro NÃO ESTÃ SELECIONADO. Verifique a definiÃ§Ã£o do RCC.",
        tmcNotAvailable: "%{tmc} estÃ¡ indisponÃ­vel. Por favor verifique o seu %{collector}.",
        tmcNotConnected: "%{tmc} estÃ¡ desligado. Por favor inicie o seu %{collector} e reinicie o servidor.",
        unknownError: "Erro desconhecido: %{0}",
        userAlreadyLoggedIn: "JÃ¡ tem sessÃ£o iniciada!",
        versionNotAllowedByLicense: "A versÃ£o do Software Ã© mais recente ou nÃ£o Ã© permitida para a sua licenÃ§a.",
        webApiConnectionError: "Servidor Web API - NÃ£o foi possÃ­vel ligar",
        webApiInternalError: "Servidor Web API - Erro Interno",
        webApiInvalidUser: "Servidor Web API - Utilizador invÃ¡lido",
        webApiNoLicenseAvailable: "Servidor Web API - Sem licenÃ§as disponÃ­veis",
        wrongDataSaved: "Dados incorrectos gravados no ficheiro XML na pasta %{0}.",
        wrongHelpInput: "Formato Errado %{0}.",
        wrongRccVersion: "Verifique a versÃ£o do seu RCC. O seu cliente apenas Ã© compatÃ­vel com o RCC %{0}."
    },
    footer: {
        aboutApplication: "Acerca da AplicaÃ§Ã£o",
        activeUser: "Utilizador Ativo",
        logOut: "Sair",
        machineErrors: "Erros da mÃ¡quina"
    },
    formulaProperties: {
        exterior: "Exterior",
        interior: "Interior",
        invalid: "InvÃ¡lido",
        solvent: "Base de Solvente",
        universal: "Universal",
        water: "Base Aquosa"
    },
    formulaSettings: {
        allUnits: "Todas as unidades disponÃ­veis na Base de Dados",
        allowCustomFormulas: "Permitir FÃ³rmulas Personalizadas",
        allowCustomPackageSize: "Permitir Embalagens Personalizadas",
        allowFormulaAutomaticNaming: "Permitir a atribuiÃ§Ã£o automÃ¡tica de nomes",
        automaticNaming: "NomeaÃ§Ã£o automÃ¡tica de FÃ³rmula",
        basePanelSize: "Defina para a Base o Tamanho do Painel",
        bippPanelSize: "Defina para a Base o Tamanho do Painel do Produto e Embalagem",
        blendColorNameAndCode: "Nome da fÃ³rmula de mistura e cÃ³digo da cor",
        buttonBellowMoreInfo: "Mostra botÃ£o abaixo das Notas de FÃ³rmula",
        buttonInColorantPanel: "Mostra botÃ£o no Painel de Corantes",
        colorCodePrimary: " CÃ³digo de Cor como primÃ¡rio",
        colorPanel: "Paleta de cores",
        colorPreviewAsImage: "PrÃ©-visualizaÃ§Ã£o de cor como imagem",
        colorPreviewResizable: "PrÃ©-visualizaÃ§Ã£o de cor redimensionÃ¡vel",
        competitiveColorSearch: "Procura de Cores Competitivas",
        customFormula: "Custom formula",
        customFormulaForMasterProduct: "Allow create custom formulas for master product",
        customFormulaForMasterProductDefault: "Checked by default",
        customFormulas: "FÃ³rmulas Personalizadas",
        customPackageSettingsUnitGrav: "DefiniÃ§Ã£o de Embalagens Personalizadas - Unidade GravimÃ©trica",
        customPackageSettingsUnitVol: "DefiniÃ§Ã£o de Embalagens Personalizadas - Unidade VolumÃ©trica",
        customPackageSize: "DefiniÃ§Ã£o de Embalagens Personalizadas - Formatos",
        customUnits: "Escolha Unidades Personalizadas",
        dropDownCalculate: "Expandir o menu suspenso atÃ© Ã  altura da janela",
        editColorants: "Editar Corantes",
        editColorantsAllowed: "Permitir a EdiÃ§Ã£o de Corantes",
        fandeckPanelSize: "Tamanho do Painel de CatÃ¡logos",
        favoriteFormulas: "FÃ³rmulas Favoritas",
        formulaColorPreview: "PrÃ©-visualizaÃ§Ã£o da cor da FÃ³rmula",
        formulaDataSettings: "DefiniÃ§Ãµes de dados da FÃ³rmula",
        formulaPanel: "Painel de FÃ³rmula",
        formulaPanelSize: "Tamanho do Painel de FÃ³rmula definido",
        formulaSettings: "DefiniÃ§Ãµes de FÃ³rmula",
        generateColorPreview: "Gerar prÃ©-visualizaÃ§Ã£o de cor",
        gravimetricOnly: "Apenas Unidades GravimÃ©tricas",
        hideAlternativeFormulas: "ocultar FÃ³rmulas Alternativas",
        hideFormulaProperties: "Ocultar Propriedades da FÃ³rmula",
        hideHistoricalFormulas: "Ocultar HistÃ³rico de FÃ³rmulas",
        imagesLocal: "Utilizar apenas imagem de uma Base de Dados local",
        imagesOnline: "Primeiro, tente abrir a imagem online, se falhar, abra uma imagem local",
        infoPanelResizable: "'Ajuste do painel ''Mais InformaÃ§Ãµes'''",
        numberOfColorants: "NÃºmero de corantes visÃ­veis",
        orderByDistance: "Ordenar os resultados da procura por distÃ¢ncia",
        productDependent: "A unidade depende do produto seleccionado",
        productFilesDialog: "Mostrar diÃ¡logo para abrir ficheiro local ou ficheiro online",
        productFilesLocal: "Utilizar apenas ficheiros de produtos da Base de Dados local",
        productFilesOnline: "Primeiro, tente abrir o ficheiro de produto online, se falhar, abra um ficheiro local",
        productPanelSize: "Tamanho do Painel de Produtos",
        searchPanelQuickSelect: "SelecÃ§Ã£o rÃ¡pida",
        setAdditionalFormulaPanel: "Definir Painel de FÃ³rmula Adicional",
        setCompetitiveColorSearch: "Permitir procura de Cores Competitivas",
        setInitialFormulaPanel: "Definir Painel de FÃ³rmula Inicial",
        setMaxToleranceForCompetitiveColors: "DefiniÃ§Ã£o da tolerÃ¢ncia mÃ¡xima para a procura de Cores Competitivas",
        setNumberOfCompetitiveColors: "DefiniÃ§Ã£o do NÃºmero de Cores Competitivas",
        setSearchPanel: "Definir painel de procura",
        setVisibilityAndOrder: "Definir visibilidade e ordem dos dados das vÃ¡rias fÃ³rmulas",
        setVisibleUnit: "Definir unidades visÃ­veis",
        showColorPreview: "Mostrar prÃ©-visualizaÃ§Ã£o de cor",
        showInFormulaStatusPanel: "Mostrar no painel de estado da FÃ³rmula",
        showInMoreInfoPanel: "Mostrar nas Notas da FÃ³rmula",
        sorting: "OrdenaÃ§Ã£o dos PainÃ©is de Corantes",
        useBase: "Usar item seleccionado para a Base",
        useBaseInProductPackage: "Usar item seleccionado para a Base na embalagem do Produto",
        useColorCode: "Usar CÃ³digo de Cor",
        useColorName: "Usar Nome de Cor",
        useFandeckGroups: "Usar Grupos de CatÃ¡logos",
        useProduct: "Utilizar item de selecÃ§Ã£o para produto",
        useProductCode: "Usar CÃ³digo de Produto",
        useProductGroups: "Utilizar Grupos de Produtos",
        volumetricOnly: "Apenas Unidades VolumÃ©tricas"
    },
    general: {
        accepted: "Aceite",
        active: "Ãltima Actividade",
        actual: "Actual",
        actualLevel: "NÃ­vel Actual",
        add: "Adicionar",
        addColorant: "Adicionar corante",
        addColorantForPackage: "Adicionar corante Ã  embalagem",
        addFile: "Adicionar ficheiro",
        all: "Todos",
        amount: "Quantidade",
        applyNow: "Aplicar agora",
        attachments: "Anexos",
        automaticCorrection: "CorrecÃ§Ã£o AutomÃ¡tica",
        automatically: "Automaticamente",
        available: "DisponÃ­vel em",
        back: "Voltar",
        base: "Base",
        baseInProductPackage: "Base em produto e embalagem",
        batchNumber: "NÃºmero de lote",
        bottom: "Em Baixo",
        buildingSite: "Site de Trabalho",
        calculate: "Calcular",
        can: "Embalagem",
        canSize: "Formato",
        cancel: "Cancelar",
        canister: "DepÃ³sito",
        canisterId: "ID do DepÃ³sito",
        canisterIndex: "Ãndice do DepÃ³sito",
        canisters: "DepÃ³sito",
        cap: "Tampa (Auto-Cap)",
        capacity: "Capacidade",
        channels: "Canal",
        choose: "Escolha",
        city: "Cidade",
        clean: "Limpar",
        clear: "Limpar",
        client: "Cliente",
        close: "Fechar",
        closeAll: "Fechar tudo",
        collapseAll: "Recolher tudo",
        color: "Cor",
        colorCode: "CÃ³digo de cor",
        colorFile: "Ficheiro de Cor",
        colorName: "Nome da Cor",
        colorPreview: "PrÃ©-visualizaÃ§Ã£o da cor",
        colorant: "Corante",
        colorantBatchNumber: "NÃºmero de Lote do Corante",
        colorantPackage: "Embalagem do Corante",
        colorants: "Corantes",
        colors: "Cores",
        company: "Empresa",
        competitiveColor: "Cor Competitiva",
        confirm: "Confirmar",
        confirmDeletion: "Apagar este item permanentemente ?",
        confirmHelpSettings: "Confirme - Guardar o FormulÃ¡rio e deixar os campos vazios ?",
        connect: "Ligar",
        continue: "Continuar",
        correction: "CorrecÃ§Ã£o",
        country: "PaÃ­s",
        created: "Criado em",
        creationDateOf: "Data de criaÃ§Ã£o de",
        criticalLevel: "NÃ­vel crÃ­tico",
        currency: "Moeda",
        currentBatchNumber: "NÃºmero de Lote actual",
        currentUfiCode: "CÃ³digo UFI actual",
        custom: "Receitas prÃ³prias",
        customData: "Dados Personalizados",
        customFandeck: "CatÃ¡logos Personalizados",
        customFormula: "FÃ³rmula Personalizada",
        customPackage: "Personalizado",
        customPackageSettings: "DefiniÃ§Ãµes de Embalagem Personalizadas",
        customer: "Cliente",
        customerVersion: "VersÃ£o do Cliente",
        customers: "Clientes",
        database: "Base de Dados",
        date: "Data",
        default: "PadrÃ£o",
        delete: "Eliminar",
        deleteImportedData: "Eliminar registos importados",
        delta: "Delta",
        description: "DescriÃ§Ã£o",
        disconnect: "Desligar",
        discount: "Desconto",
        discover: "Descubra",
        dispense: "Dispensar",
        dispensing: "Dispensando â¦",
        doNotShowAgain: "NÃ£o mostrar esta mensagem de novo",
        downloadingFile: "Descarregar ficheiros",
        edit: "Editar",
        email: "Email",
        enabled: "Activado",
        error: "Erro",
        expandAll: "Expandir tudo",
        exportData: "Dados de exportaÃ§Ã£o",
        exportPdf: "Exportar PDF",
        fan: "CatÃ¡logo",
        fandeck: "CatÃ¡logo de Cores",
        fandeckCode: "CÃ³digo do CatÃ¡logo",
        fandeckName: "Nome do CatÃ¡logo de Cores",
        fandecks: "CatÃ¡logos de Cores",
        favorite: "Favorito",
        fileTransfer: "TransferÃªncia de ficheiros",
        filling: "Enchimento",
        fillingDate: "Data de Enchimento",
        find: "Procurar",
        finish: "Terminar",
        finishedCorrection: "CorrecÃ§Ã£o concluÃ­da",
        formula: "FÃ³rmula",
        formulas: "FÃ³rmulas",
        frontdesk: "RecepÃ§Ã£o",
        getQrCode: "Obter o cÃ³digo QR",
        gravimetric: "GravimÃ©trico",
        historical: "HistÃ³rica",
        history: "HistÃ³rico",
        hours: "Horas",
        id: "ID",
        images: "Imagens",
        in: "em",
        index: "Ãndice",
        insertBarcode: "Introduza o cÃ³digo de barras",
        install: "Instalar",
        installed: "Instalado",
        instructions: "InstruÃ§Ãµes",
        internalNote: "Nota Interna",
        interval: "Intervalo",
        ip: "EndereÃ§o IP",
        itemNumber: "Item nÂº.",
        itemXOfY: "Item %{x}/%{y}",
        itemsCount: "NÃºmero de Items",
        later: "Mais tarde",
        limit: "Limite",
        load: "Carga",
        loadFormula: "Carregar receita",
        localVersion: "VersÃ£o local",
        machine: "MÃ¡quina",
        manualCorrection: "CorrecÃ§Ã£o Manual",
        manually: "Manualmente",
        margin: "Margem",
        markup: "MajoraÃ§Ã£o",
        matching: "FormulaÃ§Ã£o",
        matchingFormula: "FÃ³rmula correspondente",
        maxLevel: "NÃ­vel mÃ¡ximo",
        maxValue: "Valor mÃ¡ximo",
        maximum: "MÃ¡ximo",
        mayTakeAWhile: "PoderÃ¡ demorar",
        measured: "Medido",
        metamarism: "Metamerismo",
        minimum: "MÃ­nimo",
        minutes: "Min.",
        missingItem: "Item em falta",
        missingRequiredItems: "Todos os items marcados com asterisco terÃ£o de ser preenchidos",
        modified: "Modificado",
        modifiedAutomaticCorrection: "Target color correction",
        modifiedCustomFormula: "FÃ³rmula Personalizada Modificada",
        modifiedStandardFormula: "FÃ³rmula Standard Modificada",
        moduleChange: "Alterar MÃ³dulo",
        more: "Mais",
        moreInfo: "Mais informaÃ§Ã£o",
        moveDown: "Descer",
        moveUp: "Subir",
        myOrders: "Os meus pedidos",
        name: "Nome",
        nameTitle: "Nome",
        new: "Novo",
        next: "Seguinte",
        no: "NÃ£o",
        noColorantsAvailable: "NÃ£o existem Corantes disponÃ­veis",
        noFormulas: "Ainda sem fÃ³rmulas",
        noPricesAvailable: "NÃ£o existem PreÃ§os disponÃ­veis",
        nominalAmount: "Montante Nominal",
        notAvailable: "NÃ£o DisponÃ­vel",
        note: "Nota",
        numberOfCanisters: "NÃºmero de DepÃ³sitos",
        numberOfItemCount: "Number of '%{item}': %{count}",
        numberOfLabels: "NÃºmero de Etiquetas",
        numberOfPackages: "NÃºmero de embalagens",
        off: "Desligado",
        ok: "OK",
        on: "Ligado",
        onFocus: "Em foco",
        open: "Abrir",
        operator: "Operador",
        options: "OpÃ§Ãµes",
        order: "Order",
        other: "Outros",
        otherError: "Outro erro",
        out: "Fora",
        overwrite: "Overwrite",
        package: "Embalagem",
        packagePreview: "PrÃ©-visualizaÃ§Ã£o da embalagem",
        partialUpdates: "ActualizaÃ§Ãµes Parciais",
        phone: "Telefone",
        pleaseWait: "Aguarde â¦",
        previous: "Anterior",
        price: "PreÃ§o",
        priceGroup: "Grupo de PreÃ§o",
        print: "Imprimir",
        printTask: "Tarefa de impressÃ£o",
        processingStep: "Processing %{step}",
        product: "Produto",
        productCode: "CÃ³digo do Produto",
        productName: "Nome do Produto",
        products: "Produtos",
        pump1: "Bomba 1",
        pump2: "Bomba 2",
        purchasePrice: "PreÃ§o de Compra",
        purge: "Purgar",
        qualityControl: "Controlo de Qualidade",
        quantity: "Quantidade",
        quantityQty: "Qtd",
        quickTint: "Dosagem manual",
        rccIsNotAvailable: "O RCC nÃ£o estÃ¡ disponÃ­vel",
        rccIsNotConnected: "O RCC nÃ£o estÃ¡ ligado",
        rccNotLicensed: "O RCC nÃ£o estÃ¡ licenciado",
        reconnect: "Voltar a ligar",
        refill: "Recarga",
        refillManualLevelCorrection: "CorrecÃ§Ã£o manual",
        reformulation: "ReformulaÃ§Ã£o",
        reloadTab: "Reload Tab",
        reset: "ReinicializaÃ§Ã£o",
        restart: "Reiniciar",
        restore: "Restaurar",
        retint: "Tintar de Novo",
        revision: "RevisÃ£o",
        safetySheet: "Ficha de SeguranÃ§a",
        save: "Guardar",
        saveAs: "Guardar como",
        saveToDispensingHistory: "Guardar no HistÃ³rico",
        searchResult: "Resultado da Procura",
        searching: "Procurando â¦",
        seconds: "Sec.",
        select: "Select",
        selectAll: "Seleccionar todos",
        selectChannels: "Selecionar depÃ³sito",
        selectColumns: "Select columns to work with",
        selectXFirst: "Seleccione %{item} primeiro",
        sellPrice: "PreÃ§o de Venda",
        settings: "DefiniÃ§Ãµes",
        shelf: "Prateleira",
        showItem: "Show %{item}",
        showOptions: "Show another options",
        size: "Tamanho",
        skip: "Ignorar",
        smartPurge: "Purga Inteligente",
        softwareRestartInSeconds: "%{software} will be automatically restarted in %{seconds} seconds",
        sortResults: "Resultados Ordenados",
        spectro: "Espectro",
        standardFormula: "FÃ³rmula Standard",
        status: "Estado",
        street: "Rua",
        sum: "Soma",
        summary: "Resumo",
        sync: "Sincronizar",
        technicalSheet: "Ficha TÃ©cnica",
        templates: "Modelos",
        threshold: "Limiar",
        ticketing: "Mensagens-Pedidos",
        tintometricSystem: "Sistema TintomÃ©trico",
        toDispenseOrders: "Os meus pedidos soam",
        top: "Em Cima",
        total: "Total",
        totalAmount: "Quantidade Total",
        totalBaseAmount: "Quantidade Total de Base",
        totalColorantAmount: "Quantidade Total de Corantes",
        type: "Tipo",
        ufiCode: "CÃ³digo UFI",
        ufiThreshold: "Limiar UFI",
        unableToSynchronize: "Unable to synchronize",
        undefined: "Indefinido",
        unit: "Unidade",
        units: "Unidades",
        unknown: "Unknown",
        update: "ActualizaÃ§Ã£o",
        updated: "Actualizado",
        user: "Utilizador",
        value: "Valor",
        vat: "IVA",
        verified: "Veriicado",
        version: "VersÃ£o",
        versionId: "ID da VersÃ£o",
        versionStructure: "Estrutura da versÃ£o",
        volumetric: "VolumÃ©trico",
        warning: "Aviso",
        warningLevel: "NÃ­vel de Aviso",
        withoutName: "(sem nome)",
        workingProperly: "Working properly",
        yes: "Sim",
        zoom: "Zoom"
    },
    help: {
        autotasks: {
            brushMaintenance:
                "Calendarize esta auto-tarefa %{name} para o lembrar da limpeza do depÃ³sito da escova. O Operador terÃ¡ de remover, limpar e reinstalar a escova manualmente.",
            capMaintenance:
                "Calendarize esta auto-tarefa %{name} para o lembrar da limpeza do autocap. O Operador terÃ¡ de limpar o autocap manualmente depois de ele abrir.",
            cleanAll: "Calendarize esta auto-tarefa para o Dispensador realizar a limpeza do bicos.",
            cleanChannels: "Calendarize esta auto-tarefa para o Dispensador realizar a limpeza de bicos especÃ­ficos.",
            computerReboot: "Calendarize esta auto-tarefa para reiniciar o computador.",
            computerShutdown: "Calendarize esta auto-tarefa para desligar o computador.",
            dispenserCleaning:
                "Calendarize esta auto-tarefa %{name} para o lembrar de realizar a limpeza do Dispensador. O Operador deverÃ¡ limpar o Dispensador com um pano manualmente.",
            humidifierWaterLevelMaintenance:
                "Calendarize esta auto-tarefa %{name} para o lembrar de encher o humificador. O Operador deve verificar o nÃ­vel da Ã¡gua e se necessÃ¡rio atestar.",
            purgeAll: "Calendarize esta auto-tarefa para o Dispensador purgar automaticamente todos os bicos.",
            purgeChannels:
                "Calendarize esta auto-tarefa %{name} para o Dispensador purgar automaticamente bicos especÃ­ficos.",
            recirculateAll: "Calendarize esta auto-tarefa %{name} para o Dispensador recircular todos os depÃ³sitos.",
            recirculateChannels:
                "Calendarize esta auto-tarefa %{name} para o Dispensador recircular depÃ³sitos especÃ­ficos.",
            refillAll: "Calendarize esta auto-tarefa %{name} para o lembrar de recarregar todos os depÃ³sitos.",
            refillCanisters:
                "Calendarize esta auto-tarefa %{name} para o lembrar de recarregar depÃ³sitos especÃ­ficos. O Operador terÃ¡ de realizar o reabastecimento manualmente nos depÃ³sitos que nÃ£o cumpram o critÃ©rio de reabastecimento.",
            smartPurgeAll:
                "Calendarize esta auto-tarefa %{name} para o Dispensador realizar a purga inteligente de todos os bicos. A purga ocorrerÃ¡ exceto se as regras da purga automÃ¡tica tinham sido cumpridas.",
            smartPurgeChannels:
                "Calendarize esta auto-tarefa %{name} para o Dispensador realizar a purga inteligente de bicos especÃ­ficos. A purga ocorrerÃ¡ exceto se as regras da purga automÃ¡tica tinham sido cumpridas.",
            stirAll: "Calendarize esta auto-tarefa para o Dispensador realizar a agitaÃ§Ã£o de todos os depÃ³sitos.",
            stirCanisters:
                "Calendarize esta auto-tarefa %{name} para o Dispensador realizar a agitaÃ§Ã£o de depÃ³sitos especÃ­ficos.",
            switchPlateMaintenance:
                "Calendarize esta auto-tarefa %{name} para o lembrar de limpar o prato de comutaÃ§Ã£o. O Operador terÃ¡ que remover , limpar e recolocar o prato manualmente."
        },
        colorantBatchNumber: {
            batchNumberByPercentage:
                "O nÃºmero de Lote que prevalece Ã© utilizado para impressÃ£o considerando a sua quantidade real na lata. Navegue atÃ© Ã s definiÃ§Ãµes da lata para definir o limite para cada lata.",
            batchNumberFromLastFilling:
                "O Lote do Ãºltimo reabastecimento dado pelo Operador serÃ¡ usado para impressÃ£o, independentemente da quantidade reabastecida",
            enableBatchNumber: "Com esta definiÃ§Ã£o ligada, o reabastecimento dos Lotes de Corante sÃ£o rastreados."
        },
        connection: {
            add: "Permite adicionar um novo servidor manualmente se nÃ£o puder ser detectado atravÃ©s da funÃ§Ã£o Descobrir.",
            clientIdentifier:
                "A definiÃ§Ã£o permite identificar este cliente se houver mais clientes ligados a um servidor.",
            disconnect:
                "InformaÃ§Ã£o sobre o servidor actualmente utilizado. O botÃ£o de desligar permite deixar este servidor e mudar para outro, se disponÃ­vel.",
            discover: "Descobre se existem outros servidores disponÃ­veis na rede.",
            dropServers: "Elimina da lista todos os servidores previamente detectados.",
            dropServersNotAvailable: "Nenhum servidor disponÃ­vel",
            edit: "Permite editar manualmente um servidor jÃ¡ encontrado.",
            editDisabled: "Nenhum Servidor seleccionado."
        },
        continue: "AvanÃ§ar ?",
        driverSettings: {
            alfaRestApi: {
                host: "Digite o nome do computador ou o endereÃ§o IP.",
                machineType: "VÃ¡lido para todas as mÃ¡quinas Alfa. Windows, bem como Linux."
            },
            corobDsProxy: {
                machineType:
                    "VÃ¡lido para as geraÃ§Ãµes Slave (D200, D600..), 4G (First One) and 5G (EvoFlx). O DspProxy deve ser instalado. SÃ³ para Windows."
            },
            corobEvoDriver: {
                machineType: "VÃ¡lido para a geraÃ§Ã£o 5G (EvoFlx). O EVOservice deve ser instalado.  Windows ou Linux."
            },
            corobFlex500LLD: {
                dispenserConfigurationFile:
                    "Selecione o ficheiro de confguraÃ§Ã£o do Dispensador. PredefiniÃ§Ã£o seleccionada.",
                hldRootDir: "Seleccione a pasta principal do HLD. PredefiniÃ§Ã£o seleccionada.",
                machineType:
                    "VÃ¡lido para Corob Flex (500, 520, 540) = antiga Lenteq. HLD terÃ¡ de ser instalado. Apenas para Windows."
            },
            corobNextDriver: {
                machineType:
                    "VÃ¡lido para as geraÃ§Ãµes Slave (D200, D600...), 4G (First One) e 5G (EvoFlx). NextDriver deve ser instalado e licenciado. Apenas para Linux."
            },
            dromontDDrv: {
                databasePath:
                    "Caminho para o ficheiro da Base de Dados com dados de calibraÃ§Ã£o. PredefiniÃ§Ã£o seleccionada.",
                driverPath: "'Caminho para o ''driver'' (D_DRV.exe). PredefiniÃ§Ã£o seleccionada.'",
                machineType:
                    "ComunicaÃ§Ã£o indirecta do dispensador atravÃ©s de caminhos definidos. VÃ¡lido para as geraÃ§Ãµes V1 e V2. D_SET deve ser instalado. Windows, bem como Linux.",
                resultPath:
                    "O caminho para o ficheiro de resultados criado apÃ³s a operaÃ§Ã£o terminou. PredefiniÃ§Ã£o seleccionada.",
                serviceSoftwarePath:
                    "Caminho para o software de serviÃ§o Dromont (D_SET.exe). PredefiniÃ§Ã£o seleccionada."
            },
            dromontDirect: {
                machineType:
                    "ComunicaÃ§Ã£o directa do dispensador. VÃ¡lido para as geraÃ§Ãµes V1 e V2. D_SET deve ser instalado. Windows, bem como Linux.",
                rootDir: "Seleccionar a pasta principal do Dromont. PredefiniÃ§Ã£o seleccionada."
            },
            dromontMisura: {
                driverPath:
                    "'O caminho para o ''driver'' (MisuraRetail.exe) pode mudar com base na versÃ£o Misura Retail. PredefiniÃ§Ã£o seleccionada.'",
                extensionPath: "Caminho para o ficheiro de comunicaÃ§Ã£o para acÃ§Ãµes de serviÃ§o.",
                formulaPath: "Caminho para o ficheiro de comunicaÃ§Ã£o para dispensa.",
                machineType: "VÃ¡lido para a geraÃ§Ã£o V3. Dromont Misura deve ser instalado. Apenas Windows."
            },
            fastAndFluidIDD: {
                machineType: "VÃ¡lido para todas as mÃ¡quinas F&F. Apenas para Windows.",
                path: "SÃ£o suportados IDD2 (HA 450, HA 650, X-smart, etc.) - devem ser licenciados, IDD3 (HP 500, etc.), IDD4 (HA 180, HA 480, HA 680, Xprotint, etc.)"
            },
            fastAndFluidUIDD: {
                host: "Type in the computer host name or computer IP address.",
                machineType: "VÃ¡lido para todas as mÃ¡quinas F&F. Windows, bem como Linux.",
                password: "Type in the user password.",
                port: "Select the port number.",
                user: "Type in the user name."
            },
            heroPCPDriver: {
                machineType: "VÃ¡lido para todas as mÃ¡quinas Hero. Apenas Windows."
            },
            italtinto: {
                machineType:
                    "VÃ¡lido para todas as mÃ¡quinas Italtinto. Wcal ou ItaltintoCal deve ser instalado. Apenas Windows.",
                path: "Caminho para o ficheiro de definiÃ§Ã£o Italtinto ajustado."
            },
            manualAdvanced: {
                machineType:
                    "VÃ¡lido para todas as mÃ¡quinas manuais, incluindo o suporte de depÃ³sitos. Windows bem como Linux.",
                path: "Caminho para o ficheiro de definiÃ§Ã£o com dados sobre o dispensador e depÃ³sitos."
            },
            manualSimple: {
                machineType: "VÃ¡lido para todas as mÃ¡quinas manuais. Windows, bem como Linux.",
                path: "Caminho para o ficheiro de definiÃ§Ã£o com dados sobre o dispensador."
            },
            none: {
                machineType: "'Sem ''driver'' de dispensador seleccionado.'"
            },
            santintColorLink3: {
                machineType: "VÃ¡lido para todas as mÃ¡quinas Santint. Apenas Windows."
            },
            simulation: {
                machineType:
                    "VÃ¡lido para dispensador de simulaÃ§Ã£o se nÃ£o existir um dispensador real ligado ao computador.",
                path: "Caminho para o ficheiro de definiÃ§Ã£o da simulaÃ§Ã£o, que deve estar de acordo com a Base de Dados inserida."
            },
            udcp: {
                machineType: "Dispensador UDCP"
            }
        },
        environment: {
            activeServerPlugins: "VisÃ£o geral de plugins adicionais de software.",
            allowAutoCloseTab:
                "Com esta definiÃ§Ã£o activada, cada separador de fÃ³rmula serÃ¡ fechado automaticamente apÃ³s o processo de dispensa ter sido concluÃ­do.",
            allowAutomaticClientStart:
                "Com esta definiÃ§Ã£o activada, %{name} iniciarÃ¡ automaticamente apÃ³s o arranque do computador.",
            allowAutomaticPrint:
                "A etiqueta serÃ¡ impressa automaticamente. Requer  definiÃ§Ãµes adicionais de impressÃ£o antes da dispensa, apÃ³s a dispensa ou ambas.",
            allowBuildingSitePanel: "No painel de FÃ³rmula, a construÃ§Ã£o do painel do site ficarÃ¡ acessÃ­vel.",
            allowCustomers: "No painel de FÃ³rmula, a secÃ§Ã£o de Clientes estarÃ¡ acessÃ­vel.",
            allowDispensing:
                'No Painel de FÃ³rmula, o botÃ£o "Dispensar" serÃ¡ activado juntamente com as opÃ§Ãµes "Dispensar" em "DefiniÃ§Ãµes da MÃ¡quina".',
            allowFileTransfer:
                "Com esta definiÃ§Ã£o activada, a importaÃ§Ã£o e exportaÃ§Ã£o automÃ¡tica de dados por transferÃªncia de ficheiros fica disponÃ­vel.",
            allowFormulaModificationPanel: "No painel de FÃ³rmula, a ModificaÃ§Ã£o do painel ficarÃ¡ activada",
            allowFormulaStatusPanel: "No Painel de FÃ³rmula, o Painel de Estado serÃ¡ activado.",
            allowLight: "%{name} serÃ¡ acessÃ­vel.",
            allowOrdering: 'No painel da FÃ³rmula, o botÃ£o "Pedido" serÃ¡ activado.',
            allowPricing:
                'No painel da FÃ³rmula, os preÃ§os podem ser utilizados. A visibilidade dos preÃ§os Ã© definida em "PreÃ§os DisponÃ­veis". Os preÃ§os sÃ£o definidos em "DefiniÃ§Ãµes de PreÃ§os".',
            allowProductPreviewImage: "A imagem do produto serÃ¡ mostrada durante a dispensa.",
            allowQualityControl: "O Controlo de Qualidade serÃ¡ activado",
            allowSearchCheaperColors:
                "No Painel de FÃ³rmula, a funÃ§Ã£o de procura de Cores EconÃ³micas estarÃ¡ disponÃ­vel.",
            allowSoundNotification:
                "A notificaÃ§Ã£o sonora do Pedido toca uma melodia musical quando um pedido Ã© recebido.",
            allowSpectro: 'A secÃ§Ã£o "EspectrofotÃ³metro" serÃ¡ acessÃ­vel.',
            allowTabs: "Com esta definiÃ§Ã£o activada,  pode trabalhar com separadores mÃºltiplos em simultÃ¢neo.",
            applyZoom:
                "O zoom aumenta ou reduz a resoluÃ§Ã£o. Os atalhos de teclado CTRL + e CTRL - tambÃ©m sÃ£o aplicÃ¡veis.",
            automaticLogout: "Define apÃ³s quantos minutos o logout automÃ¡tico deve ser activado.",
            availableDatabases:
                "As definiÃ§Ãµes permitem alternar entre Bases de Dados se houver mais do que uma disponÃ­vel.",
            backupLocalDB:
                "Exporta a Base de Dados local. O ficheiro exportado pode ser usado como backup da Base de Dados",
            barcodeTesting:
                "O ambiente de teste do cÃ³digo de barras serve para verificar a correcÃ§Ã£o do cÃ³digo de barras digitalizado, comparando-o com os cÃ³digos de barras inseridos na Base de Dados.",
            customBanner: "Coloque o seu prÃ³prio logÃ³tipo ou faixa e a sua posiÃ§Ã£o.",
            customCurrencyFormat:
                "O formato de moeda personalizado pode substituir o formato de moeda predefinido com base no idioma seleccionado.",
            customDateFormat:
                "O formato de data personalizado pode substituir o formato de data padrÃ£o com base no idioma seleccionado.",
            customNumberFormat:
                "O formato numÃ©rico personalizado pode substituir o formato numÃ©rico padrÃ£o com base no idioma seleccionado.",
            customTimeFormat:
                "O formato de tempo personalizado pode substituir o formato de tempo padrÃ£o com base no idioma seleccionado.",
            defaultPrinter:
                "A impressora seleccionada serÃ¡ utilizada para imprimir etiquetas, a menos que seja alterada na janela de opÃ§Ãµes da impressora.",
            defaultTemplate:
                "O modelo seleccionado serÃ¡ utilizado na impressÃ£o de etiquetas, a menos que seja alterado na janela de opÃ§Ãµes de ImpressÃ£o.",
            deleteImportedData:
                "Apaga os dados personalizados previamente importados. Os dados podem ser novamente importados apÃ³s o apagamento.",
            diskSpaceNotification: "Verifica o espaÃ§o disponÃ­vel em disco e notifica em caso de espaÃ§o insuficiente.",
            dispensingNotes: "No painel de FÃ³rmula, a secÃ§Ã£o de notas de distribuiÃ§Ã£o estarÃ¡ acessÃ­vel.",
            downloadListEmpty: "Sem descargas em curso.",
            enableVirtualKeyboard: "Em %{name}, o teclado virtual estarÃ¡ disponÃ­vel.",
            exportLocalSettings:
                "Exporta as definiÃ§Ãµes locais deste computador. O ficheiro pode ser importado para outro computador para aplicar definiÃ§Ãµes locais idÃªnticas.",
            exportStaticSql:
                "Exporta as definiÃ§Ãµes locais deste computador. O ficheiro exportado pode ser utilizado para criar uma Base de Dados com esta definiÃ§Ã£o.",
            exportTranslationKeys:
                "Exporte as traduÃ§Ãµes mais recentes e depois de traduzidas, envie-as por correio electrÃ³nico ao seu fornecedor de software para que sejam importadas.",
            favoriteButton: "Clique para adicionar a fÃ³rmula como favorita",
            formulaNotes: "No painel de FÃ³rmula, a secÃ§Ã£o de notas de fÃ³rmula estarÃ¡ acessÃ­vel.",
            helpSettings: "A informaÃ§Ã£o Ã© visÃ­vel na secÃ§Ã£o de Ajuda no painel de acesso rÃ¡pido.",
            importCustomData: "Importa os dados personalizados locais com base no formato seleccionado.",
            importExcelFile: "Importe o ficheiro excel com os dados a inserir na base de dados.",
            importsLocalSettings: "Importa as definiÃ§Ãµes locais exportadas de outro computador.",
            internalNote: "No painel de FÃ³rmula, a secÃ§Ã£o de notas internas serÃ¡ acessÃ­vel.",
            lockComputer:
                "As definiÃ§Ãµes asseguram que o ambiente de %{name} nÃ£o pode ser deixado - a Ãºltima experiÃªncia do modo kiosk serÃ¡ activada. Apenas aplicÃ¡vel para Windows.",
            maxNumberTabs:
                "O limite de tabulaÃ§Ã£o define quantas tabulaÃ§Ãµes de fÃ³rmula podem estar abertas simultÃ¢neamente.",
            memoryTabs: "Permitir a reabertura de separadores recentemente abertos apÃ³s o inÃ­cio do software.",
            printAfterDispensing:
                "A definiÃ§Ã£o requer informaÃ§Ã£o sobre quantas cÃ³pias de etiquetas devem ser impressas apÃ³s o processo de dispensa.",
            printAsImage:
                "Imprimir como imagem ajuda a resolver os problemas quando a forma de impressÃ£o padrÃ£o falha. NÃ£o a utilize quando a impressÃ£o padrÃ£o funciona correctamente. CompatÃ­vel apenas com Linux.",
            printBeforeDispensing:
                "A definiÃ§Ã£o requer informaÃ§Ã£o sobre quantas cÃ³pias de etiquetas devem ser impressas antes do processo de dispensa.",
            printEnabled:
                'Esta definiÃ§Ã£o permite utilizar a impressora com o software. As definiÃ§Ãµes adicionais estÃ£o em "DefiniÃ§Ãµes de ImpressÃ£o".',
            printOnRequest: "No painel FÃ³rmula, o botÃ£o Imprimir serÃ¡ activado.",
            printTaskVariable:
                "A tarefa de impressÃ£o sÃ³ Ã© processada se uma dada variÃ¡vel de impressÃ£o estiver disponÃ­vel nos dados de impressÃ£o",
            quickTintTemplate: "'O modelo seleccionado serÃ¡ utilizado na impressÃ£o ''rÃ¡pida'' de etiquetas.'",
            restoreLocalSettings:
                "Restaura as definiÃ§Ãµes locais deste computador. ApÃ³s apagar todas as definiÃ§Ãµes, pode ser criada uma nova definiÃ§Ã£o.",
            runLightAtStartUp: "%{light} serÃ¡ iniciada em vez de %{name}.",
            screenSaverTimeout: "Define ao fim de quantos minutos, o protector de ecrÃ£ deve ser activado.",
            selectCustomDataFormat:
                "Seleccionar o formato dos dados originais a importar. Cada formato pode requerer ficheiros e definiÃ§Ãµes adicionais diferentes.",
            setCustomHomeButton: 'O botÃ£o "Home" em %{name} serÃ¡ redireccionado para o painel seleccionado.',
            setFts: "A procura de texto completo permite a procura de fÃ³rmula de texto completo (tambÃ©m a partir do meio da palavra, etc.).",
            setKeyboardShortcuts: "NÃ£o Ã© possÃ­vel definir o mesmo atalho de teclado para duas acÃ§Ãµes diferentes.",
            setNumberOfDecimalPlaces:
                "O arredondamento define quantas casas decimais dos corantes usados na fÃ³rmula serÃ£o apresentadas.",
            setOrderSearchParameters:
                "A procura de pedidos define que parÃ¢metros sÃ£o utilizados na procura entre pedidos. Apenas acessÃ­vel em %{name}.",
            setOverwriteLastTab:
                "Ao escolher uma nova fÃ³rmula atravÃ©s de procura global enquanto o limite de tabulaÃ§Ã£o da fÃ³rmula Ã© atingido, a Ãºltima tabulaÃ§Ã£o de fÃ³rmula carregada serÃ¡ sobre-escrita pela nova selecÃ§Ã£o de fÃ³rmula.",
            setSearchPanel:
                "Defina a sua prÃ³pria visibilidade e ordem dos items utilizados na procura de uma nova fÃ³rmula.",
            setVisibilityAndOrder:
                "Os itens de navegaÃ§Ã£o seleccionados serÃ£o visÃ­veis no painel de acesso rÃ¡pido. A posiÃ§Ã£o mais alta aqui define a posiÃ§Ã£o mais Ã  esquerda no painel. A quantidade mÃ¡xima permitida de itens de navegaÃ§Ã£o Ã© de 6.",
            setYourLanguage: "A mudanÃ§a de idioma requer o reinÃ­cio do software.",
            settingsSearch: "Procure em vÃ¡rias definiÃ§Ãµes se nÃ£o estiver certo de onde os encontrar.",
            showNewOrderNotifications:
                "A notificaÃ§Ã£o de pedido Ã© uma janela pop-up anunciando que um novo pedido foi recebido.",
            sorting:
                "Quick Tint pode ser pedida de acordo com os nomes dos corantes ou atravÃ©s de identificadores de depÃ³sitos.",
            turnOnKioskMode: "O modo Kiosk activo oculta a barra de tarefas.",
            windowClosingRules:
                "Define se a janela de Quick Tint (Dispensa Manual) Ã© fechada antes ou depois do inÃ­cio do processo de dispensa."
        },
        formulaSettings: {
            additionalFormulaTab:
                "Esta definiÃ§Ã£o define que painel serÃ¡ mostrado ao abrir um novo separador de fÃ³rmula.",
            allowCustomFormulas: "A criaÃ§Ã£o e procura de fÃ³rmulas personalizadas serÃ¡ activada.",
            allowCustomPackageSize:
                "No painel de FÃ³rmula, a opÃ§Ã£o de formato da embalagem personalizada serÃ¡ activada.",
            allowEditingColorants:
                "No painel de FÃ³rmula, o botÃ£o Editar corante serÃ¡ activado (visÃ­vel apÃ³s seleccionar uma cor).",
            alternativeFormulasPosition: "Define como acessar fÃ³rmulas alternativas.",
            basePanelSize: "Defina formato da Base no painel de FÃ³rmula",
            bippPanelSize: "Defina formato da Base na embalagem do produto no painel de FÃ³rmula",
            blendColorNameAndCode:
                'Esta definiÃ§Ã£o junta os campos de procura por Nome e CÃ³digo da Cor para criar um Ãºnico campo de procura."',
            color: "No painel de FÃ³rmula, a prÃ©-visualizaÃ§Ã£o da cor serÃ¡ a Ãºnica informaÃ§Ã£o visÃ­vel.",
            colorCodePrimary: "O cÃ³digo da cor serÃ¡ apresentado primeiramente no campo de pesquisa.",
            colorPreviewAsImage: "No painel de FÃ³rmula, a prÃ©-visualizaÃ§Ã£o da cor serÃ¡ representada por uma imagem.",
            colorPreviewResizable: "Permite redimensionar o painel de prÃ©-visualizaÃ§Ã£o das cores.",
            colorantPanelLimit:
                "As definiÃ§Ãµes determinam o nÃºmero de corantes que ficarÃ£o sempre visÃ­veis antes de os ocultar na barra de deslocaÃ§Ã£o.",
            colorantPanelOrderBy:
                "O painel de fÃ³rmula pode ter os corantes ordenados de acordo com os nomes ou por quantidades.",
            customCanOption:
                "Escolhe que unidades de mediÃ§Ã£o podem ser usadas para o formato da embalagem personalizada no painel da FÃ³rmula.",
            customCanSettingsUnit:
                "Escolhe qual a unidade de medida padrÃ£o para definiÃ§Ãµes de embalagens personalizadas no painel de FÃ³rmula.",
            customFormulaForMasterProduct:
                "Defines whether the option âFormula for master productâ is displayed when saving custom formula",
            customFormulaForMasterProductDefault:
                "Defines whether the option âFormula for master productâ is checked by default",
            deleteConfirmation:
                "A activaÃ§Ã£o desta definiÃ§Ã£o resultarÃ¡ na apresentaÃ§Ã£o de pop-ups para confirmar a eliminaÃ§Ã£o de um item.",
            dropDownCalculate:
                "O menu drop-down para seleccionar a fÃ³rmula que procura irÃ¡ estender-se atÃ© ao fundo da janela.",
            fandeckGroups: "Este definiÃ§Ã£o activa a hierarquia com Grupos de CatÃ¡logos se disponÃ­vel na Base de Dados.",
            fandeckPanelSize: "Tamanho do catÃ¡logo no painel da FÃ³rmula",
            favoriteFormulasInitial: "Ao iniciar %{name}, o painel de Favoritos aparecerÃ¡.",
            formulaAutomaticNaming:
                "Uma fÃ³rmula alterada serÃ¡ nomeada automaticamente com base nas modificaÃ§Ãµes de corantes realizadas.",
            formulaPanel: "Ao abrir um novo separador, aparecerÃ¡ o painel de FÃ³rmula.",
            formulaPanelInitial: "Ao iniciar %{name}, o painel de FÃ³rmula aparecerÃ¡.",
            formulaPanelSize: "Tamanho da fÃ³rmula definido no painel da FÃ³rmula",
            formulaPropertiesPosition: "Define como acessar as propriedades da fÃ³rmula.",
            generateColorPreview:
                "Com esta definiÃ§Ã£o ligada, a prÃ©-visualizaÃ§Ã£o da cor serÃ¡ gerada automaticamente. A prÃ©-visualizaÃ§Ã£o resultante nÃ£o Ã© exacta.",
            historicalFormulasPosition: "Define com acessar o histÃ³rico de fÃ³rmulas.",
            image: "No painel de FÃ³rmula, a imagem do produto serÃ¡ visÃ­vel ao lado da prÃ©-visualizaÃ§Ã£o da cor com a possibilidade de abrir o painel com mais informaÃ§Ãµes.",
            images: "Esta opÃ§Ã£o permite definir a fonte dos ficheiros de imagem.",
            infoPanelResizable: "Esta opÃ§Ã£o permite redimensionar o painel informativo.",
            initialFormulaTab: "Esta opÃ§Ã£o permite definir que painel serÃ¡ mostrado apÃ³s o %{0} starts.",
            moreInfo:
                "No painel de FÃ³rmula, o painel de informaÃ§Ã£o serÃ¡ visÃ­vel ao lado da prÃ©-visualizaÃ§Ã£o da cor e da imagem do produto.",
            orderByDistance:
                "Com esta definiÃ§Ã£o activa, o resultado da procura por cor Ã© ordenada por distÃ¢ncia mÃ©trica especial.",
            productCode:
                "Esta opÃ§Ã£o permite a utilizaÃ§Ã£o cÃ³digos de produtos juntamente com nomes de produtos, se disponÃ­veis na Base de Dados.",
            productFiles:
                "Esta opÃ§Ã£o permite definir a fonte dos ficheiros de produtos que estÃ£o disponÃ­veis no painel da FÃ³rmula.",
            productGroups:
                "Esta opÃ§Ã£o permite definir permite a hierarquia com grupos de produtos, se disponÃ­veis na Base de Dados.",
            productPanelSize: "Formato do produto definido no painel de FÃ³rmula",
            searchNewFormula:
                "Ao abrir um novo separador, aparecerÃ¡ procurar nova fÃ³rmula (contÃ©m informaÃ§Ã£o sobre as Ãºltimas fÃ³rmulas dispensadas e as fÃ³rmulas favoritas).",
            searchNewFormulaInitial:
                "Ao iniciar %{name}, surgirÃ¡ a procura de nova fÃ³rmula (contÃ©m informaÃ§Ã£o sobre as Ãºltimas fÃ³rmulas dispensadas e as fÃ³rmulas favoritas).",
            searchPanelFormulaItems: "Pelo menos um dos itens da fÃ³rmula deve ser seleccionado.",
            searchPanelProductItems: "Apenas um dos items de produto pode ser seleccionado.",
            searchPanelQuickSelect:
                "NÃ£o Ã© necessÃ¡rio premir o botÃ£o carregar fÃ³rmula. SerÃ¡ redireccionado directamente para o separador principal da FÃ³rmula logo apÃ³s ter seleccionado a fÃ³rmula.",
            setCompetitiveColorSearch:
                'Com esta definiÃ§Ã£o activa, a procura competitiva de cores na "Paleta de Cores" e no "Painel de FÃ³rmula" ficarÃ¡ disponÃ­vel (apenas para fÃ³rmulas nÃ£o disponÃ­veis).',
            setFormulaInfoInPreview:
                "No painel de FÃ³rmula, o tipo de dados seleccionados serÃ¡ sempre visÃ­vel na prÃ©-visualizaÃ§Ã£o de cores.",
            setFormulaPreview:
                "A definiÃ§Ã£o muda a posiÃ§Ã£o e a exibiÃ§Ã£o da prÃ©-visualizaÃ§Ã£o da cor, imagem da embalagem e dados informativos sobre a cor.",
            setFormulaRGBPreviewVisibleInformation:
                "No painel FÃ³rmula, o tipo de dados seleccionados serÃ¡ sempre visÃ­vel na prÃ©-visualizaÃ§Ã£o de cores.",
            setFormulaUnit:
                "No painel de FÃ³rmula, esta opÃ§Ã£o define qual a unidade de corante que Ã© aberta como primeira apÃ³s a selecÃ§Ã£o de uma cor. TambÃ©m aplicÃ¡vel no Quick Tint (Dispensa Manual).",
            setFormulaVisibilityAndOrder:
                "No painel FÃ³rmula, os dados seleccionados serÃ£o visÃ­veis na secÃ§Ã£o Mais informaÃ§Ãµes (apenas aplicÃ¡vel se a prÃ©-visualizaÃ§Ã£o da fÃ³rmula definida na definiÃ§Ã£o da FÃ³rmula for Imagem ou Mais informaÃ§Ãµes)",
            setMaxToleranceForCompetitiveColors:
                "Definir a tolerÃ¢ncia mÃ¡xima Delta E (CIE 2000) para a procura de cor competitiva.",
            setNumberOfCompetitiveColors: "Definir quantas cores competitivas devem ser oferecidas apÃ³s a procura.",
            setVisibleUnit:
                "No painel de FÃ³rmula, esta opÃ§Ã£o define quais as unidades de corante que sÃ£o apresentadas depois de seleccionar uma cor. TambÃ©m aplicÃ¡vel no Quick Tint (Dispensa Manual).",
            showColorPreview:
                "No painel da FÃ³rmula, ao procurar por uma nova fÃ³rmula, mostra  uma pequena prÃ©-visualizaÃ§Ã£o da cor ao lado do nome da cor. ",
            showSiblingProducts:
                "Defines whether the option âShow sibling productsâ is displayed when saving custom formula",
            useColorCode: "No Painel de FÃ³rmula, mostra a informaÃ§Ã£o acerca do CÃ³digo de Cor."
        },
        formulaValidation: {
            batchNumberInvalid: "O depÃ³sito (%{colorants}) contÃ©m um lote estragado de corante.",
            batchNumberWarning: "Corante (%{colorants}) com este nÃºmero de lote pode estar estragado.",
            bellowBaseLimit: "A soma das quantidades de corantes estÃ¡ abaixo do limite base.",
            checkColorantBaseRules: "Esta definiÃ§Ã£o verifica se o corantes e a base podem ser usados nesta combinaÃ§Ã£o.",
            checkMinDosableAmount:
                "A quantidade mÃ­nima de tintÃ¡vel Ã© a menor quantidade de corante que pode ser dispensada como recomendado pelo laboratÃ³rio.",
            checkOverfill:
                "Esta definiÃ§Ã£o verifica se existe espaÃ§o suficiente na lata para os corantes imediatamente apÃ³s as quantidades serem definidas.",
            checkTotalCntAmounts:
                "Esta definiÃ§Ã£o verifica se os limites para as quantidades mÃ­nimas e mÃ¡ximas de corantes na embalagem base do produto foram excedidos. Estes limites sÃ£o definidos na Base de Dados.",
            colorantBaseRules: "O Corante nÃ£o Ã© vÃ¡lido para a Base seleccionada.",
            colorantMinAmount: "A quantidade de corante Ã© inferior Ã  quantidade mÃ­nima tintÃ¡vel.",
            dispensingWithErrorsEnabled:
                "Se permitido, aparecerÃ¡ uma mensagem de aviso em caso de violaÃ§Ãµes de validaÃ§Ã£o, nÃ£o obstante serÃ¡ possÃ­vel avanÃ§ar com a dispensa.",
            invalidBatchNumber: "O Corante tem um nÃºmero de lote invÃ¡lido ou o lote nÃ£o estÃ¡ em condiÃ§Ãµes.",
            overBaseLimit: "A soma das quantidades de corantes Ã© superior Ã  quantidade mÃ¡xima tintÃ¡vel.",
            overfill: "Foi detectado excesso de enchimento.",
            unifyColorantBatchForMultipleCans:
                "Se permitido, uma informaÃ§Ã£o para encher ao MÃ¡ximo aparecerÃ¡ quando a quantidade de corante Ã© maior do que a capacidade mÃ¡xima do depÃ³sito e o depÃ³sito nÃ£o estÃ¡ cheio ao mÃ¡ximo.",
            warningConfirmBtn: "Eu aceito os riscos ... avance!"
        },
        help: "Ajuda",
        helpLink: "Centro de Ajuda",
        helper: {
            automaticallyCheckForUpdates:
                "SerÃ¡ automaticamente verificado se hÃ¡ alguma actualizaÃ§Ã£o disponÃ­vel para %{name} ou Base de Dados no intervalo de tempo dado.",
            automaticallyDownloadUpdates:
                "Se estiver disponÃ­vel uma actualizaÃ§Ã£o, esta serÃ¡ descarregada automaticamente sem ter de confirmar.",
            automaticallyInstallNewDatabases:
                "Se uma BD atÃ© agora ausente for enviada, serÃ¡ instalada como uma novo BD. Posteriormente, a BD poderÃ¡ ser utilizada.",
            automaticallyInstallUpdates:
                "Se tiver sido descarregada uma actualizaÃ§Ã£o, esta serÃ¡ instalada automaticamente sem ter de confirmar.",
            canBrowseChangeLog: "Ao actualizar o software, o %{name} changelog oficial estarÃ¡ disponÃ­vel para consulta",
            forceInstall: "A instalaÃ§Ã£o da actualizaÃ§Ã£o serÃ¡ forÃ§ada.",
            installDuringNight: "A actualizaÃ§Ã£o serÃ¡ instalada durante a noite, se o computador estiver disponÃ­vel."
        },
        licensing: {
            collect:
                "Os ficheiros de registo serÃ£o descarregados para a localizaÃ§Ã£o seleccionada. Os ficheiros de Log sÃ£o requeridos pelo Fornecedor so Software para anÃ¡lise de bugs.",
            company: "A empresa que forneceu a licenÃ§a.",
            computerID:
                "IdentificaÃ§Ã£o da licenÃ§a para ajudar o Fornecedor do Software em caso de assistÃªncia necessÃ¡ria.",
            email: "O endereÃ§o de correio electrÃ³nico do titular da licenÃ§a.",
            licenseUuid:
                "IdentificaÃ§Ã£o da licenÃ§a para ajudar o Fornecedor do Software em caso de assistÃªncia necessÃ¡ria.",
            name: "O nome do titular da licenÃ§a.",
            openBugreport:
                "Por favor informe-nos se existe um bug no software e envie-nos um relatÃ³rio com a descriÃ§Ã£o do bug.",
            posInfoContactperson: "InformaÃ§Ã£o do POS sobre o proprietÃ¡rio a ser impressa na etiqueta.",
            posInfoMachineInformation:
                "InformaÃ§Ã£o do POS sobre o dispensador a ser impresso na etiqueta ou reconhecido na rede.",
            posInfoPos: "InformaÃ§Ã£o do POS sobre o local a ser impresso na etiqueta.",
            reactivation: "ReativaÃ§Ã£o ou alteraÃ§Ã£o da licenÃ§a atual.",
            refresh: "Descarrega a mais recente informaÃ§Ã£o sobre licenÃ§as.",
            refreshUnavailable: "ActualizaÃ§Ã£o da licenÃ§a nÃ£o disponÃ­vel porque estÃ¡ offline.",
            registrationContactperson: "InformaÃ§Ãµes de registo para identificar o proprietÃ¡rio da licenÃ§a.",
            registrationMachineInformation: "InformaÃ§Ãµes de registo para identificar o dispensador da licenÃ§a.",
            registrationPos: "InformaÃ§Ã£o de registo para identificar a localizaÃ§Ã£o da licenÃ§a.",
            versionScope: "Limites de expiraÃ§Ã£o do software.",
            versionType: "O tipo de produto de software."
        },
        machineIsBusy: "Os erros nÃ£o podem ser reiniciados uma vez que a mÃ¡quina estÃ¡ ocupada.",
        machineSettings: {
            allowManualColorantAddition:
                "Se a quantidade de corante requerida exceder a quantidade mÃ¡xima de dispensa, esta definiÃ§Ã£o permite adicionÃ¡-la manualmente apÃ³s a dispensa.",
            autotasks:
                "As tarefas automÃ¡ticas sÃ£o eventos de manutenÃ§Ã£o automÃ¡tica de mÃ¡quinas e computadores que podem ser definidos para serem executados em determinado momento ou intervalo de tempo.",
            barcodeRefillValidation: "Esta definiÃ§Ã£o activa a validaÃ§Ã£o do cÃ³digo de barras no reabastecimento.",
            barcodeRefillValidationBaseAndColorant:
                "A verificaÃ§Ã£o do cÃ³digo de barras Ã© efectuada no enchimento do depÃ³sito e na embalagem de corante.",
            barcodeRefillValidationColorant:
                "A verificaÃ§Ã£o do cÃ³digo de barras Ã© efectuada no reenchimento da embalagem de corante.",
            canisterBarcode:
                "O cÃ³digo de barras Ã© atribuÃ­do ao depÃ³sito em que o corante estÃ¡ disponÃ­vel. O cÃ³digo de barras Ã© necessÃ¡rio para assegurar o correcto reabastecimento do corante.",
            checkCanBeforeDispense: "Esta definiÃ§Ã£o sÃ³ Ã© vÃ¡lida para a simulaÃ§Ã£o Fast & Fluid.",
            checkOverfill:
                "Esta definiÃ§Ã£o verifica se hÃ¡ lugar suficiente na lata para os corantes antes de os dispensar.",
            currentlySelectedMachine: "Fornece informaÃ§Ã£o sobre a mÃ¡quina actualmente seleccionada.",
            dispenseInvalidColorants:
                "'Esta definiÃ§Ã£o permite dispensar manualmente corantes que nÃ£o estÃ£o definidos na parametrizaÃ§Ã£o da ''mesa'' da mÃ¡quina.'",
            dispenserConfigurationBackup:
                "Descarregar e guardar as definiÃ§Ãµes actuais da mÃ¡quina para manter uma cÃ³pia de seguranÃ§a.",
            dispensingLogic:
                "Os tipos de lÃ³gica de dispensa podem assegurar a definiÃ§Ã£o de um comportamento diferente para cada depÃ³sito quando hÃ¡ mais corante a ser dispensado do que o permitido ou desejado.",
            enableTmc: "Esta definiÃ§Ã£o permite o envio de dados para o TMC.",
            enableUserIdentification: "O utilizador tem de iniciar sessÃ£o para que a dispensa seja permitida.",
            machineUnit: "A unidade da mÃ¡quina define a unidade de medida dos corantes nos depÃ³sitos.",
            minDispensedAmount:
                "A quantidade mÃ­nima dispensada define a quantidade de corante que tem de ser dispensada para considerar a purga realizada  de modo a evitar uma purga adicional.",
            minimalDispenseAmount:
                "A quantidade mÃ­nima de dispensa Ã© a menor quantidade de corante que pode ser dispensada conforme recomendaÃ§Ã£o do fabricante do dispensador. Se for violada, aparecerÃ¡ uma mensagem de aviso, contudo a dispensa ainda Ã© possÃ­vel de realizar.",
            missingAutotaskCanisters: "Deve haver pelo menos um depÃ³sito seleccionado.",
            missingAutotaskChannels: "Deve ser seleccionado pelo menos um depÃ³sito.",
            missingAutotaskChannelsValue: "O volume de todos os depÃ³sitos seleccionados deve ser preenchido",
            missingAutotaskCleanTime: "O tempo de limpeza deve ser preenchido",
            missingAutotaskName: "O nome da auto-tarefa deve ser preenchido",
            missingAutotaskRecirculation: "O tempo e a velocidade da recirculaÃ§Ã£o devem ser preenchidos",
            missingAutotaskStirring: "O tempo e a velocidade de agitaÃ§Ã£o devem ser preenchidos",
            missingAutotaskVolume: "O volume da purga deve ser preenchido",
            placeCanSensor:
                "Esta definiÃ§Ã£o activa o sensor para a colocaÃ§Ã£o da lata - a dispensa nÃ£o comeÃ§arÃ¡ a menos que a lata tenha sido colocada correctamente.",
            placeCanSensorDelay:
                "Define o tempo recomendado no sensor para a detecÃ§Ã£o e colocaÃ§Ã£o da lata.. Garante que a dispensa sÃ³ comeÃ§a apÃ³s o perÃ­odo de tempo definido durante o qual a lata foi colocada correctamente.",
            purgeVolume:
                "O volume de purga define a quantidade de corante que serÃ¡ purgada ao efectuar uma purga inteligente.",
            rccUrl: "O Redlike Control Center (RCC) Ã© responsÃ¡vel pela comunicaÃ§Ã£o com o dispensador.",
            refillThreshold:
                "Se a quantidade de corante no depÃ³sito com o CÃ³digo UFI ou NÃºmero de Lote fornecidos ficar abaixo deste limite, quer o CÃ³digo UFI quer o NÃºmero de Lote serÃ£o descartado.",
            refillThresholdBatch:
                "Se a quantidade de corante no depÃ³sito com o NÃºmero de Lote fornecido ficar abaixo deste limite, o NÃºmero de Lote serÃ¡ descartado.",
            refillThresholdUfi:
                "Se a quantidade de corante no depÃ³sito com o CÃ³digo UFI fornecido ficar abaixo deste limite, o CÃ³digo UFI serÃ¡ descartado.",
            removeCanSensor:
                "Esta definiÃ§Ã£o activa o sensor para remoÃ§Ã£o da lata - a distribuiÃ§Ã£o nÃ£o Ã© considerada feita a menos que a lata tenha sido removida.",
            removeCanSensorDelay:
                "A definiÃ§Ã£o recomendada ligada Ã  remoÃ§Ã£o da lata, assegura que a distribuiÃ§Ã£o sÃ³ Ã© concluÃ­da apÃ³s expiraÃ§Ã£o do intervalo de tempo definido para remoÃ§Ã£o da lata.",
            skipPlaceCanDialog:
                "Com esta definiÃ§Ã£o ligada, o dispensador nÃ£o esperarÃ¡ pela colocaÃ§Ã£o de uma lata atÃ© o botÃ£o OK ser premido. A dispensa serÃ¡ iniciada automaticamente.",
            skipRemoveCanDialog:
                "Com esta definiÃ§Ã£o ligada, o dispensador nÃ£o esperarÃ¡ pela remoÃ§Ã£o da lata atÃ© que o botÃ£o OK seja premido. O processo de dispensa serÃ¡ considerado terminado automaticamente.",
            smartPurgeType:
                "O tipo de purga pode considerar apenas a dispensa ou a dispensa mais outros eventos de purga,  ao validar a necessidade de uma purga inteligente.",
            splitFormula:
                "Se a quantidade de corante necessÃ¡ria exceder a quantidade mÃ¡xima de distribuiÃ§Ã£o, o ajuste permite dispensar uma parte do corante, recarregar o depÃ³sito e dispensar a quantidade restante em falta.",
            tintometricSystem:
                "Sistema TintomÃ©trico (conjunto de Corantes disponÃ­veis) define que Corantes e FÃ³rmulas estarÃ£o disponÃ­veis na aplicaÃ§Ã£o e nas suas definiÃ§Ãµes.",
            validateBarcodeBaseCan:
                "A base tem de ser validada atravÃ©s de cÃ³digo de barras antes de ser permitida a distribuiÃ§Ã£o. A definiÃ§Ã£o assegura que a base correcta Ã© utilizada.",
            validateColorantsDuringInit:
                "A definiÃ§Ã£o da mÃ¡quina serÃ¡ comparada com a Base de Dados cada vez que o RCC for reiniciado. Em caso de desajustes, ocorrerÃ¡ uma notificaÃ§Ã£o."
        },
        matchingSettings: {
            matchingInformation: "On matching result panel, %{item} will be available.",
            matchingOptionsColorants: "On matching options panel, colorants panel will be available.",
            matchingOptionsColorfile: "On matching options panel, colorfile selectbox will be available.",
            matchingOptionsSortResults: "On matching options panel, sort results selectbox will be available.",
            matchingRowCount: "Define quantos resultados deverÃ£o ser apresentados apÃ³s a operaÃ§Ã£o de formulaÃ§Ã£o."
        },
        navigation: {
            barcodeScan: "Abre uma janela com a possibilidade de introduzir manualmente o cÃ³digo de barras.",
            canisterBarcodes:
                "Abre uma janela com vista geral do cÃ³digo de barras do depÃ³sito e a possibilidade de definir o cÃ³digo de barras do depÃ³sito.",
            canisterLevel:
                "Abre uma janela mostrando os nÃ­veis dos DepÃ³sitos de Corante com a possibilidade de definir o nÃ­vel de corante para cada um deles.",
            canisters:
                "Abre um painel mostrando os DepÃ³sitos de Corante com a possibilidade de definir o nÃ­vel de corante para cada um deles.",
            clean: "Abre uma janela com a possibilidade de realizar a recarga dos depÃ³sitos.",
            colorPanel: "Abre um painel com a possibilidade de procurar uma nova fÃ³rmula num catÃ¡logo electrÃ³nico.",
            colorSearchTab: "Abre um painel com a possibilidade de procurar todas as cores em todos os catÃ¡logos.",
            colorantRefillHistory:
                "Abre uma janela com a vista geral dos reabastecimentos de corante realizados nos depÃ³sitos.",
            customFormula: "Abre um painel com a possibilidade de criar uma nova FÃ³rmula Personalizada.",
            customers:
                "Abre um painel com a visÃ£o geral dos Clientes e a possibilidade de acrescentar, editar ou apagar.",
            dispensingHistory: "Abre um painel com a visÃ£o geral das dispensas realizadas.",
            favorites: "Abre um painel com a possibilidade de seleccionar uma fÃ³rmula favorita.",
            help: "Abre uma janela com informaÃ§Ãµes de ServiÃ§o ao Cliente, se fornecidas pelo Fornecedor.",
            hideItems: "Abre uma janela com a possibilidade de marcar produtos e catÃ¡logos como ocultos.",
            historyOfOrders:
                "VÃ¡lido exclusivamente para %{name}, abre um painel com a visÃ£o geral dos pedidos dispensadas.",
            machineReset: "Inicia a reinicializaÃ§Ã£o do dispensador.",
            matching: "Abre um painel com a possibilidade de formular uma nova com com um espectrofotÃ³metro.",
            myOrders: "Abre um painel com a sÃ­ntese dos pedidos enviados.",
            purge: "Abre uma janela com a possibilidade de definir a purga do depÃ³sito.",
            quickTint: "Abre uma janela com a possibilidade de efectuar a dispensa manual.",
            searchFormula: "Abre um painel com a possibilidade de procurar uma nova fÃ³rmula.",
            spectro: "Abre um painel com a possibilidade de medir com um espectrÃ³fotometro.",
            stir: "Abre uma janela com a possibilidade de definir a agitaÃ§Ã£o do depÃ³sito.",
            ticketing: "Abre o painel do sistema de Mensagens - Pedidos.",
            toDispense: "Abre um painel com a sÃ­ntese dos pedidos recebidos."
        },
        noHelpForLicense: "NÃ£o hÃ¡ ajuda disponÃ­vel para a sua LicenÃ§a. PeÃ§a ao seu Fornecedor que a acrescente.",
        posInfo: {
            sync: "Sincroniza os dados com a secÃ§Ã£o Registo"
        },
        poweredByDeso: "Operado por %{name}",
        priceSettings: {
            VatPrice: "Valor do IVA do Corante em %.",
            VatPriceProduct: "O valor do IVA do produto serÃ¡ o mesmo para cada corante. Definido em %.",
            basePurchase: "PreÃ§o de Compra para base calculada por litro (base exclusivamente).",
            basePurchasePriceProduct:
                "PreÃ§o de Compra para a embalagem da base seleccionada. Definido na moeda seleccionada.",
            baseSell: "O PreÃ§o de Venda apenas para a base (apenas base e margem de lucro/majoraÃ§Ã£o/desconto).",
            baseSellFull: "PreÃ§o de Venda total para a base.",
            cntName: "Define a que corante o preÃ§o estÃ¡ relacionado.",
            cntPurchase: "PreÃ§o de Compra de corantes (corantes exclusivamente).",
            cntPurchaseByName:
                "PreÃ§o de Compra de corantes calculado individualmente para cada um (corantes exclusivamente).",
            cntPurchasePricePerLiter:
                "O PreÃ§o de Compra do corante por litro (corante exclusivamente). Definido na moeda seleccionada.",
            cntSell: "O PreÃ§o de Venda apenas para corantes (inclui margem de corantes/marcas/Desconto).",
            cntSellByName:
                "O PreÃ§o de Venda de todos os corantes utilizados no produto calculado individualmente para cada um (apenas corantes e margem/desconto).",
            cntSellFull: "PreÃ§o de Compra de corantes (corantes exclusivamente) sem desconto.",
            cntSellFullByName:
                "PreÃ§o de Compra de corantes calculado individualmente para cada um (corantes exclusivamente) sem desconto.",
            cntSellPricePerLiter:
                "O PreÃ§o de Venda do corante por litro (corante exclusivamente). Definido na moeda seleccionada.",
            cntVat: "Valor do IVA do colorante fixado em %.",
            colorants:
                "Os preÃ§os genÃ©ricos dos corantes serÃ£o os mesmos para cada corante. Recomenda-se que o PreÃ§o de Compra seja modificado por margem de lucro. Definido na moeda seleccionada.",
            colorantsPosCoeficient: "O Coeficiente genÃ©rico do Corante para o POS.",
            colorantsSellPrice:
                "Os preÃ§os genÃ©ricos dos corantes serÃ£o os mesmos para cada corante. Recomenda-se que o PreÃ§o de Venda seja modificado pelo desconto. Definido na moeda seleccionada.",
            currencyCodeNew: "O cÃ³digo da moeda tem de estar na forma oficial de trÃªs letras, por exemplo EUR.",
            currencyNameNew: "O nome da moeda, por exemplo, Euro.",
            currencyRateNew:
                "A taxa de cÃ¢mbio para a moeda principal, por exemplo 25,855 CZK por 1 EUR. A taxa tem de ser editada continuamente para ser mantida actualizada.",
            currencyRoundingNew:
                "O arredondamento estabelece o menor valor possÃ­vel a pagar da moeda, por exemplo, o Euro tem um arredondamento de 0,01 porque o menor valor possÃ­vel Ã© de 1 cÃªntimo.",
            currencySymbolNew: "O sÃ­mbolo oficial da moeda, por exemplo, o Euro.",
            defaultPrice: "PreÃ§o do corante definido na Base de Dados seleccionada (sem IVA).",
            defaultPriceGroup: "PreÃ§o de corante para grupo de preÃ§os fixado na Base de Dados seleccionada (sem IVA).",
            defaultVatPrice: "IVA do Corante definido na Base de Dados seleccionada.",
            discountHeader:
                "Valor do desconto que serÃ¡ subtraÃ­do ao valor do PreÃ§o de Compra do corante. Definido em %.",
            discountHeaderProduct:
                "Desconto de substratos o valor definido a partir do preÃ§o do colorante do produto. Definido em %.",
            export: "Exportar um ficheiro com os preÃ§os actualmente inseridos. Pode ser importado novamente apÃ³s ter modificado os preÃ§os.",
            import: "Importar um ficheiro correctamente formatado (exportado) para inserir ou modificar os preÃ§os.",
            localPrices:
                "Os preÃ§os sugeridos sÃ£o dados pelo administrador da Base de Dados. Se activados, estes preÃ§os podem ser editados localmente neste computador.",
            margin: "Escolha qual o cÃ¡lculo do preÃ§o que deve ser utilizado para a definiÃ§Ã£o do preÃ§o final disponÃ­vel. A margem e a majoraÃ§Ã£o somam-se, enquanto o desconto Ã© subtraÃ­do ao PreÃ§o de Venda indicado.",
            marginAll: "O preÃ§o da margem/majoraÃ§Ã£o para pacotes mÃºltiplos (inclui margem/majoraÃ§Ã£o).",
            marginHeader: "A margem adiciona o valor definido atÃ© ao PreÃ§o de Compra do corante. Definido em %.",
            marginHeaderProduct: "A margem adiciona o valor definido atÃ© ao PreÃ§o de Compra do produto. Definida em %.",
            marginPerPkg: "O preÃ§o da margem/majoraÃ§Ã£o para uma embalagem (inclui margem/majoraÃ§Ã£o).",
            markupHeader: "A majoraÃ§Ã£o adiciona o valor definido atÃ© ao preÃ§o do corante de compra. Definido em %.",
            markupHeaderProduct:
                "A majoraÃ§Ã£o adiciona o valor definido atÃ© ao preÃ§o do produto de compra. Definido em %.",
            packagePricing: "Sobretaxa adicional definida individualmente para cada formato de embalagem.",
            packageSurcharge:
                "Os preÃ§os das embalagens genÃ©ricos serÃ£o os mesmos para cada sobretaxa de embalagem. Definidos na moeda seleccionada.",
            priceDefinition: "A definiÃ§Ã£o define que tipos de preÃ§os sÃ£o utilizados no cÃ¡lculo dos preÃ§os finais.",
            priceGroupNumber:
                "A definiÃ§Ã£o define quantos Grupos de PreÃ§o serÃ£o utilizados. O intervalo para Grupos de PreÃ§o individuais pode ser definido em Valores PadrÃ£o.",
            priceGroupPricePerLiter:
                "O preÃ§o do colorante utilizado quando Ã© calculado o preÃ§o usando grupo de preÃ§os.",
            priceGroups:
                "Os Grupos de PreÃ§o mostram o nÃºmero do grupo de preÃ§os relevante (os limites sÃ£o estabelecidos na Base de Dados ou em Valores PadrÃ£o).",
            priceGroupsEnabled:
                "A definiÃ§Ã£o permite trabalhar com Grupos de PreÃ§o. Definir o intervalo em Valores por Defeito e preÃ§os individuais em PreÃ§os de Corantes.",
            priceGroupsGeneric:
                "Os Grupos de PreÃ§o sÃ£o intervalos de preÃ§os para o  preÃ§o final do produto com base nos preÃ§os dos corantes em fÃ³rmula.",
            productBasePackageSellPrice:
                "PreÃ§o de Venda para a embalagem de base seleccionada. Definido na moeda seleccionada.",
            productBaseSellPrice:
                "PreÃ§o de Venda para base calculada por litro (base exclusivamente). Definido na moeda seleccionada.",
            productBaseVat: "Valor base do IVA para a embalagem de produto seleccionada, fixado em %.",
            productName: "Define a que base do produto o preÃ§o estÃ¡ relacionado.",
            productPosCoeficient: "O Coeficiente genÃ©rico do Produto para o POS.",
            productPricing:
                "O PreÃ§o de Compra para todas as embalagens Ã© utilizado quando se dispensam embalagens personalizados.",
            productSize: "Define a que embalagem da base do produto seleccionado o preÃ§o estÃ¡ relacionado.",
            productVat: "Valor de base do IVA para o produto, fixado em %.",
            products:
                "Os preÃ§os dos produtos genÃ©ricos serÃ£o os mesmos para cada produto. Recomenda-se que o PreÃ§o de Compra seja modificado por margem ou por majoraÃ§Ã£o. Definido na moeda seleccionada.",
            productsSellPrice:
                "Os preÃ§os dos produtos genÃ©ricos serÃ£o os mesmos para cada produto. Recomenda-se que o PreÃ§o de Venda seja modificado com desconto. Definido na moeda seleccionada.",
            sellPriceAll:
                "O PreÃ§o de Venda de embalagens mÃºltiplas (incluindo base, corantes, margem de sobretaxa/majoraÃ§Ã£o/desconto).",
            sellPricePerKg:
                "O PreÃ§o de Venda do produto por quilograma (inclui base, corantes, margem de sobretaxa/majoraÃ§Ã£o/desconto).",
            sellPricePerL:
                "O PreÃ§o de Venda do produto por litro (incluindo base, corantes, margem de sobretaxa/marcas/desconto).",
            sellPricePerPkg:
                "O PreÃ§o de Venda de uma embalagem (inclui base, corantes, margem de sobretaxa/majoraÃ§Ã£o/desconto).",
            setPriceTypesVisibilityAndOrder:
                "No painel de FÃ³rmula, os preÃ§os seleccionados serÃ£o visÃ­veis na secÃ§Ã£o de preÃ§os. A posiÃ§Ã£o mais alta aqui define a posiÃ§Ã£o mais Ã  esquerda na secÃ§Ã£o.",
            surchargeAll: "O preÃ§o de uma taxa adicional para embalagens mÃºltiplas (inclui sobretaxa).",
            surchargePerPkg: "O preÃ§o de uma taxa adicional por embalagem (inclui sobretaxa).",
            tintPurchaseAll:
                "O PreÃ§o de Compra para todo o processo de tintagem de embalagens mÃºltiplas (inclui corantes e sobretaxa).",
            tintPurchasePerPkg:
                "O PreÃ§o de Compra para todo o processo de tintagem de uma embalagem (inclui corantes e sobretaxa).",
            tintSellFullAll:
                "O PreÃ§o de Compra para todo o processo de tintagem de uma embalagem (incluindo corantes e sobretaxa) sem desconto.",
            tintlSellFullAllPerPackage:
                "O PreÃ§o de Compra para todo o processo de tintagem de embalagens mÃºltiplas (incluindo corantes e sobretaxa) sem desconto.",
            totalPurchaseAll: "O preÃ§o total de compra do produto para embalagens mÃºltiplas (inclui base e corantes).",
            totalPurchasePerKg: "O preÃ§o total de compra do produto por quilograma (inclui base e corantes).",
            totalPurchasePerL: "O preÃ§o total de compra do produto por litro (inclui base e corantes).",
            totalPurchasePerPkg: "O preÃ§o total de compra do produto por embalagem (inclui base e corantes).",
            totalSellFullAll:
                "O preÃ§o total de compra do produto para embalagens mÃºltiplas (inclui base e corantes) sem desconto.",
            totalSellFullPerKg:
                "O preÃ§o total de compra do produto por quilograma (inclui base e corantes) sem desconto.",
            totalSellFullPerLiter:
                "O preÃ§o total de compra do produto por litro (inclui base e corantes) sem desconto.",
            totalSellFullPerPackage:
                "O preÃ§o total de compra do produto por embalagem (inclui base e corantes) sem desconto.",
            withAndWithoutVat:
                "No painel de FÃ³rmula, o preÃ§o serÃ¡ visÃ­vel em ambas as variaÃ§Ãµes, com e sem IVA, simultaneamente.",
            withVat: "No painel de FÃ³rmula, todos os preÃ§os serÃ£o visÃ­veis com IVA incluÃ­do.",
            withoutVat: "No painel de FÃ³rmula, todos os preÃ§os serÃ£o visÃ­veis com IVA excluÃ­do."
        },
        qualityControlSettings: {
            colorDifference: "Modelo de DiferenÃ§a de Cor para o Controlo de Qualidade.",
            deltaA: "Define o limite da tolerÃ¢ncia para Delta A no Controlo de Qualidade.",
            deltaB: "Define o limite da tolerÃ¢ncia para Delta B no Controlo de Qualidade.",
            deltaE: "Define o limite da tolerÃ¢ncia para Delta E no Controlo de Qualidade.",
            deltaL: "Define o limite da tolerÃ¢ncia para Delta L no Controlo de Qualidade.",
            deltaMetamerism: "Define o limite da tolerÃ¢ncia para Delta Metamerismo no Controlo de Qualidade."
        },
        registration: {
            sync: "Sincroniza os dados com a secÃ§Ã£o Info POS"
        },
        searchingPleaseWait: "Por favor aguarde, o melhor resultado estÃ¡ a ser procurado",
        setupSteps: {
            customData: "Dados Personalizados",
            machineType: "Tipo de mÃ¡quina",
            userPreferences: "PreferÃªncias do Utilizador"
        },
        spectroSettings: {
            ColorixNanoUseProfiledValues:
                "Quando se utilizam valores perfilados, os resultados medidos sÃ£o recalculados para remover o efeito de filtro. Permitir esta opÃ§Ã£o para a mediÃ§Ã£o universal de espectrofotÃ³metros.",
            XRiteModelRM400: "NÃ£o sÃ£o requeridos Drivers.",
            datacolorDiagnosticTile: "Datacolor - Usar mosaico de diagnÃ³stico.",
            datacolorSilent: "Datacolor -  silenciado",
            measureModes: "Seleccionar os nÃ­veis de brilho suportados.",
            model: "Modelo",
            simulationPath: "Caminho para o ficheiro de simulaÃ§Ã£o. Usada a predefiniÃ§Ã£o.",
            spectroType: "O driver oficial do espectrofotÃ³metro tem de estar instalado. Apenas para Windows.",
            spectroTypeCom:
                "O driver oficial do espectrofotÃ³metro tem de estar instalado. AtenÃ§Ã£o Ã  porta COM em uso. VÃ¡lido para Windows assim como para Linux.",
            spectroTypeDataColorReader:
                "O computador tem de ter ligaÃ§Ã£o Bluetooth. O espectrofotÃ³metro tem de ser emparelhado com o computador. Ã necessÃ¡rio o Windows 10 com actualizaÃ§Ã£o automÃ¡tica de 2018.",
            spectroTypeMinolta2XXXd:
                "O driver oficial do espectrofotÃ³metro tem de estar instalado. AtenÃ§Ã£o Ã  porta COM em uso. VÃ¡lido para Windows assim como para Linux.",
            spectroTypeNotSelected: "Seleccione o seu modelo de espectrofotÃ³metro.",
            spectroTypeRM400: "NÃ£o sÃ£o requeridos Drivers.",
            spectroTypeSimulation:
                "Valores laboratoriais necessÃ¡rios para obter resultados de simulaÃ§Ã£o. Windows bem como Linux.",
            spectroTypeXRite: "Apenas Windows."
        },
        ufiCode: {
            baseUfiCodeValidation:
                "O cÃ³digo UFI de base tem de ser validado atravÃ©s de cÃ³digo de barras antes de ser permitida a sua dispensa.",
            enableUfiCodes:
                "Os cÃ³digos UFI sÃ£o utilizados na UE e fornecem informaÃ§Ãµes sobre o quÃ£o perigoso um produto Ã© para o ambiente.",
            invalidUfi: "CÃ³digo UFI InvÃ¡lido.",
            printUfiCode:
                "Se um corante numa fÃ³rmula exceder o limite estabelecido, o seu cÃ³digo UFI serÃ¡ impresso na etiqueta de impressÃ£o.",
            printUfiCodePercentage:
                "Se um corante numa fÃ³rmula exceder o limite estabelecido, o seu cÃ³digo UFI e respectiva percentagem serÃ£o impressos na etiqueta. ",
            ufiCodesByPercentage:
                "O cÃ³digo UFI que prevalece Ã© utilizado para impressÃ£o considerando a sua quantidade real no depÃ³sito. Navegue atÃ© Ã s definiÃ§Ãµes do depÃ³sito para definir o limite para cada um deles.",
            ufiCodesFromDatabase:
                "O cÃ³digo UFI da Base de Dados principal fornecido pelo administrador da Base de Dados Ã© utilizado para a impressÃ£o.",
            ufiCodesFromLastFilling:
                "O cÃ³digo UFI da Ãºltima recarga dado pelo operador Ã© utilizado para a impressÃ£o independentemente da quantidade recarregada."
        },
        userManagement: {
            add: "A definiÃ§Ã£o adiciona um novo Utilizador que pode iniciar sessÃ£o no software. O Utilizador pode ter um cÃ³digo de barras atribuÃ­do e poderÃ¡ iniciar sessÃ£o automaticamente apÃ³s o software ser iniciado, se assim for definido.",
            assignedGroups:
                "Define a que Grupos de Utilizadores o Utilizador pertence. Diferentes Grupos de Utilizadores permitem atribuir privilÃ©gios diferenciados no Sistema.",
            availableGroups:
                "Define que Grupos de Utilizadores existem disponÃ­veis para o Utilizador. Diferentes Grupos de Utilizadores permitem atribuir privilÃ©gios diferenciados no Sistema. ",
            loggedUserDelete: "O Utilizador actualmente ligado nÃ£o pode ser apagado."
        },
        visit: "Ou visite",
        visitNoLicense: "Para mais informaÃ§Ãµes, por favor visite"
    },
    helpSettings: {
        customHelpLink: "LigaÃ§Ã£o Centro de Ajuda",
        helpSettings: "Ajuda - DefiniÃ§Ãµes",
        message: "Mensagem"
    },
    helper: {
        automaticallyCheckForUpdates: "Procurar automaticamente por actualizaÃ§Ãµes",
        automaticallyDownloadUpdates: "Descarregar automaticamente as actualizaÃ§Ãµes",
        automaticallyInstallNewDatabases: "Instalar automaticamente novas Bases de Dados",
        automaticallyInstallUpdates: "InstalaÃ§Ã£o AutomÃ¡tica de ActualizaÃ§Ãµes",
        bugReport: "RelatÃ³rio de Anomalias",
        canBrowseChangeLog: "Mostrar Online %{name} changelog",
        collect: "Recolher",
        collectLogFiles: "Recolher Ficheiros de Registo (log)",
        component: "Componente",
        content: "ConteÃºdo",
        contentSize: "Tamanho do conteÃºdo",
        download: "Descarregar",
        downloadLogFiles: "Descarregar Ficheiros de Registo (log)",
        downloadingData: "A descarregar dados",
        everyHours: "cada %{interval} horas",
        forceInstall: "ForÃ§ar a ActualizaÃ§Ã£o",
        installDuringNight: "Durante a noite (%{start} - %{end}) - every %{interval} hour",
        newVersion: "Nova versÃ£o",
        notConnected: "Helper nÃ£o estÃ¡ ligado",
        openBugReport: "Abrir RelatÃ³rio de Anomalias",
        packageSize: "Formato",
        pleaseWait: "Por favor aguarde, isto pode levar algum tempo.",
        send: "Enviar",
        sendBugReportToCustomerService: "Enviar RelatÃ³rio de Anomalias",
        sendingReport: "Enviando",
        subject: "Assunto"
    },
    helperDialog: {
        1: "Pode verificar por actualizaÃ§Ãµes de software ou Bases de Dados.",
        2: "Continuar com o download dos pacotes de actualizaÃ§Ã£o?",
        3: "Continuar com a instalaÃ§Ã£o de pacotes de actualizaÃ§Ã£o descarregados?",
        10: "Procurando por novas actualizaÃ§Ãµes de software e de Bases de Dados.   ...",
        11: "Existe uma nova actualizaÃ§Ã£o disponÃ­vel para o seu computador. Quer descarregÃ¡-la?",
        12: "NÃ£o existem novas actualizaÃ§Ãµes disponÃ­veis para o seu computador.",
        14: "Ocorreu um erro durante a verificaÃ§Ã£o de actualizaÃ§Ãµes. %{0}",
        15: "'A sincronizar Base de Dados (''zone'') .   ...'",
        20: "A descarregar pacote de actualizaÃ§Ã£o.   ...",
        21: "O pacote de actualizaÃ§Ã£o que foi descarregado estÃ¡ agora a ser verificado.   ...",
        22: "A descarga do pacote de actualizaÃ§Ã£o falhou! Tentar de novo ?",
        23: "A descarga do pacote de actualizaÃ§Ã£o falhou (o ficheiro estÃ¡ mal formado). Tentar de novo ?",
        24: "AvanÃ§ar com a instalaÃ§Ã£o de actualizaÃ§Ã£o?",
        25: "A instalaÃ§Ã£o da actualizaÃ§Ã£o automÃ¡tica comeÃ§arÃ¡ em %{0}",
        26: "Existe uma nova actualizaÃ§Ã£o disponÃ­vel para o seu computador. Quer descarregÃ¡-la?",
        27: "AvanÃ§ar com a instalaÃ§Ã£o de actualizaÃ§Ã£o?",
        40: "A parar aplicaÃ§Ãµes e serviÃ§os.   â¦",
        41: "A copiar novos ficheiros.   ...",
        42: "A iniciar aplicaÃ§Ãµes e serviÃ§os.   â¦",
        43: "A terminar a actualizaÃ§Ã£o de software.   ...",
        44: "O seu software foi actualizado com sucesso!",
        45: "Quer tentar de novo a instalaÃ§Ã£o? Se decidir tentar de novo, certifique-se de que os componentes de software nÃ£o estÃ£o actualmente em uso.",
        46: "A reinicializaÃ§Ã£o do PC Ã© necessÃ¡ria para afectar as alteraÃ§Ãµes, a reinicializaÃ§Ã£o serÃ¡ feita em %{0}",
        999: "Ocorreu um erro interno: %{0}",
        automaticInstallation: "InstalaÃ§Ã£o de actualizaÃ§Ã£o automÃ¡tica",
        btnAbort: "Abortar",
        btnCancel: "Cancelar",
        btnCheckUpdate: "Procurar por actualizaÃ§Ãµes",
        btnContinue: "Continuar",
        btnDownloadUpdate: "Descarregar actualizaÃ§Ã£o",
        btnInstallUpdate: "Instalar actualizaÃ§Ã£o",
        btnOk: "OK",
        btnRetry: "Tentar de Novo",
        btnSkip: "Saltar",
        checkingForUpdates: "Procurando por actualizaÃ§Ãµes",
        downloadingFailed: "A descarga falhou!",
        downloadingPackage: "A descarregar pacote de actualizaÃ§Ã£o.   â¦",
        finishingUpdate: "A terminar a actualizaÃ§Ã£o ",
        installingUpdate: "A instalar a actualizaÃ§Ã£o",
        internalError: "Erro interno",
        rebootRequired: "Ã necessÃ¡ria uma reinicializaÃ§Ã£o do computador",
        startingComponents: "A iniciar componentes de software",
        stoppingComponents: "A parar componentes de software",
        synchronizingDatabases: "'A sincronizar Base de Dados (''zone'')'",
        updateAvailable: "ActualizaÃ§Ã£o disponÃ­vel, seleccione os componentes a serem actualizados",
        updateDownloaded: "A actualizaÃ§Ã£o foi descarregada",
        updateFailed: "O processo de actualizaÃ§Ã£o falhou",
        updateInstalled: "A actualizaÃ§Ã£o foi instalada",
        verificationFailed: "A verificaÃ§Ã£o do pacote de actualizaÃ§Ã£o falhou",
        verifyingPackage: "A verificar a integridade do pacote descarregado",
        yourSoftwareIsUpToDate: "O seu software estÃ¡ actualizado",
        yourSoftwareVersion: "A sua versÃ£o de software: %{0}"
    },
    importData: {
        abortImportingData: "Abortar a ImportaÃ§Ã£o",
        aborted: "A importaÃ§Ã£o foi abortada.",
        backupLocalDB: "Backup da Base de Dados Local.",
        confirmRestore: "Quer realmente restaurar todas as definiÃ§Ãµes locais?",
        dataMissing: "A importaÃ§Ã£o falhou porque o ficheiro fonte nÃ£o continha quaisquer dados.",
        deleteImportedData: "Apaga Dados Importados",
        encodingFile: "CodificaÃ§Ã£o de Ficheiros",
        exportLocalSettings: "Exportar DefiniÃ§Ãµes Locais",
        exportStaticSql: "Exportar Static SQL ",
        fileDamaged: "A importaÃ§Ã£o falhou porque o ficheiro de origem parece estar danificado.",
        fileMissing: "A importaÃ§Ã£o falhou porque o ficheiro fonte nÃ£o existe.",
        format: "Formato",
        formatPath: "Caminho de FormataÃ§Ã£o",
        headerMissing: "A importaÃ§Ã£o falhou porque falta o cabeÃ§alho do ficheiro.",
        import: "ImportaÃ§Ã£o",
        importAborted: "ImportaÃ§Ã£o abortada",
        importAborting: "Abortando a importaÃ§Ã£o",
        importFailed: "A importaÃ§Ã£o falhou devido a um erro inesperado.",
        importLocalSettings: "Importar DefiniÃ§Ãµes Locais",
        importPrices: "ImportaÃ§Ã£o de PreÃ§os",
        imported: "A importaÃ§Ã£o foi concluÃ­da com sucesso.",
        importedWithErrors: "A ImportaÃ§Ã£o terminou com erros. As linhas com erro foram ignoradas.",
        importing: "Importando â¦",
        noFormatAvailable: "Nenhum formato disponÃ­vel",
        processing: "Processando",
        processingCustomFormulas: "Processando FÃ³rmulas Personalizadas",
        processingCustomers: "Processando Clientes",
        productsFile: "Ficheiro de Produtos",
        restoreLocalSettings: "Restaurar DefiniÃ§Ãµes Locais",
        underProgress: "A importaÃ§Ã£o estÃ¡ em curso.",
        unknownFormat: "A importaÃ§Ã£o falhou porque o ficheiro de origem Ã© de formato desconhecido.",
        userFormulasFile: "Ficheiro de fÃ³rmulas de utilizador"
    },
    infoType: {
        baseDensity: "Densidade da Base",
        baseMass: "Massa da base",
        baseUfiCode: "CÃ³digo UFI da Base",
        baseVolume: "Volume da Base",
        batchNumbersTable: "Tabela de NÃºmeros de Lote",
        bfsGrade: "Classe BFS",
        colorLab: "Cor Lab",
        colorRgb: "Cor RGB",
        colorRgbHex: "Cor RGB Hex",
        colorXyz: "Cor xyz",
        colorantBatchNumbers: "NÃºmeros de Lote de Corantes",
        colorantMass: "Massa do Corante",
        colorantUfiCodes: "CÃ³digos UFI do Corante",
        colorantVolume: "Volume do Corante",
        formulaDate: "Data da FÃ³rmula",
        formulaDatetime: "Data e Hora da FÃ³rmula",
        formulaMoreInfo: "FÃ³rmula mais informaÃ§Ãµes",
        formulaMoreInfoInternal: "FÃ³rmula mais informaÃ§Ã£o interna",
        formulaMoreInfoPrint: "FÃ³rmula mais informaÃ§Ã£o - imprimir",
        hbw: "HBW",
        isPackageGravimetric: "Ã Embalagem GravimÃ©trica",
        maxColorantMass: "Massa MÃ¡xima de Corante permitida",
        maxColorantVolume: "Volume MÃ¡ximo de Corante permitido",
        nominalMass: "Massa Nominal da Embalagem",
        nominalVolume: "Volume Nominal da Embalagem",
        overfillDetected: "Sobreenchimento Detectado",
        totalPaintDensity: "Densidade total da tinta",
        totalPaintMass: "Massa Total da Tinta",
        totalPaintVolume: "Volume Total da Tinta",
        ufiCodesTable: "Tabela de CÃ³digos UFI",
        verifiedFormula: "FÃ³rmula Verificada",
        yValue: "Valor Y"
    },
    initialTab: {
        favoriteFormulas: "FÃ³rmulas Favoritas",
        lastDispensedFormulas: "Ãltimas FÃ³rmulas Dispensadas",
        searchNewFormula: "Procurar Nova FÃ³rmula"
    },
    invalidBatchNumbersModal: {
        header: "Verificar nÃºmero do lote dos corantes",
        info: "Existe pelo menos um depÃ³sito que contÃ©m um lote de corante inadequado. Por favor, nÃ£o utilize este lote. Esvazie o depÃ³sito usando o Quick Tint (Dispensa Manual).",
        unknownStatus: "Estado do Lote desconhecido"
    },
    keyWords: {
        action: "actuar",
        add: "adicionar",
        addition: "adiÃ§Ã£o",
        additional: "adicional",
        address: "endereÃ§o",
        admin: "admin",
        advanced: "AvanÃ§ado",
        after: "depois de",
        afterDispensing: "apÃ³s a dispensa",
        alfa: "Alfa",
        all: "todos",
        allow: "permitir",
        alphabetically: "alfabeticamente",
        amount: "quantidade",
        api: "api",
        ask: "perguntar",
        autocap: "autocap",
        autotask: "tarefa automÃ¡tica",
        availablePrice: "preÃ§o disponÃ­vel",
        backup: "backup",
        banner: "faixa",
        barcode: "cÃ³digo de barras",
        barcodes: "cÃ³digos de barras",
        base: "base",
        before: "antes",
        begin: "comeÃ§ar",
        bfs: "bfs",
        bottom: "fundo",
        brand: "marca",
        brush: "escova",
        bug: "erro",
        button: "botÃ£o",
        buy: "comprar",
        cC3: "CC3",
        cM: "CM",
        calibration: "calibraÃ§Ã£o",
        can: "lata",
        canHandling: "manuseamento da lata",
        canister: "depÃ³sito",
        canisterFilling: "enchimento de depÃ³sitos",
        canisterLevels: "nÃ­veis de depÃ³sitos",
        canisters: "depÃ³sitos",
        cap: "cap",
        center: "Centro",
        centre: "Centro",
        change: "alteraÃ§Ã£o",
        changelog: "registo de alteraÃ§Ãµes",
        channels: "bicos",
        check: "verifique",
        chunk: "pedaÃ§o",
        chunks: "pedaÃ§os",
        city: "cidade",
        clean: "limpe",
        cleaning: "limpando",
        clientIdentifier: "identificador de cliente",
        close: "feche",
        closest: "mais prÃ³ximo",
        code: "cÃ³digo",
        collect: "recolha",
        color: "cor",
        colorLink3: "ColorLink3",
        colorPanel: "paleta de cores",
        colorReader: "ColorReader",
        colorant: "corante",
        colorantConsumption: "consumo de corante",
        colorantPrice: "preÃ§o do corante",
        colorants: "corantes",
        colorix: "Colorix",
        colour: "cor",
        communication: "comunicaÃ§Ã£o",
        compare: "Comparar",
        competitive: "competitivo",
        computer: "computador",
        config: "configurar",
        configuration: "definiÃ§Ã£o",
        confirm: "confirmar",
        confirmation: "confirmaÃ§Ã£o",
        connection: "ligaÃ§Ã£o",
        contactPerson: "pessoa de contacto",
        control: "Controlo",
        copies: "cÃ³pias",
        corob: "Corob",
        cost: "custo",
        country: "paÃ­s",
        create: "criar",
        currency: "moeda",
        current: "actual",
        custom: "personalizado",
        customers: "Clientes",
        daily: "diariamente",
        dark: "Escura",
        data: "dados",
        database: "Base de Dados",
        datacolor: "Datacolor",
        date: "data",
        decimals: "decimais",
        default: "padrÃ£o",
        delay: "atraso",
        delete: "apagar",
        deletion: "apagamento",
        deltaE: "delta E",
        device: "dispositivo",
        devices: "dispositivos",
        diagnosticTile: "Mosaico de diagnÃ³stico",
        dialog: "diÃ¡logo",
        direct: "directo",
        disconnect: "desligar",
        discount: "desconto",
        dispense: "dispensar",
        dispenser: "dispensador",
        dispensing: "dispensando",
        down: "para baixo",
        download: "descarregar",
        driver: "Driver",
        dromont: "Dromont",
        dspProxy: "DspProxy",
        edit: "editar",
        editor: "Editor",
        email: "e-mail",
        error: "erro",
        evoDriver: "EvoDriver",
        evoService: "EvoService",
        excel: "Excel",
        expiration: "expiraÃ§Ã£o",
        export: "exportar",
        eyeOne: "Eye-One",
        fF: "F&F",
        fandeck: "catÃ¡logo",
        fastFluid: "Fast & Fluid",
        file: "ficheiro",
        fill: "encher",
        fillToMax: "encher ao mÃ¡ximo",
        find: "localizar",
        first: "primeiro",
        flex: "Flex",
        folder: "pasta",
        formula: "fÃ³rmula",
        formulas: "fÃ³rmulas",
        from: "a partir de",
        fts5: "fts5",
        fullScreen: "ecrÃ£ completo",
        fullText: "texto integral",
        fulltext: "texto integral",
        g: "g",
        genericPricing: "preÃ§os genÃ©ricos",
        hLD: "HLD",
        hard: "hard",
        hbw: "hbw",
        help: "ajuda",
        helpCenter: "centro de ajuda",
        hero: "Hero",
        history: "histÃ³ria",
        home: "home",
        host: "anfitriÃ£o",
        humidifier: "humidificador",
        iDD: "IDD",
        identification: "identificaÃ§Ã£o",
        image: "imagem",
        impGallon: "imp. galÃ£o",
        impQuart: "imp. quart",
        import: "Importar",
        individually: "individualmente",
        info: "InformaÃ§Ã£o",
        information: "informaÃ§Ã£o",
        initial: "inicial",
        initialization: "inicializaÃ§Ã£o",
        initialize: "inicializar",
        insert: "inserir",
        install: "instalar",
        intellyPurge: "purga inteligente",
        invalid: "invÃ¡lido",
        ipAddress: "endereÃ§o IP",
        italtinto: "Italtinto",
        items: "Itens",
        keyboard: "teclado",
        kg: "Kg",
        kiosk: "Kiosk",
        kioskMode: "modo kiosk",
        l: "l",
        lLD: "LLD",
        lab: "lab",
        label: "etiqueta",
        labels: "etiquetas",
        language: "lÃ­ngua",
        largo: "largo",
        last: "Ãºltimo",
        lenteq: "Lenteq",
        levels: "nÃ­veis",
        license: "licenÃ§a",
        light: "Luz",
        limit: "limite",
        link: "ligaÃ§Ã£o",
        linux: "Linux",
        load: "carga",
        lock: "fechar",
        logFiles: "ficheiros de registo",
        logic: "lÃ³gica",
        logo: "logÃ³tipo",
        lower: "baixar",
        machine: "mÃ¡quina",
        machineConfiguration: "definiÃ§Ã£o da mÃ¡quina",
        machineManagement: "gestÃ£o de mÃ¡quinas",
        machineName: "nome da mÃ¡quina",
        main: "principal",
        maintenance: "manutenÃ§Ã£o",
        manual: "manual",
        manualAddition: "adiÃ§Ã£o manual",
        manualDispensing: "dispensa manual",
        manualScan: "varrimento manual",
        margins: "margens",
        markups: "markups / majoramentos",
        mass: "massa",
        match: "coincidente",
        measure: "medida",
        measurement: "mediÃ§Ã£o",
        measurementUnits: "unidades de mediÃ§Ã£o",
        melody: "melodia",
        message: "mensagem",
        minimal: "mÃ­nimo",
        minolta: "Minolta",
        minus: "menos",
        minutes: "minutos",
        misura: "Misura",
        ml: "ml",
        mode: "modo",
        model: "modelo",
        modification: "modificaÃ§Ã£o",
        modify: "modificar",
        monthly: "mensal",
        moreInfo: "mais informaÃ§Ã£o",
        movableTable: "mesa mÃ³vel",
        move: "mover",
        music: "mÃºsica",
        myOrders: "Tintagem - Os Meus Pedidos",
        name: "nome",
        naming: "nomeando",
        nano: "Nano",
        navigation: "navegaÃ§Ã£o",
        new: "novo",
        nextDriver: "NextDriver",
        night: "noite",
        nixPro: "Nix Pro",
        notes: "notas",
        notification: "notificaÃ§Ã£o",
        number: "nÃºmero",
        off: "off",
        open: "abrir",
        order: "encomenda",
        ordering: "encomendar",
        overfill: "sobreenchimento",
        overview: "visÃ£o geral",
        overwrite: "sobrescrever",
        own: "prÃ³prio",
        pCPDriver: "PCPDriver",
        package: "embalagem",
        packagePrice: "preÃ§o da embalagem",
        packages: "embalagens",
        panels: "painÃ©is",
        parameter: "parÃ¢metro",
        path: "caminho",
        pc: "pc",
        phone: "telefone",
        phoneNumber: "nÃºmero de telefone",
        picture: "imagem",
        place: "local",
        placement: "colocaÃ§Ã£o",
        plug: "ficha",
        plugger: "conector",
        plugging: "conectando",
        plugin: "encaixe",
        plus: "mais",
        pointOfSale: "ponto de venda",
        popUp: "pop-up",
        pos: "POS",
        present: "presente",
        preview: "antevisÃ£o",
        price: "preÃ§o",
        priceExport: "exportaÃ§Ã£o de preÃ§os",
        priceGroup: "grupo de preÃ§os",
        priceImport: "preÃ§o de importaÃ§Ã£o",
        prices: "preÃ§os",
        pricing: "preÃ§os",
        primaryCurrency: "moeda primÃ¡ria",
        print: "imprimir",
        printer: "impressora",
        printing: "impressÃ£o",
        problem: "problema",
        product: "produto",
        productPrice: "preÃ§o do produto",
        profiledValues: "valores perfilados",
        punch: "perfurar",
        puncher: "perfurador",
        punching: "perfuraÃ§Ã£o",
        purge: "purga",
        purgeType: "tipo de purga",
        purgeVolume: "volume de purga",
        quality: "qualidade",
        quick: "rÃ¡pido",
        quickTint: "Quick Tint",
        rM: "RM",
        raise: "levantar",
        rcc: "rcc",
        reader: "leitor",
        reboot: "reiniciar",
        receive: "receber",
        recirculate: "recircular",
        recirculation: "recirculaÃ§Ã£o",
        redlike: "Redlike",
        refill: "recarga",
        registration: "registo",
        regular: "Regular",
        removal: "remoÃ§Ã£o",
        remove: "remover",
        report: "relatÃ³rio",
        reset: "reinicializaÃ§Ã£o",
        resolution: "resoluÃ§Ã£o",
        restart: "reiniciar",
        rgb: "RGB",
        rights: "direitos",
        rounding: "arredondamento",
        rules: "regras",
        sanTint: "SanTint",
        save: "guardar",
        scale: "balanÃ§a",
        scan: "varimento",
        scope: "Ã¢mbito",
        screen: "ecrÃ£",
        screensaver: "protector de ecrÃ£",
        search: "procura",
        secondaryCurrency: "moeda secundÃ¡ria",
        select: "seleccionar",
        selectedFormula: "FÃ³rmula seleccionada",
        sell: "vender",
        sensor: "Sensor",
        serialNumber: "nÃºmero de sÃ©rie",
        server: "servidor",
        servers: "servidores",
        service: "serviÃ§o",
        serviceAction: "acÃ§Ã£o de serviÃ§o",
        serviceActions: "acÃ§Ãµes de serviÃ§o",
        serviceSoftware: "software de serviÃ§o",
        serviceWindow: "janela de serviÃ§o",
        settings: "definiÃ§Ãµes",
        shelf: "prateleira",
        shortcuts: "atalhos",
        shot: "shot",
        show: "mostrar",
        shutDown: "fechar",
        shutdown: "encerramento",
        silent: "Silencioso",
        simple: "simples",
        simulation: "simulaÃ§Ã£o",
        size: "tamanho",
        skip: "saltar",
        smartPurge: "purga inteligente",
        software: "Software",
        softwareSupplier: "fornecedor de software",
        sort: "ordenar",
        sound: "som",
        spectro: "Spectro",
        spectrophotometer: "espectrofotÃ³metro",
        speed: "velocidade",
        split: "divisÃ£o",
        start: "comeÃ§ar",
        startup: "arranque",
        statistics: "estatÃ­sticas",
        status: "estado",
        stir: "agitar",
        stirring: "agitaÃ§Ã£o",
        street: "rua",
        support: "suporte",
        surcharge: "sobretaxa",
        tab: "separador",
        tabs: "separadores",
        task: "tarefa",
        template: "modelo",
        testing: "testes",
        time: "hora",
        tintingManagementCenter: "centro de gestÃ£o de tintagem",
        to: "para",
        toDispense: "Pedidos para Dispensar",
        tolerance: "tolerÃ¢ncia",
        top: "topo",
        total: "Total",
        translation: "traduÃ§Ã£o",
        turnOff: "desligar",
        turntable: "mesa giratÃ³ria",
        type: "tipo",
        uIDD: "UIDD",
        uSGallon: "GalÃ£o dos EUA",
        uSQuart: "Quart dos E.U.A",
        unit: "unidade",
        up: "subir",
        update: "actualizaÃ§Ã£o",
        url: "url",
        user: "Utilizador",
        userGroups: "Grupos de Utilizadores",
        v1: "v1",
        v2: "v2",
        v3: "v3",
        vAT: "IVA",
        validate: "validar",
        validation: "validaÃ§Ã£o",
        version: "versÃ£o",
        virtual: "Virtual",
        volume: "Volume",
        weekly: "semanalmente",
        window: "janela",
        windows: "Windows",
        with: "com",
        without: "sem",
        xRite: "X-Rite",
        xrite: "Xrite",
        yValue: "y valor",
        zipCode: "cÃ³digo postal",
        zoom: "Zoom"
    },
    languages: {
        bg: "Ð±ÑÌÐ»Ð³Ð°ÑÑÐºÐ¸",
        cs: "ÄeÅ¡tina",
        da: "Danish",
        de: "Deutsch",
        el: "ÎÎ»Î»Î·Î½Î¹ÎºÎ¬",
        en: "English",
        es: "EspaÃ±ol",
        fr: "FranÃ§ais",
        hr: "Hrvatski",
        hu: "Magyar",
        id: "Bahasa Indonesia",
        is: "Ãsland",
        it: "Italiano",
        lt: "Lithuanian",
        lv: "Latvian",
        ms: "Melayu",
        nl: "Nederland",
        no: "Norway",
        pl: "Polski",
        pt: "PortuguÃªs",
        ro: "Romana",
        ru: "Ð ÑÑÑÐºÐ¸Ð¹",
        sk: "SlovenÄina",
        sr: "Srpski",
        sv: "Sverige",
        zh: "Chinese"
    },
    license: {
        activateLicense: "Activar a licenÃ§a",
        activateNewLicense: "Activar nova licenÃ§a",
        checkLicenseKey: "Verificar chave de licenÃ§a",
        companyId: "IdentificaÃ§Ã£o da Empresa",
        contactPerson: "Pessoa de contacto",
        copy: "CÃ³pia",
        country: "PaÃ­s",
        emptyCity: "A cidade Ã© uma informaÃ§Ã£o obrigatÃ³ria",
        emptyCountry: "O paÃ­s Ã© uma informaÃ§Ã£o obrigatÃ³ria",
        emptyName: "O nome da loja Ã© uma informaÃ§Ã£o obrigatÃ³ria",
        enterIdentificationKeys: "Introduza as suas chaves de identificaÃ§Ã£o",
        expirationDate: "Data de expiraÃ§Ã£o %{dateTime}",
        fillRegistration: "Preencha os dados de registo (desÃ§a para ver mais)",
        insertLicense: "Inserir chave gerada para activaÃ§Ã£o offline",
        invalidEmail: "O e-mail inserido Ã© invÃ¡lido",
        invalidPhone: "O telefone inserido Ã© invÃ¡lido",
        itemsMarkedasterisk: "(os items marcados com um asterisco devem ser preenchidos)",
        lastUpdate: "Ãltima alteraÃ§Ã£o %{dateTime}",
        leasedLicense: "LicenÃ§a alugada",
        licenseActivated: "LicenÃ§a activada",
        licenseStatus: "Estado da licenÃ§a",
        licenseWillExpire: "A sua licenÃ§a expira em %{dayCount} dias",
        licenseWillExpireOneDay: "A sua licenÃ§a expira em %{dayCount} dia",
        machineInformation: "InformaÃ§Ã£o da mÃ¡quina",
        noLicenseAvailable: "nenhuma licenÃ§a disponÃ­vel",
        noProductsForKey: "NÃ£o hÃ¡ produtos disponÃ­veis para as chaves de identificaÃ§Ã£o indicadas.",
        pointOfSale: "Ponto de venda",
        producer: "Produtor",
        reactivate: "Reactivar",
        reactivateLicense: "Reactivar LicenÃ§a",
        region: "RegiÃ£o",
        registerLicense: "Por favor, pegue numa cÃ³pia do pedido de activaÃ§Ã£o e navegue atÃ©:",
        registrationForm: "Registo",
        selectProduct: "Seleccione o produto",
        serialNumber: "NÃºmero de sÃ©rie",
        skipNewLicense: "Se quiser Activar uma nova licenÃ§a mais tarde, pode clicar em Saltar",
        unlimitedLicense: "LicenÃ§a ilimitada",
        userId: "IdentificaÃ§Ã£o do Utilizador",
        uuid: "LicenÃ§a UUID",
        versionDetails: "Detalhes da versÃ£o",
        versionScope: "Ãmbito da versÃ£o",
        versionType: "Tipo de versÃ£o",
        zip: "CÃ³digo Postal"
    },
    login: {
        authenticate: "Autenticar",
        logIn: "Iniciar SessÃ£o",
        loginAs: "Iniciar sessÃ£o como outro Utilizador",
        messages: {
            incorrectUsername: "O nome de Utilizador ou palavra-passe estÃ¡ incorrecto"
        },
        password: "Palavra-Passe",
        username: "Nome do Utilizador"
    },
    machineActionHistory: {
        actionHistory: "HistÃ³rico de OperaÃ§Ãµes"
    },
    machineErrors: {
        channel: "Canal",
        code: "CÃ³digo",
        machineErrors: "Erros da mÃ¡quina",
        noMachineErrors: "NÃ£o existem actualmente erros de mÃ¡quina",
        resetErrors: "Repor erros"
    },
    machineSettings: {
        action: "AcÃ§Ã£o",
        addAutotask: "Adicionar Tarefa AutomÃ¡tica",
        autoCanisterIn: "Entrada de DepÃ³sito AutomÃ¡tica",
        autoCanisterOut: "SaÃ­da de DepÃ³sito AutomÃ¡tica",
        automaticRefill: "Recarga AutomÃ¡tica",
        autotaskSettings: "DefiniÃ§Ãµes de Tarefas AutomÃ¡ticas",
        backupConfiguration: "Guardar DefiniÃ§Ãµes do Dispensador",
        brushMaintenance: "ManutenÃ§Ã£o da Escova",
        capMaintenance: "ManutenÃ§Ã£o da Tampa",
        checkCanisterBeforeDispense: "Verifique o depÃ³sito antes da dispensa",
        checkColorantBaseRules: "Verifica regras para Corante e Base.",
        checkMinDosableAmount: "Verificar a quantidade mÃ­nima de corantes",
        checkOverfill: "Verificar o sobreenchimento do depÃ³sito",
        checkTotalCntAmounts: "Verificar a quantidade total de corantes para a base de tintagem",
        cleanAll: "Limpar tudo",
        computerReboot: "ReinÃ­cio do computador",
        computerShutdown: "Encerramento do computador",
        connectMachine: "Ligar a MÃ¡quina",
        days: "Dias",
        daysOfMonth: "Dias do mÃªs",
        devices: "Dispositivos",
        disabled: "Desactivado",
        dispenseAndPurge: "Dispensar e purgar",
        dispenseOnly: "Dispensar apenas",
        dispenserCleaning: "Limpeza do dispensador",
        dispensingWithErrorsEnabled: "Permitir a dispensa apesar dos erros de validaÃ§Ã£o",
        editAutotask: "Editar tarefa automÃ¡tica",
        firstRun: "Primeira ExecuÃ§Ã£o",
        hours: "Horas",
        humidifier: "Humidificador",
        humidifierWaterLevelMaintenance: "ManutenÃ§Ã£o do nÃ­vel de Ã¡gua do humidificador",
        machineConfigurationNoCanisters: "A definiÃ§Ã£o da mÃ¡quina nÃ£o contÃ©m depÃ³sitos.",
        machineName: "Nome da mÃ¡quina",
        machineSettings: "DefiniÃ§Ãµes da mÃ¡quina",
        manualPuncher: "Perfurador manual",
        minDispensedAmount: "Quantidade mÃ­nima dispensada",
        minutes: "Minutos",
        nextRun: "PrÃ³xima ExecuÃ§Ã£o",
        noAutotasksSet: "Sem tarefas automÃ¡ticas definidas",
        noDataAvailable: "NÃ£o hÃ¡ dados disponÃ­veis",
        noMachine: "NÃ£o estÃ¡ ligada nenhuma mÃ¡quina",
        onStart: "No arranque",
        plugger: "Conector",
        postpone: "Pode adiar",
        puncher: "Perfurador",
        purgeAll: "Purgar Todos",
        purgeOnly: "Apenas purga",
        recirculateAll: "Recircular Todos",
        recirculateChannels: "RecirculaÃ§Ã£o de DepÃ³sitos",
        recirculationSpeed: "Velocidade de recirculaÃ§Ã£o",
        recirculationTime: "Tempo de recirculaÃ§Ã£o",
        refillAll: "Recarregar Todos",
        refillCanisters: "Recarregar DepÃ³sitos",
        runAt: "Diariamente Ã s",
        runDefinedDaysAt: "Em dias definidos Ã s",
        runEvery: "Executar a cada",
        runInDays: "ExecuÃ§Ã£o em dias",
        serialNum: "NÃºmero de sÃ©rie",
        settingsMachine: "DefiniÃ§Ãµes da MÃ¡quina",
        smartPurgeAll: "Purga Inteligente - Para Todos",
        smartPurgeChannels: "Purga - Individual",
        smartPurgeRules: "Regras de Purga Inteligente",
        startType: "Tipo de arranque",
        stirAll: "Agitar tudo",
        stirCanisters: "Canais de agitaÃ§Ã£o",
        stirringSpeed: "Velocidade de agitaÃ§Ã£o",
        stirringTime: "Tempo de agitaÃ§Ã£o",
        switchPlateMaintenance: "ManutenÃ§Ã£o da placa de circuito",
        theCurrentlySelectedMachine: "MÃ¡quina correntemente seleccionada",
        threshold: "Limiar",
        turntable: "Plataforma giratÃ³ria",
        unifyColorantBatchForMultipleCans: "Unifica o Lote de Corante para dispensas de mÃºltiplas embalagens.",
        volume: "Volume",
        weekdays: "Dias Ãºteis"
    },
    mainTab: {
        acceptedFormula: "FÃ³rmula aceite",
        addBuildingSite: "Adicionar local de construÃ§Ã£o.",
        addToFavorites: "Adicionar aos favoritos",
        alternativeFormulas: "FÃ³rmulas Alternativas",
        alternativeValidFormulas: "FÃ³rmulas Alternativas VÃ¡lidas",
        buildingSiteSpecification: "EspecificaÃ§Ã£o de construÃ§Ã£o de local.",
        colorantsAreInvalid: "Um ou mais corantes sÃ£o invÃ¡lidos",
        dispensedPackages: "Embalagens Dispensadas",
        dispensingInProgress: "Dispensa em curso",
        dispensingIsAborted: "A Dispensa foi interrompida",
        dispensingIsNotAvailable: "A Dispensa nÃ£o Ã© possÃ­vel",
        dispensingProgress: "%de %{done} de %{all}",
        editColorant: "Editar corante",
        editNote: "Nota de ediÃ§Ã£o",
        findCompetitiveColor: "Tente encontrar a cor competitiva",
        forceDispensing: "Dispensa forÃ§ada",
        formulaInvalidColorants: "A fÃ³rmula contÃ©m corantes invÃ¡lidos: %{colorants}",
        formulaOutOfDate: "Formula may be out of date",
        formulaProperties: "Propriedades da FÃ³rmula",
        hiddenFandecks: "CatÃ¡logos ocultos",
        hiddenProducts: "Produtos ocultos",
        historicalFormulas: "HistÃ³rico de FÃ³rmulas",
        lowerDeltaNumber: "Menor nÃºmero de delta maior precisÃ£o",
        machineError: "Erro da mÃ¡quina",
        machineIsBusy: "A mÃ¡quina estÃ¡ ocupada",
        machineNotConnected: "A mÃ¡quina nÃ£o estÃ¡ ligada",
        manualColorantAddition: "AdiÃ§Ã£o manual de corante",
        modifiedFormula: "A fÃ³rmula Ã© modificada",
        modifiedFormulaInLab: "FÃ³rmula modificado no LaboratÃ³rio.",
        newColorAfterScaling: "Nova cor apÃ³s pesagem",
        newRgbNotAccuratelyMeasured: "O novo RGB nÃ£o Ã© medido com precisÃ£o, Ã© apenas indicativo",
        noBaseAvailable: "NÃ£o hÃ¡ base disponÃ­vel",
        noBuildingSiteAvailable: "NÃ£o existe informaÃ§Ã£o sobre o local de construÃ§Ã£o.",
        noColorantForCorrection: "NÃ£o foram seleccionados Corantes adicionais para a CorrecÃ§Ã£o.",
        noColorants: "Sem corantes",
        noCustomer: "Nenhum cliente",
        noCustomers: "Nenhum cliente disponÃ­vel",
        noDispenseNotesAvailable: "NÃ£o se encontram disponÃ­veis instruÃ§Ãµes para Dispensa",
        noFormulaAvailable: "Seleccionou uma combinaÃ§Ã£o sem fÃ³rmula!",
        noFormulaSelected: "NÃ£o foi selecionada nenhuma fÃ³rmula",
        noInternalNotesAvailable: "NÃ£o estÃ£o disponÃ­veis notas internas",
        noNotesAvailable: "Nenhumas instruÃ§Ãµes existentes",
        noPackageAvailable: "Nenhum pacote disponÃ­vel",
        noPackageSelected: "Nenhum embalagem seleccionada",
        noProductAvailable: "Nenhum produto disponÃ­vel",
        noResultsFound: "NÃ£o foram encontrados resultados",
        openLocalFile: "Aberto a partir de uma Base de Dados local",
        openOnlineFile: "Aberto a partir da Internet",
        order: "Pedido",
        orderingIsNotAvailable: "O sistema de pedidos nÃ£o estÃ¡ disponÃ­vel",
        originalColor: "Cor Original",
        overAvailableLevel: "Acima do nÃ­vel disponÃ­vel",
        package: "Embalagem",
        packageIsRequired: "Uma embalagem Ã© necessÃ¡ria",
        packaging: "Embalagem",
        partialUpdateReload: "Partial updates may have affected this formula. Reload this tab to see an updated data.",
        printIsNotAvailable: "A impressÃ£o nÃ£o estÃ¡ disponÃ­vel",
        productFiles: "Ficheiros de Produtos",
        productFilesViewer: "Visualizador de Ficheiros de Produtos",
        productNotAvailable: "Product '%{productName}' is not available.",
        properties: "Propriedades",
        regularPrice: "PreÃ§o Normal",
        resetFormulaData: "Nova fÃ³rmula",
        rgbOnlyIndicative: "RGB apenas indicativo!",
        saveAsCustom: "Guardar Como",
        saveToStatsIsNotAvailable: "Guardar para HistÃ³rico nÃ£o estÃ¡ disponÃ­vel",
        searchForCheaper: "Procurar p/ +econÃ³mico",
        selectFromCompetitive: "Pode seleccionar cor a partir das cores da concorrÃªncia.",
        specialPrice: "PreÃ§o especial",
        specialPriceVip: "PreÃ§o especial VIP",
        splitFormula: "FÃ³rmula dividida",
        withVAT: "com IVA",
        withoutVAT: "sem IVA"
    },
    marginSettings: {
        allBases: "Todas as bases",
        allProducts: "Todos os produtos",
        editMargin: "Editar Margem",
        marginAndDiscountWarning:
            "Ã necessÃ¡rio definir a opÃ§Ã£o de CÃ¡lculo de PreÃ§os para utilizar margens e descontos.",
        marginSettings: "DefiniÃ§Ãµes de Margens",
        marginsFor: "Margens para",
        markupColorants: "Sobretaxa de preÃ§o de Corante",
        sizeOfPackage: "Formato",
        valueBase: "Valor da Base",
        valueColorant: "Valor do Corante"
    },
    matching: {
        actualColor: "Cor actual",
        allCorrections: "Todas as CorrecÃ§Ãµes",
        allTillItems: "Tudo atÃ© aos items",
        auto: "Auto",
        autoSelectAll: "Auto - Todos",
        canStartCorrection: "EntÃ£o pode iniciar a CorrecÃ§Ã£o.",
        canStartMatching: "EntÃ£o pode iniciar a FormulaÃ§Ã£o.",
        cannotBeUsed: "A FormulaÃ§Ã£o nÃ£o pode ser usada.",
        changeProductAndColorants: "Tente mudar o Produto ou os Corantes",
        checkConfig: "Verifique as definiÃ§Ãµes de FormulaÃ§Ã£o.",
        colorCorrection: "CorrecÃ§Ã£o de Cor",
        colorIsIndicative: "A visualizaÃ§Ã£o da cor Ã© meramente indicativa",
        colorNotAccurate:
            "A cor poderÃ¡ nÃ£o ser apresentada com precisÃ£o, dependerÃ¡ sempre das especificaÃ§Ãµes do monitor.",
        colorantInDispensedFormula: "Corantes na fÃ³rmula dispensada",
        confirmDispensing: "Confirm dispensing",
        connectionProblem: "Problema de LigaÃ§Ã£o",
        correctionHistory: "HistÃ³rico de CorrecÃ§Ã£o",
        correctionRunning: "CorrecÃ§Ã£o em execuÃ§Ã£o",
        draftFormula: "Draft formula",
        exclude: "Excluir",
        excludeAll: "Excluir Todos",
        include: "Incluir",
        includeAll: "Incluir Todos",
        invalidProduct: "NÃ£o Ã© possÃ­vel realizar a correspondÃªncia para o produto %{productName}",
        itemOnly: "Apenas Item",
        manualColorCorrection: "CorrecÃ§Ã£o Manual de Cor",
        matchFormula: "FormulaÃ§Ã£o",
        matchingInformation: "InformaÃ§Ã£o de FormulaÃ§Ã£o",
        matchingResult: "Resultado da FormulaÃ§Ã£o",
        matchingRunning: "FormulaÃ§Ã£o em execuÃ§Ã£o",
        matchingSearchOptions: "FormulaÃ§Ã£o - OpÃ§Ãµes de Procura",
        measurement: "MediÃ§Ã£o",
        noCorrection: "ImpossÃ­vel corrigir",
        noSpectralCurveProvided:
            "O dispositivo ligado nÃ£o pode ser usado para a FormulaÃ§Ã£o porque nÃ£o disponibiliza Curva Espectral",
        notAvailableForMatching: "IndisponÃ­vel para FormulaÃ§Ã£o",
        originalFormula: "FÃ³rmula Original",
        reformulate: "Reformular",
        reformulationRunning: "ReformulaÃ§Ã£o em execuÃ§Ã£o",
        resultColor: " Cor resultante",
        saveAsCustomFormula: "Guardar como FÃ³rmula Personalizada",
        searchInProgress: "Procura em curso â¦",
        selectColorfile: "Seleccione o Ficheiro de Cor",
        selectRequiredItems: "Seleccione o Produto, a Base, os Corantes e a Embalagem.",
        selectedResult: "Resultado seleccionado",
        spectralDataNotAvailable: "InformaÃ§Ã£o Expectral indisponÃ­vel",
        startCorrection: "Iniciar CorrecÃ§Ã£o",
        startMatching: "Iniciar FormulaÃ§Ã£o",
        targetColor: "Cor escolhida",
        unsavedDraft: "Unsaved draft",
        unsavedDraftWarning: "Once you are satisfied with formula â do not forget to save your result.",
        usedForMatching: "Usado para FormulaÃ§Ã£o"
    },
    modal: {
        changeColorantUnit: "Alterar unidade de Corante",
        payAttention: "Preste AtenÃ§Ã£o!"
    },
    module: {
        productGroups: "Grupos de Produtos"
    },
    navigation: {
        globalSearch: {
            fandeckFilter: "Filtro de CatÃ¡logo de Cores",
            formulasOverLimit: "Encontrados cerca de %{count} resultados. Por favor tente digitar mais caracteres.",
            foundFormulas: "%{count} FÃ³rmulas Encontradas",
            help: "Ajuda:",
            helpText:
                "Digitepor exemplo '%{filter}' para procurar fÃ³rmulas comeÃ§adas por '%{formula}', produto comeÃ§ado por '%{product}' e catÃ¡logo por '%{fandeck}'.",
            productFilter: "Filtro de produto",
            searchInFormulas: "Procurar em fÃ³rmulas",
            typeMore: "Por favor escreva mais caracteres"
        },
        menu: {
            actionHistory: "HistÃ³rico de OperaÃ§Ãµes",
            additionalFormulaTab: "Separador FÃ³rmula Adicional",
            advancedSettings: "DefiniÃ§Ãµes AvanÃ§adas",
            autotaskSettings: "Tarefas AutomÃ¡ticas",
            availableDatabases: "Bases de Dados disponÃ­veis",
            availablePrices: "PreÃ§os disponÃ­veis",
            bugReport: "RelatÃ³rio de Anomalias",
            canisterBarcodes: "CÃ³digos de barras do depÃ³sito",
            canisterDispensingLogic: "LÃ³gica de Dispensa",
            canisterFilling: "Enchimento de DepÃ³sito",
            canisterSettings: "DefiniÃ§Ãµes do DepÃ³sito",
            clientServerSettings: "LigaÃ§Ã£o Cliente/Servidor",
            closing: "Encerramento",
            color: "Cor",
            colorModification: "ModificaÃ§Ã£o de Cor",
            colorPanel: "DefiniÃ§Ãµes da Paleta de Cores",
            colorRepresentation: "RepresentaÃ§Ã£o de Cores e Dados",
            colorSearch: "Procura de Cores",
            colorant: "Corante",
            colorantConsumption: "Consumo de Corante",
            colorantPricing: "PreÃ§os de Corantes",
            colorantRefillHistory: "HistÃ³rico de Recarga de Corantes",
            competitiveSearch: "Procura de Cores Competitivas",
            connections: "LigaÃ§Ãµes",
            currency: "Moeda",
            customData: "Dados Personalizados",
            database: "Base de Dados",
            databaseCheck: "VerificaÃ§Ã£o da Base de Dados",
            databaseConnection: "LigaÃ§Ã£o Ã  Base de Dados",
            defaultValues: "Valores PadrÃ£o",
            devices: "Dispositivos",
            dispensingHistory: "HistÃ³rico de Dispensa",
            dispensingSettings: "DefiniÃ§Ãµes de Dispensa",
            driverSettings: "DefiniÃ§Ãµes do Driver",
            environment: "Ambiente",
            environmentConfiguration: "DefiniÃ§Ãµes do Ambiente",
            environmentalSettings: "DefiniÃ§Ãµes de Ambiente",
            favorites: "Favoritos",
            fileTransfer: "TransferÃªncia de Ficheiros DESO",
            formatting: "FormataÃ§Ã£o",
            formula: "FÃ³rmula",
            formulaData: "Dados",
            formulaModification: "Modificar FÃ³rmula",
            formulaPanels: "PainÃ©is de FÃ³rmula",
            formulaSettings: "DefiniÃ§Ãµes de FÃ³rmula",
            formulaUnit: "Unidade de FÃ³rmula",
            generalSearch: "Procura Geral",
            globalSettingsSearch: "Procurar nas DefiniÃ§Ãµes",
            helpItems: "DefiniÃ§Ãµes da Ajuda",
            importAndExport: "ImportaÃ§Ã£o e ExportaÃ§Ã£o",
            importAndExportData: "ImportaÃ§Ã£o e ExportaÃ§Ã£o de Dados",
            importCustomData: "Importar Dados Personalizados",
            initialFormulaTab: "Separador Inicial da FÃ³rmula ",
            interfaceSettings: "DefiniÃ§Ãµes do Interface",
            keyboardShortcuts: "Atalhos de Teclado",
            language: "Idioma",
            languageSettings: "DefiniÃ§Ãµes de Idioma",
            layout: "Esquema",
            license: "LicenÃ§a",
            licenseData: "Dados da LicenÃ§a",
            licenseIdentification: "IdentificaÃ§Ã£o da LicenÃ§a",
            licenseStatus: "Estado da LicenÃ§a",
            licenseSupplier: "Fornecedor da LicenÃ§a",
            licenseVersion: "VersÃ£o da LicenÃ§a",
            localData: "Dados Locais",
            machine: "InformaÃ§Ã£o da MÃ¡quina",
            machineActions: "AcÃ§Ãµes da MÃ¡quina",
            machineAndDevices: "MÃ¡quina e Dispositivos",
            machineManagement: "GestÃ£o da MÃ¡quina",
            machineSettings: "DefiniÃ§Ãµes da MÃ¡quina",
            mainSettings: "DefiniÃ§Ãµes Principais",
            maintenance: "ManutenÃ§Ã£o",
            marginAndDiscount: "Margem e Desconto",
            matchingSearchResult: "FormulaÃ§Ã£o - resultados da procura",
            matchingSettings: "DefiniÃ§Ãµes de FormulaÃ§Ã£o",
            navigationItems: "Itens de NavegaÃ§Ã£o",
            newFormulaWindow: "FÃ³rmula",
            orderSearch: "Procura de Pedidos",
            orderSettings: "DefiniÃ§Ãµes de Pedidos",
            packageSurcharge: "Sobretaxa de Embalagem",
            popUps: "Pop-Ups",
            posInfo: "InformaÃ§Ã£o POS",
            price: "DefiniÃ§Ãµes de PreÃ§os",
            priceManagement: "GestÃ£o de PreÃ§os",
            priceSettings: "DefiniÃ§Ãµes de PreÃ§os",
            pricingOptions: "OpÃ§Ãµes de PreÃ§os",
            printSettings: "DefiniÃ§Ãµes de ImpressÃ£o",
            productPricing: "PreÃ§os de Produtos",
            qualityControlSettings: "DefiniÃ§Ãµes de Controlo de Qualidade",
            quickTint: "DefiniÃ§Ãµes de Quick Tint (Dispensa Manual)",
            rccConfig: "DefiniÃ§Ãµes RCC",
            rccConnection: "LigaÃ§Ã£o RCC",
            rccSettings: "DefiniÃ§Ãµes RCC",
            refillSettings: "DefiniÃ§Ãµes de Recarga",
            refillingLogic: "LÃ³gica de Recarga",
            registration: "Registo",
            searchSettings: "DefiniÃ§Ãµes de Procura",
            serverPlugins: "Plugins de Servidor",
            serviceActions: "AcÃ§Ãµes de ServiÃ§o",
            settings: "DefiniÃ§Ãµes",
            simplifiers: "Simplificador",
            singleActions: "AcÃ§Ãµes individuais",
            smartPurgeRules: "Regras de Purga Inteligente",
            softwareOptions: "OpÃ§Ãµes de Software",
            spectroSettings: "DefiniÃ§Ãµes de EspectrofotÃ³metro",
            statistics: "EstatÃ­sticas",
            switchToFrontdesk: "Mudar para Frontdesk",
            switchToFullRedlike: "Mudar para %{name}",
            switchToLight: "Mudar para %{name}",
            switchToMachine: "Mudar para MÃ¡quina",
            tabs: "Separadores e Menus Pop-Up",
            testBarcodes: "Teste de CÃ³digo de Barras",
            updateOptions: "OpÃ§Ãµes de ActualizaÃ§Ã£o",
            userManagemenet: "GestÃ£o de Utilizadores",
            visibleUnits: "Unidades VisÃ­veis"
        },
        navBar: {
            barcode: "CÃ³digo de Barras",
            help: "Ajuda",
            hideItems: "Ocultar Produtos / CatÃ¡logos"
        },
        notificationPanel: {
            noNotifications: "Sem novas notificaÃ§Ãµes"
        },
        tabBar: {
            closeActive: "Fechar activo",
            closeAll: "Fechar todos",
            closeAllExceptActive: "Fechar tudo excepto activo(s)",
            customFormula: "FÃ³rmula Personalizada",
            dispensingHistory: "HistÃ³rico de Dispensa",
            favorites: "Favoritos",
            formulaSearch: "Procurar FÃ³rmula",
            rewriteSettings: "Reescrever definiÃ§Ãµes locais"
        }
    },
    ordering: {
        assign: "Atribuir",
        assignment: "AtribuiÃ§Ã£o",
        createdDate: "Data de CriaÃ§Ã£o",
        finishDispensing: "Terminando Dispensa",
        foundInOrders: "Pedidos Encontrados",
        inactiveDatabase: "A fÃ³rmula Ã© proveniente de uma Base de Dados inactiva ou desconhecida %{0}",
        inactiveUnknownDatabase: "A fÃ³rmula Ã© proveniente de uma Base de Dados inactiva ou desconhecida",
        newOrderReceived: "Recebeu um novo pedido!",
        noOrderSelected: "Nenhum Pedido Seleccionado",
        release: "Libertar",
        status: {
            accepted: "aceite",
            canceled: "cancelado",
            created: "criado",
            done: "ConcluÃ­do",
            partlyDone: "Parcialmente ConcluÃ­do",
            preparing: "Em PreparaÃ§Ã£o",
            unknown: "desconhecido"
        }
    },
    partialUpdates: {
        applying: "A instalar as actualizaÃ§Ãµes parciais",
        cantBeUsedForYourDbVersion:
            "As actualizaÃ§Ãµes nÃ£o podem ser usadas para esta Base de Dados. Actualize usando o Helper.",
        newVersionWillBeInstalled:
            "Uma nova versÃ£o serÃ¡ instalada incluindo todas as actualizaÃ§Ãµes parciais disponÃ­veis.",
        noPartialUpdatesAvailable: "Sem ActualizaÃ§Ãµes Parciais disponÃ­veis",
        outOfDate: "Por actualizar",
        partialUpdates: "ActualizaÃ§Ãµes parciais",
        partialUpdatesArePreparing: "A preparar as actualizaÃ§Ãµes parciais",
        partialUpdatesAvailable: "ActualizaÃ§Ãµes Parciais disponÃ­veis!",
        preparedUpdatesMessage: "As seguintes actualizaÃ§Ãµes parciais estÃ£o prontas para serem instaladas",
        remindMeLater: "Lembrar-me em : %{time} minutos.",
        swOutOfDate: "A versÃ£o actual do software Ã©",
        updateAutomatically: "Se nÃ£o responder, a ActualizaÃ§Ã£o serÃ¡ inciada em : %{time} segundos.",
        updateToNewVersion: "Actualizar para a versÃ£o mais recente",
        updateWillTakeMoreTime: "A ActualizaÃ§Ã£o demorarÃ¡ mais tempo.",
        updatesApplied: "As actualizaÃ§Ãµes parciais foram instaladas com sucesso.",
        updating: "ActualizaÃ§Ã£o em Curso â¦"
    },
    posInfo: {
        address: "EndereÃ§o",
        contactName: "Nome de Contacto",
        contactPerson: "Pessoa de Contacto",
        identification: "IdentificaÃ§Ã£o",
        machineInformation: "InformaÃ§Ã£o da MÃ¡quina",
        pos: "Ponto de Venda (POS)",
        secondAddress: "EndereÃ§o Alternativo",
        shopIdentification: "IdentificaÃ§Ã£o da Loja",
        shopName: "Nome da Loja",
        url: "URL",
        zipCode: "CÃ³digo Postal"
    },
    priceTypeList: {
        priceBasePurchase: "PreÃ§o de Custo da Base",
        priceBaseSell: "PreÃ§o de Venda da Base",
        priceBaseSellFull: "PreÃ§o Total de Venda da Base",
        priceCntPurchase: "PreÃ§o de Custo dos Corantes",
        priceCntPurchaseByColorantName: "PreÃ§o de Custo para %{0} Corante",
        priceCntPurchaseByName: "PreÃ§o de Custo para Corantes por Nome",
        priceCntSell: "PreÃ§o de Venda de Corantes",
        priceCntSellByColorantName: "PreÃ§o de Venda para %{0} Corante",
        priceCntSellByName: "PreÃ§o de Venda de Corantes por Nome",
        priceCntSellFull: "PreÃ§o Total de Venda dos Corantes",
        priceCntSellFullByColorantName: "PreÃ§o Total de Venda para %{0} Corante",
        priceCntSellFullByName: "PreÃ§o Total de Venda de Corantes por Nome",
        priceGroupBarcode: "CÃ³digo de Barras do Grupo de PreÃ§o",
        priceMarginAll: "Margem para Todas as Embalagens",
        priceMarginPerPkg: "Margem para Uma Embalagem",
        priceSellPriceAll: "PreÃ§o de Venda para Todas as Embalagens",
        priceSellPricePerKg: "PreÃ§o de Venda por Quilograma",
        priceSellPricePerL: "PreÃ§o de Venda por Litro",
        priceSellPricePerPkg: "PreÃ§o de Venda por Embalagem",
        priceSurchargeAll: "Sobretaxa para Todas as Embalagens",
        priceSurchargePerPkg: "Sobretaxa por Embalagem",
        priceTintPurchaseAll: "PreÃ§o de Custo da Tintagem para Todas as Embalagens",
        priceTintPurchasePerPkg: "PreÃ§o de Custo da Tintagem por Embalagem",
        priceTintSellFullAll: "PreÃ§o de Venda Completo da Tintagem para Todas as Embalagens",
        priceTintSellFullAllPerPackage: "PreÃ§o de Venda Completo da Tintagem por Embalagem",
        priceTotalPurchaseAll: "PreÃ§o de Custo Total para Todas as Embalagens",
        priceTotalPurchasePerKg: "PreÃ§o de Custo Total por Quilograma",
        priceTotalPurchasePerL: "PreÃ§o de Custo Total por Litro",
        priceTotalPurchasePerPkg: "PreÃ§o de Custo Total por Embalagem",
        priceTotalSellFullAll: "PreÃ§o Total de Venda Completo para Todas as Embalagens",
        priceTotalSellFullPerKg: "PreÃ§o Total de Venda por Quilograma",
        priceTotalSellFullPerLiter: "PreÃ§o Total de Venda por Litro",
        priceTotalSellFullPerPackage: "PreÃ§o Total de Venda por Embalagem"
    },
    pricing: {
        allBases: "Todas as Bases",
        allPackages: "Todos as Embalagens",
        backup: "Backup",
        basesOfProduct: "Bases de %{productName}",
        colorantPricing: "PreÃ§os de Corantes",
        export: "ExportaÃ§Ã£o",
        import: "ImportaÃ§Ã£o",
        packagePricing: "PreÃ§os de Embalagens",
        packageSurcharge: "Sobretaxa de Embalagem",
        packages: "Embalagens",
        packagesOfProduct: "Embalagens de %{productName}",
        posCoeficient: "Coeficiente do POS",
        priceGroupPricePerLiter: "Grupo de PreÃ§o - PreÃ§o por litro",
        priceGroups: "Grupos de PreÃ§o",
        pricePerLiter: "PreÃ§o por Litro",
        productPricing: "PreÃ§os de Produto",
        purchasePrice: "PreÃ§o de Custo",
        purchasePricePerLiter: "PreÃ§o de Custo por Litro",
        sellPrice: "PreÃ§o de Venda",
        surcharge: "Sobretaxa"
    },
    print: {
        adminRightsRequired: "Os direitos de administraÃ§Ã£o sÃ£o necessÃ¡rios para editar ou criar um novo modelo.",
        allowAutomaticPrint: "Permitir impressÃ£o automÃ¡tica",
        allowPrintAfterDispensing: "Permitir a impressÃ£o apÃ³s a dispensa",
        allowPrintBeforeDispensing: "Permitir a impressÃ£o antes da dispensa",
        automaticPrint: "ImpressÃ£o AutomÃ¡tica",
        choosePrinter: "Selecionar Impressora",
        chooseSettings: "Editar DefiniÃ§Ãµes",
        chooseTemplate: "Seleccionar Tamanho da Etiqueta",
        copies: "CÃ³pias",
        createTemplate: "Criar Etiqueta",
        createTemplateHint: "Crie um novo modelo a partir do zero. Guarde-o na pasta dos modelos e reinicie o RCC.",
        defaultPrinter: "Impressora Predefinida",
        defaultSettings: "DefiniÃ§Ãµes PadrÃ£o",
        defaultTemplate: "Etiqueta Predefinida",
        editTemplate: "Editar Etiqueta",
        editTemplateHint: "Editar %{name}. As alteraÃ§Ãµes serÃ£o visÃ­veis apÃ³s o reinÃ­cio do RCC.",
        noEditTemplate: "Nenhuma Etiqueta para editar",
        noPrinterSelected: "Nenhuma Impressora Seleccionada",
        noPrintersAvailable: "Nenhuma impressora disponÃ­vel",
        noTemplateSelected: "Nenhuma Etiqueta Seleccionada",
        noTemplatesAvailable: "Nenhuma Etiqueta DisponÃ­vel",
        numberOfCopies: "NÃºmero de CÃ³pias",
        openTemplateEditor: "Abrir Editor de Etiquetas",
        printAfterDispensing: "Imprimir depois de dispensar",
        printAsImage: "Imprimir como imagem",
        printBeforeDispensing: "Imprimir antes de dispensar",
        printOnRequest: "Imprimir a pedido",
        printOptions: "OpÃ§Ãµes de ImpressÃ£o",
        printPagesAfterDispensing: "NÃºmero de CÃ³pias de Etiquetas - ApÃ³s Dispensa",
        printPagesBeforeDispensing: "NÃºmero de CÃ³pias de Etiquetas - Antes da Dispensa",
        printPreview: "PrÃ©-visualizaÃ§Ã£o da ImpressÃ£o",
        printSettings: "DefiniÃ§Ãµes de ImpressÃ£o",
        printTaskLinkVariable: "Tarefa com ligaÃ§Ã£o a uma variÃ¡vel",
        printVariable: "Imprimir VariÃ¡vel",
        printerName: "Nome da Impressora",
        printerOptions: "OpÃ§Ãµes de ImpressÃ£o",
        printerSettings: "DefiniÃ§Ãµes da Impressora",
        quickTintTemplate: "Modelo de Quick Tint",
        setDefaultPrinter: "Definir Impressora PrÃ©-Definida",
        setDefaultTemplate: "Definir Etiqueta PadrÃ£o",
        setQuickTintTemplate: "Definir Etiqueta Quick Tint (Dispensa Manual)",
        showPreviewDialogBeforePrint: "Mostrar diÃ¡logo de prÃ©-visualizaÃ§Ã£o antes da impressÃ£o",
        template: "Etiqueta",
        templateName: "Nome da Etiqueta",
        templateSettings: "DefiniÃ§Ãµes da Etiqueta"
    },
    printTemplate: {
        baseCode: "CÃ³digo da Base",
        baseName: "Nome da Base",
        bfs: "BFS",
        colorantType: "Tipo de corante",
        customerCity: "Cidade do Cliente",
        customerEmail: "E-mail do Cliente",
        customerName: "Nome do Cliente",
        customerPhone: "Telefone do Cliente",
        customerStreet: "Rua do Cliente",
        customerZipCode: "CÃ³digo Postal do Cliente",
        destinationOfUse: "Destino de utilizaÃ§Ã£o",
        infoBfsGrade: "Classe BFS",
        orderQrCode: "CÃ³digo QR",
        packageOrderCount: "Contagem de pedidos de embalagem",
        posAddress: "POS - EndereÃ§o 1",
        posAddressSecond: "POS - EndereÃ§o 2",
        posCity: "POS - Cidade",
        posContact: "POS - Contacto",
        posEmail: "POS - Correio ElectrÃ³nico",
        posPhone: "POS - Telefone ",
        posUrl: "POS -  URL",
        posZipCode: "POS - CÃ³digo Postal",
        priceBasePurchaseWithTax: "PreÃ§o de custo da base com IVA",
        priceBaseSellWithTax: "PreÃ§o de Venda da base com IVA",
        priceCntPurchaseWithTax: "PreÃ§o de custo dos colorantes com IVA",
        priceCntTotalSellWithTax: "PreÃ§o de Venda dos corantes com IVA",
        priceMarginAllWithTax: "Margem para todos as embalagens com IVA",
        priceMarginPerPkgWithTax: "Margem para uma embalagem com IVA",
        priceSellPriceAllWithTax: "PreÃ§o de Venda para todas as embalagens com IVA",
        priceSellPricePerKgWithTax: "PreÃ§o de Venda por quilograma com IVA",
        priceSellPricePerLWithTax: "PreÃ§o de Venda por litro com IVA",
        priceSellPricePerPkgWithTax: "PreÃ§o de Venda por embalagem com IVA",
        priceSurchargeAllWithTax: "Sobretaxa para todos as embalagens com IVA",
        priceSurchargePerPkgWithTax: "Sobretaxa por embalagem com IVA",
        priceTintPurchaseAllWithTax: "PreÃ§o de custo da tintagem para todas as embalagens com IVA",
        priceTintPurchasePerPkgWithTax: "PreÃ§o de custo da tintagem por embalagem com IVA",
        priceTotalPurchaseAllWithTax: "PreÃ§o de custo total para todas as embalagens com IVA",
        priceTotalPurchasePerKgWithTax: "PreÃ§o de custo total por quilograma com IVA",
        priceTotalPurchasePerLWithTax: "PreÃ§o de custo total por litro com IVA",
        priceTotalPurchasePerPkgWithTax: "PreÃ§o de custo total por embalagem com IVA",
        productAltName: "Produto",
        recipeInline: "FÃ³rmula"
    },
    products: {
        bases: "Bases",
        numberOfProducts: "NÃºmero de Produtos",
        packagesFor: "Embalagens para",
        sizeOfPackage: "Formato da Embalagem"
    },
    purgeModal: {
        purgeAll: "Purgar todos",
        purgeAllChannels: "Purgar - Todos",
        purgeVolume: "Volume de Purga",
        startPurge: "Comece a Purgar"
    },
    qualityControl: {
        darker: "Mais Escuro",
        dispensedMeasuredFormula: "FÃ³rmula dispensada atravÃ©s de mediÃ§Ã£o",
        lighter: "Mais Claro",
        measureDispensedFormula: "MeÃ§a a fÃ³rmula dispensada para cÃ¡lculo do Delta E",
        moreBlue: "Mais Azul",
        moreGreen: "Mais Verde",
        moreRed: "Mais Vermelho",
        moreYellow: "Mais Amarelo",
        pleaseContinueToFormulaCorrection: "Avance para a CorrecÃ§Ã£o da FÃ³rmula",
        qualityControlFailed: "Reprovado pelo Controlo de Qualidade",
        qualityControlPassed: "Aprovado pelo Controlo de Qualidade"
    },
    quickTint: {
        dispensingInProgress: "Dispensa em Curso â¦",
        dispensingIsNotAvailable: "Dispensa NÃ£o DisponÃ­vel",
        machineNotConnected: "A MÃ¡quina nÃ£o estÃ¡ ligada",
        noColorantsSelected: "NÃ£o foram selecionados Corantes",
        noPrinterAvailable: "A impressÃ£o nÃ£o pode ser realizada porque nÃ£o hÃ¡ impressora disponÃ­vel.",
        noTemplateAvailable: "A impressÃ£o nÃ£o pode ser realizada, uma vez que nÃ£o existe um modelo disponÃ­vel.",
        overMaxCanisterSize: "Uma ou mais quantidades de corantes sÃ£o invÃ¡lidas"
    },
    quickTintSettings: {
        alphabetically: "Alfabeticamente",
        byCanister: "Por DepÃ³sito",
        closeAfterDispensing: "Fechar apÃ³s a dispensa",
        closeBeforeDispensing: "Fechar antes da dispensa",
        quickTintSettings: "DefiniÃ§Ãµes Quick Tint",
        sorting: "OrdenaÃ§Ã£o",
        windowClosingRules: "Regras de Fecho de Janelas"
    },
    rccButtons: {
        abort: "cancelar",
        all: "todos",
        cancel: "cancelar",
        continue: "continuar",
        help: "ajuda",
        ignore: "ignorar",
        no: "nÃ£o",
        noToAll: "nÃ£o a todos",
        ok: "ok",
        postpone: "adiar",
        resume: "retomar",
        retry: "tente de novo",
        skip: "saltar",
        yes: "sim",
        yesToAll: "sim a todos"
    },
    rccDialog: {
        98: "Verifique a Base %{0} com o cÃ³digo de barras.",
        99: "Adicionar a Base %{0} e confirme (click OK)",
        100: "Dispensador em Estado de Erro ... Reniciar Erros?",
        101: "Dispensador em Estado de Erro ... ImpossÃ­vel AvanÃ§ar!",
        102: "A ReinicializaÃ§Ã£o Falhou... ImpossÃ­vel AvanÃ§ar!",
        103: "A fÃ³rmula contÃ©m corante invÃ¡lido: %{0}",
        104: "A fÃ³rmula contÃ©m corantes invÃ¡lidos: %{0}",
        105: "Corante: %{0} estÃ¡ sob nÃ­vel de alerta",
        106: "Corantes: %{0} estÃ£o sob nÃ­vel de alerta",
        107: "Corante: %{0} estÃ¡ abaixo do nÃ­vel crÃ­tico",
        108: "Corantes: %{0} estÃ£o abaixo do nÃ­vel crÃ­tico",
        109: "Colocar Embalagem",
        110: "Coloque a Embalagem da Base: %{0} para fÃ³rmula: %{1}",
        111: "Remover Embalagem",
        112: "Perfurar a Embalagem ?",
        113: "ReinicializaÃ§Ã£o de erros â¦  .",
        114: "Prateleira em movimento â¦  .",
        115: "A Perfurar a Embalagem ...  .",
        116: "A Dispensar FÃ³rmula %{0},  |Embalagem: %{1} de %{2}|Produto: %{3}|Base: %{4}|Formato: %{5}",
        117: "A Dispensar FÃ³rmula %{0},  |Embalagem: %{1} de %{2}|Produto: %{3}|Base: %{4}|Formato: %{5}",
        118: "A Dispensar â¦  .|Embalagem: %{0} de %{1}",
        119: "A Dispensar â¦  .|Embalagem: %{0} de %{1}",
        120: "A Cancelar a Dispensa â¦  .",
        121: "Valide o CÃ³digo de Barras da Embalagem",
        122: "Valide o CÃ³digo de Barras da Base |Produto: %{0}|Base: %{1}|Formato: %{2}",
        123: "A Dispensa foi cancelada ... Retomar a Dispensa ?",
        124: "Ocorreu um erro no Dispensador %{0} : %{1}. Retomar a Dispensa ?",
        125: "Certifique-se de que a embalagem anteriormente utilizada Ã© recolocada",
        126: "Certifique-se de utilizar uma nova embalagem. A Dispensa serÃ¡ processada do zero.",
        127: "Corante: %{0} estÃ¡ abaixo da quantidade mÃ­nima de dispensa. Continuar apesar deste aviso?",
        128: "Corantes: %{0} estÃ£o abaixo da quantidade mÃ­nima de distribuiÃ§Ã£o. Continuar apesar deste aviso?",
        129: "A fÃ³rmula seleccionada quebra a regra de Sobre Enchimento. Quantidade Total de Corantes: %{0} %{1}. Quantidade MÃ¡xima Permitida de Corantes: %{2} %{3}. Continuar apesar deste aviso?",
        130: "O Dispensador estÃ¡ em estado de erro ... Reiniciar Erros?",
        131: "O Dispensador estÃ¡ em estado de erro ... ImpossÃ­vel AvanÃ§ar.",
        132: "A reinicializaÃ§Ã£o falhou ... ImpossÃ­vel AvanÃ§ar.",
        133: "FÃ³rmula para purga vazia ou insuficiente ... ImpossÃ­vel AvanÃ§ar.",
        134: "FÃ³rmula para purga contÃ©m items que nÃ£o podem ser purgados ... AvanÃ§ar mesmo assim ?",
        135: "Coloque a embalagem de purga ",
        136: "Remova a embalagem de purga",
        137: "ReinicializaÃ§Ã£o de erros ...",
        138: 'Prateleira em movimento â¦ "',
        139: "Purgando â¦  ",
        140: "Purgando â¦  ",
        141: "Purga cancelada â¦ ",
        142: "A embalagem para a purga em falta ... Verifique se a embalagem estÃ¡ bem colocada.",
        143: "FÃ³rmula para purga contÃ©m items que nÃ£o podem ser purgados ... AvanÃ§ar mesmo assim ?",
        144: "Coloque a embalagem de purga ",
        145: "A Preparar â¦ ",
        146: "A Terminar â¦ ",
        150: "Limpeza em curso â¦ ",
        151: "Limpeza em curso â¦ ",
        152: "Limpeza cancelada! â¦ ",
        160: "RecirculaÃ§Ã£o em curso â¦ ",
        161: "RecirculaÃ§Ã£o em curso â¦ ",
        162: "RecirculaÃ§Ã£o cancelada! â¦ ",
        170: "AgitaÃ§Ã£o em curso â¦ ",
        171: "AgitaÃ§Ã£o em curso â¦ ",
        172: "AgitaÃ§Ã£o cancelada! â¦ ",
        180: "LigaÃ§Ã£o ao Dispensador em curso ...",
        181: "LigaÃ§Ã£o ao Dispensador nÃ£o pode ser estabelecida %{0}: %{1}",
        182: "LigaÃ§Ã£o ao Dispensador nÃ£o pode ser estabelecida. Ver ficheiros de registo para mais informaÃ§Ãµes.",
        183: "O Dispensador tem em falta o Corante: %{0} que estÃ¡ definido na sua Base de Dados.",
        184: "O Dispensador tem em falta os Corantes: %{0} que estÃ£o definidos na sua Base de Dados.",
        185: "LigaÃ§Ã£o ao Dispensador a fechar â¦ ",
        190: "Feche a janela de serviÃ§o para continuar",
        200: "ReinicializaÃ§Ã£o em curso â¦ ",
        201: "ReposiÃ§Ã£o de Hardware â¦ ",
        202: "InicializaÃ§Ã£o em curso â¦ ",
        203: "ReposiÃ§Ã£o de Erros em curso â¦ ",
        205: "Autocap a abrir  â¦ ",
        206: "Autocap a fechar â¦ ",
        207: "Autocap em movimento â¦ ",
        210: "PerfuraÃ§Ã£o em curso â¦ ",
        211: "LigaÃ§Ã£o em curso â¦ ",
        215: "Prateleira a subir â¦ ",
        216: "Prateleira a descer â¦ ",
        217: "Prateleira em movimento â¦ ",
        220: "Mesa em movimento para posiÃ§Ã£o de recarga: %{0} â¦ ",
        221: "Mesa em movimento para a posiÃ§Ã£o inicial â¦ ",
        222: "Mesa em movimento â¦ ",
        230: "Dispensador ocupado â¦ ",
        240: "Por favor, recarregue o depÃ³sito %{0}",
        241: "Por favor, recarregue o depÃ³sito %{0}",
        242: "A posicionar o depÃ³sito: %{0} (%{1}) para a posiÃ§Ã£o de recarga.",
        243: "Por favor, recarregue o depÃ³sito %{0} usando cÃ³digo de barras.",
        244: "Por favor, recarregue o depÃ³sito %{0} usando cÃ³digo de barras.",
        250: "Retire o depÃ³sito da escova, limpe-o e encha-o com Ã¡gua conforme instruÃ§Ãµes.",
        251: "Volte a colocar o depÃ³sito da escova.",
        254: "Autocap a abrir â¦",
        255: "Autocap, limpe-o conforme instruÃ§Ãµes.",
        256: "Verifique se a limpeza estÃ¡ concluÃ­da e se o Autocap estÃ¡ de novo na posiÃ§Ã£o correta.",
        257: "Autocap a fechar â¦",
        260: "Retire e limpe a placa do interruptor.",
        261: "Reponha a placa do interruptor.",
        265: "Limpe a mÃ¡quina com um pano macio e remova corantes ou outros lÃ­quidos derramados.",
        266: "Confirmar quando concluÃ­do.",
        270: "Encha o depÃ³sito de Ã¡gua do humidificador e confirme quando concluÃ­do.",
        271: "Encha o depÃ³sito de Ã¡gua do humidificador e confirme quando concluÃ­do.",
        272: "O nÃ­vel da Ã¡gua ainda estÃ¡ baixo, verifique novamente.",
        273: "O nÃ­vel da Ã¡gua ainda estÃ¡ baixo, verifique novamente.",
        274: "Verifique o nÃ­vel da Ã¡gua no depÃ³sito do humidificador e reabasteÃ§a se necessÃ¡rio.",
        275: "Aguarde â¦",
        280: "ReinicializaÃ§Ã£o do Computador em curso ...",
        281: "Encerramento do Computador em curso â¦",
        300: "A embalagem da Base estÃ¡ em falta â¦ verifique se a embalagem estÃ¡ colocada correctamente.",
        301: "A Preparar â¦ ",
        302: "A Terminar â¦ ",
        303: "A fÃ³rmula nÃ£o pode ser dispensada porque contÃ©m Corante: %{0} que estÃ¡ acima da quantidade mÃ¡xima de dispensa definida para a embalagem.",
        304: "A fÃ³rmula nÃ£o pode ser dispensada porque contÃ©m Corantes: %{0} que estÃ£o acima das quantidades mÃ¡ximas de dispensa definidas para as embalagens.",
        305: "Corante: %{0} nÃ£o pode ser dispensado de uma sÃ³ vez, quer dividir a fÃ³rmula?",
        306: "Corantes: %{0} nÃ£o podem ser dispensados de uma sÃ³ vez, quer dividir a fÃ³rmula?",
        307: "Corante: %{0} nÃ£o serÃ¡ dispensado pelo Dispensador, quer continuar e adicionÃ¡-lo manualmente?",
        308: "Corantes: %{0} nÃ£o serÃ£o dispensados pelo Dispensador, quer continuar e adicionÃ¡-los manualmente?",
        309: "A fÃ³rmula seleccionada estÃ¡ vazia â¦ Utilize a embalagem da Base tal e qual.",
        310: "Nenhum corante serÃ¡ dispensado, prepare a embalagem da Base para adiÃ§Ã£o manual de corantes.",
        311: "Retire a embalagem da Base e prepare-a para adiÃ§Ã£o manual de corantes.",
        312: "Adicione manualmente %{0} %{1} de Corante: %{2}, confirme quando concluÃ­do.",
        313: "Dispensar fÃ³rmula manual",
        314: "A fÃ³rmula seleccionada quebra a regra de Sobre Enchimento. Quantidade Total de Corantes: %{0} %{1}. Quantidade MÃ¡xima Permitida de Corantes: %{2} %{3}. Continuar apesar deste aviso?",
        315: "Leia ou digite o cÃ³digo UFI da base inscrito na lata",
        316: "Digitalize ou digite o cÃ³digo UFI da embalagem da Base|Produto: %{0}|Base: %{1}|Formato: %{2}",
        317: "Prepare o corante: %{0} para adiÃ§Ã£o manual, confirme quando concluir.",
        318: "Prepare os corantes: %{0} para adiÃ§Ã£o manual, confirme quando concluir.",
        319: "Adicione o corante manualmente: %{0}, confirme quando concluir.",
        320: "Adicione os corantes manualmente: %{0}, confirme quando concluir.",
        400: "A tarefa de lavagem automÃ¡tica Ã© iniciada.",
        401: "A purga automÃ¡tica serÃ¡ iniciada ",
        405: "O suporte de escova deve ser reparado.",
        406: "O depÃ³sito da escova requer manutenÃ§Ã£o.",
        410: "A manutenÃ§Ã£o automÃ¡tica da tampa serÃ¡ iniciada.",
        411: "A manutenÃ§Ã£o automÃ¡tica da tampa serÃ¡ iniciada.",
        415: "A placa do interruptor precisa de ser limpa.",
        416: "A placa do interruptor precisa de ser limpa.",
        420: "O Dispensador precisa de ser limpo.",
        421: "O Dispensador precisa de ser limpo.",
        425: "O reabastecimento dos depÃ³sitos serÃ¡ iniciado.",
        426: "O reabastecimento dos depÃ³sitos serÃ¡ iniciado.",
        430: "ReinÃ­cio do computador agendado",
        431: "ReinÃ­cio do computador foi agendado",
        435: "Encerramento do computador programado.",
        436: "Encerramento do computador programado.",
        440: "Limpeza do Dispensador agendada.",
        441: "Limpeza do Dispensador agendada.",
        445: "RecirculaÃ§Ã£o do Dispensador agendada.",
        446: "RecirculaÃ§Ã£o do Dispensador agendada.",
        450: "AgitaÃ§Ã£o do Dispensador agendada.",
        451: "AgitaÃ§Ã£o do Dispensador agendada.",
        990: "Ocorreu um erro no Dispensador %{0}: %{1}. Tentar novamente ?",
        991: "Ocorreu um erro interno: %{0}",
        200000001: "Coloque uma embalagem",
        200000002: "Remova a embalagem",
        200000003: "'Quantidade para ''%{0}'' abaixo do valor mÃ­nimo de dispensa â¦ AvanÃ§ar Ã  sua responsabilidade ?'",
        200000004: "Recarregar '%{0}'"
    },
    rccDriverSettings: {
        databasePath: "Caminho para a Base de Dados",
        dispenser: "Dispensador",
        dispenserConfigurationFile: "Ficheiro de definiÃ§Ã£o do Dispensador",
        driverPath: "Caminho para o Driver",
        extensionPath: "Caminho para a ExtensÃ£o",
        folder: "Pasta",
        formulaPath: "Caminho para a FÃ³rmula",
        host: "AnfitriÃ£o",
        iddPath: "Ficheiro de definiÃ§Ã£o IDD",
        italtintoPath: "Caminho para DefiniÃ§Ã£o Italtinto",
        lldPath: "DirectÃ³rio raiz HLD",
        machineType: "Tipo de mÃ¡quina",
        noMachineAvailable: "Nenhuma mÃ¡quina disponÃ­vel",
        protocolVersion: "VersÃ£o do protocolo",
        rccDriverSettings: "DefiniÃ§Ãµes do Driver",
        resultPath: "Caminho para Resultado",
        save: "Guardar DefiniÃ§Ãµes",
        saveSettingsWarning: "AtenÃ§Ã£o! alteraÃ§Ãµes nesta secÃ§Ã£o podem causar mau funcionamento do Dispensador.",
        serviceSwPath: "Caminho para o ServiÃ§o de Software",
        simulationPath: "Caminho para SimulaÃ§Ã£o"
    },
    rccMachineSettings: {
        allowManualColorantAddition: "Permitir a adiÃ§Ã£o manual de corantes",
        ask: "Pergunte a",
        canHandlingOptions: "OpÃ§Ãµes de manuseamento de embalagens",
        checkCanBeforeDispense: "Verifique a embalagem antes da Dispensa",
        checkOverfill: "Verifique o sobre enchimento",
        colorantBatchNumbers: "NÃºmeros de lote de corantes",
        colorantPackageValidation: "Somente para validaÃ§Ã£o de embalagens de corantes",
        disable: "Desabilitar",
        dispenseInvalidColorants: "Dispensar corantes invÃ¡lidos",
        dispensingOptions: "OpÃ§Ãµes de Dispensa",
        enable: "Habilitar",
        enableUserIdentification: "IdentificaÃ§Ã£o do Utilizador",
        fullValidation: "ValidaÃ§Ã£o completa",
        machineAccuracyWarning: "Aviso sobre a precisÃ£o da mÃ¡quina",
        machineOptions: "OpÃ§Ãµes de mÃ¡quina",
        machineUnit: "Unidade da mÃ¡quina",
        minimalDispenseAmount: "Quantidade mÃ­nima de Dispensa",
        placeCanSensor: "Posicione o sensor da embalagem",
        placeCanSensorDelay: "Posicione  o atraso do sensor de embalagem",
        rccMachineSettings: "DefiniÃ§Ãµes da MÃ¡quina",
        refillBarcodeValidation: "ValidaÃ§Ã£o de cÃ³digo de barras da recarga de corante",
        refillBarcodeValidationCanisterAndColorant: "Valida o depÃ³sito e a embalagem de corante",
        refillBarcodeValidationColorant: "Valida apenas a embalagem de corante",
        refillSettings: "DefiniÃ§Ãµes de Recarga",
        removeCanSensor: "Remova a embalagem",
        removeCanSensorDelay: "Remova o atraso do sensor da embalagem",
        save: "Guardar DefiniÃ§Ãµes",
        sec: "seg.",
        skipPlaceCanDialog: "Ignorar diÃ¡logo de posicionamento da embalagem",
        skipRemoveCanDialog: "Ignorar diÃ¡logo de remoÃ§Ã£o da embalagem",
        splitFormula: "FÃ³rmula dividida",
        tmcEnabled: "Activar o TMC",
        ufiCode: "CÃ³digo UFI",
        validateBarcodeBaseCan: "ValidaÃ§Ã£o do cÃ³digo de barras da Base",
        validateBarcodeRefill: "ValidaÃ§Ã£o de cÃ³digo de barras da recarga de Corante",
        validateColorantsDuringInit: "Validar corantes durante a inicializaÃ§Ã£o"
    },
    rccPanel: {
        actionsRunningOnDispenser: "Existem algumas acÃ§Ãµes em execuÃ§Ã£o na mÃ¡quina",
        addLevel: "NÃVEL DE ADIÃÃO",
        addManually: "Adicionar manualmente",
        barcodeNotSet: "O DepÃ³sito %{colorantName} (%{canisterName}) nÃ£o tem um cÃ³digo de barras atribuÃ­do.",
        cancel: "CANCELAR",
        dispenseFormula: "FÃ³rmula Dispensada",
        dispenserIdle: "A mÃ¡quina estÃ¡ inactiva",
        dispenserIsBusy: "A mÃ¡quina estÃ¡ ocupada",
        dispenserIsIdle: "A mÃ¡quina estÃ¡ inactiva",
        dispenserIsReady: "A mÃ¡quina estÃ¡ pronta para outras tarefas",
        dispensingFormula: "FÃ³rmula em Dispensa â¦",
        errorCode: "CÃ³digo de erro",
        explanation: "ExplicaÃ§Ã£o",
        fillToMax: "Recarregar atÃ© ao mÃ¡ximo",
        finished: "ConcluÃ­do",
        inProgress: "Em curso â¦",
        machineIsReady: "A mÃ¡quina estÃ¡ pronta",
        moveToFill: "Mover para recarregar",
        noMachineDialog: "Nenhuma mÃ¡quina estÃ¡ ligada",
        of: "de",
        packageSize: "Formato",
        placeBaseCan: "Posicione a embalagem da Base",
        pleaseCheckYourMachineConnection: "Por favor, verifique a ligaÃ§Ã£o da sua mÃ¡quina.",
        pleaseRefill: "Por favor, recarregue",
        solution: "SoluÃ§Ã£o",
        subErrors: "Sub erros",
        timeToEnd: "Tempo atÃ© ao final",
        tintingFormula: "Dispensa da FÃ³rmula",
        tintingPleaseWait: "D I S P E N S A    E M    C U R S O . . . ",
        validateBaseCan: "Valide embalagem da Base",
        waiting: "Em espera â¦"
    },
    rccSettigns: {
        rccSettigns: "LigaÃ§Ã£o RCC",
        rccUrl: "RCC URL"
    },
    rccSpectroDialog: {
        100: "Ligue-se ao seu dispositivo atravÃ©s de Bluetooth. Certifique-se de que tem o Bluetooth activado e de que o seu instrumento estÃ¡ ligado.",
        101: "O instrumento nÃ£o foi detectado. Tentar novamente ?",
        110: "Certifique-se de que o Nano estÃ¡ ligado e prima o botÃ£o do instrumento para dar inÃ­cio Ã  inicializaÃ§Ã£o",
        111: "Nano nÃ£o foi detectado. Tentar novamente ?",
        112: "Desligue o Nano, espere 10 segundos, ligue-o novamente e continue",
        120: "Ligando-se ao seu dispositivo â¦  .",
        121: "O instrumento nÃ£o foi detectado. Tentar novamente ?",
        200: "Coloque o instrumento sobre o mosaico de calibraÃ§Ã£o PRETO e prossiga ou prima a tecla do instrumento",
        201: "Coloque o instrumento sobre o mosaico de calibraÃ§Ã£o PRETO e prossiga",
        202: "Coloque o instrumento sobre o mosaico de calibraÃ§Ã£o PRETO e prima a tecla do instrumento",
        205: "Coloque o instrumento sobre o mosaico de calibraÃ§Ã£o BRANCO e prossiga ou prima a tecla do instrumento",
        206: "Coloque o instrumento sobre o mosaico de calibraÃ§Ã£o BRANCO e prossiga",
        207: "Coloque o instrumento sobre o mosaico de calibraÃ§Ã£o BRANCO e prima a tecla do instrumento",
        210: "Coloque o instrumento sobre o mosaico de DIAGNÃSTICO e prossiga ou prima a tecla do instrumento",
        211: "Coloque o instrumento sobre o mosaico de DIAGNÃSTICO e prossiga",
        212: "Coloque o instrumento sobre o mosaico de DIAGNÃSTICO e prima a tecla do instrumento",
        215: "Feche a tampa do instrumento e prossiga ou prima a tecla do instrumento",
        216: "Feche a tampa do instrumento e prossiga",
        217: "Feche a tampa do instrumento e prima o botÃ£o do instrumento",
        220: "Coloque o instrumento sobre o mosaico ZERO e prossiga ou prima a tecla do instrumento",
        221: "Coloque o instrumento sobre o mosaico ZERO e prossiga",
        222: "Coloque o instrumento sobre o mosaico ZERO e prima a tecla do instrumento",
        224: "Coloque o instrumento no bloco de calibraÃ§Ã£o e prossiga ou prima a tecla do instrumento",
        225: "Coloque o instrumento no bloco de calibraÃ§Ã£o e prossiga",
        226: "Coloque o instrumento no bloco de calibraÃ§Ã£o e prima a tecla do instrumento",
        227: "Coloque o instrumento no bloco de calibraÃ§Ã£o e prima a tecla do instrumento",
        295: "Termine a calibraÃ§Ã£o na janela do Driver.",
        296: "O instrumento nÃ£o estÃ¡ ligado â¦ Ligar agora ?",
        297: "CalibraÃ§Ã£o em preparaÃ§Ã£o â¦  .",
        298: "CalibraÃ§Ã£o em curso â¦  .",
        299: "Finalizando a CalibraÃ§Ã£o â¦  .",
        300: "Coloque o instrumento sobre a amostra e prossiga ou prima a tecla do instrumento",
        301: "Coloque o instrumento sobre a amostra e prossiga",
        302: "Coloque o instrumento sobre a amostra e prima a tecla do instrumento",
        303: "Instrumento nÃ£o calibrado â¦ AvanÃ§ar com a calibraÃ§Ã£o?",
        304: "O instrumento nÃ£o estÃ¡ ligado â¦ Ligar agora ?",
        390: "Seleccionar Modo de MediÃ§Ã£o",
        395: "Termine a mediÃ§Ã£o na janela do Driver.",
        397: "MediÃ§Ã£o em preparaÃ§Ã£o â¦  .",
        398: "MediÃ§Ã£o em curso â¦  .",
        399: "Finalizando  a MediÃ§Ã£o ...  .",
        498: "A transferir a mediÃ§Ã£o â¦  .",
        499: "A transferir todas as mediÃ§Ãµes â¦  .",
        900: "Ocorreu erro no instrumento %{0} : %{1}. Tentar novamente ?",
        901: "Ocorreu um erro interno: %{0}"
    },
    rccSpectroSettings: {
        DatacolorColorReader:
            "O computador tem de ter ligaÃ§Ã£o Bluetooth. O espectrofotÃ³metro tem de ser emparelhado com o computador. Ã necessÃ¡rio o Windows 10 com actualizaÃ§Ã£o automÃ¡tica de 2018.",
        DatacolorSilent:
            "Quando se usa o modo Silencioso, as janelas Datacolor sÃ£o mostradas directamente em %{name}. Nestas janelas, os parÃ¢metros espectrais nÃ£o podem ser alterados.",
        DatacolorUseDiagnosticTile: "A utilizaÃ§Ã£o do mosaico de DIAGNÃSTICO melhora a qualidade da mediÃ§Ã£o.",
        comPort: "Porta COM",
        diagnosticTile: "Utilize o mosaico de DIAGNÃSTICO Datacolor",
        measureModes: "Modos de mediÃ§Ã£o",
        measureModesOrder: "Ordem dos modos de mediÃ§Ã£o",
        model: "Modelo",
        noSpectroAvailable: "Sem espectrofotÃ³metros disponÃ­veis",
        rccSpectroSettings: "DefiniÃ§Ãµes do EspectrofotÃ³metro",
        save: "Guardar DefiniÃ§Ãµes",
        silent: "Datacolor Silencioso",
        simulationPath: "Caminho p/Simulador",
        spectroType: "EspectrofotÃ³metro Mod",
        useProfiledValues: "Utilizar valores perfilados"
    },
    recirculateChannels: {
        recirculateAllChannels: "Recircular todos os DepÃ³sitos",
        recirculateChannels: "RecirculaÃ§Ã£o - Individual",
        recirculatingSpeed: "Velocidade de RecirculaÃ§Ã£o",
        recirculatingTime: "Tempo de RecirculaÃ§Ã£o",
        startRecirculating: "Iniciar RecirculaÃ§Ã£o"
    },
    redlikeLight: {
        finishPreviousSteps: "Por favor, termine os passos anteriores",
        searchBySpectro: "Procurar por EspectrofotÃ³metro",
        searchFormula: "Procurar FÃ³rmula",
        selectBase: "Seleccione a Base",
        selectColor: "Seleccionar  Cor",
        selectCustomer: "Seleccionar Cliente",
        selectFandeck: "Seleccionar CatÃ¡logo",
        selectPackage: "Seleccionar Embalagem",
        selectProduct: "Seleccionar Produto",
        startSelectFandeck: "Comece por seleccionar o CatÃ¡logo",
        startSelectProduct: "Comece por seleccionar o Produto",
        stepByStepProgress: "Pode prosseguir passo a passo",
        typeHereToSearch: "Digite aqui para procurar",
        typeToFilter: "Tipo a filtrar"
    },
    restartModal: {
        computerNeedsRestart: "O computador precisa de ser reiniciado!",
        notCompletelyTranslated:
            "A mudanÃ§a de idioma requer o reinÃ­cio do software. Algumas partes do software podem nÃ£o ser traduzidas completamente neste momento.",
        restartIsRequired: "Ã necessÃ¡rio reiniciar o software apÃ³s as alteraÃ§Ãµes terem sido realizadas.",
        softwareNeedsRestart: "%{name} Requer reinÃ­cio!"
    },
    searchPanel: {
        basePlaceholder: "ou digite um Nome para a Base",
        baseStartPlaceholder: "Comece por digitar o Nome da Base",
        colorCodeNamePlaceholder: "or type a formula code/name",
        colorCodeNameStartPlaceholder: "Start by typing a formula code/name",
        colorCodePlaceholder: "Introduzir ou selecionar nÃºmero de tom de cor",
        colorCodeStartPlaceholder: "Introduzir ou selecionar nÃºmero de tom de cor",
        colorNameCodePlaceholder: "or type a formula name/code",
        colorNameCodeStartPlaceholder: "Start by typing a formula name/code",
        colorNamePlaceholder: "Introduzir ou selecionar nome de tom de cor",
        colorNameStartPlaceholder: "Introduzir ou selecionar nome de tom de cor",
        colorPreviewIsNotAvailable:
            "PrÃ©-visualizaÃ§Ã£o da cor indisponÃ­vel. Selecione um catÃ¡logo para visualizar cores que sejam relevantes.",
        fandeckPlaceholder: "ou digite um Nome de CatÃ¡logo",
        fandeckStartPlaceholder: "Comece por digitar um Nome de CatÃ¡logo",
        formulaByColor: "FÃ³rmula por Cor",
        noResultsFound: "NÃ£o foram encontrados resultados",
        packagePlaceholder: "ou digite um Nome de Embalagem",
        packageStartPlaceholder: "Comece por digitar o Nome de uma Embalagem",
        productPlaceholder: "ou digite um nome de produto",
        productStartPlaceholder: "Comece por digitar o Nome de um Produto",
        standard: "PadrÃ£o",
        typeFandeckToFilter: "igite aqui para filtrar por Nome de CatÃ¡logo",
        typeProductToFilter: "igite aqui para filtrar por Nome de Produto"
    },
    sendOrderModal: {
        customNote: "Nota personalizada",
        noCompatibleServers: "NÃ£o existem servidores compatÃ­veis disponÃ­veis na sua rede",
        orderOverview: "Vista geral de pedidos",
        selectTargetMachine: "Seleccionar MÃ¡quina Alvo",
        sendOrder: "Enviar Pedido",
        sendOrderTo: "O seu pedido serÃ¡ enviado para %{serverName}",
        targetMachine: "MÃ¡quina Alvo"
    },
    server: {
        computerId: "ID do computador",
        ip: "IP do Servidor",
        selectServer: "Por favor seleccione um dos servidores disponÃ­veis",
        server: "Servidor"
    },
    serverDialog: {
        1: "Existe um erro na definiÃ§Ã£o da marca para a sua licenÃ§a. Por favor consulte o seu Fornecedor.",
        2: "ImpossÃ­vel processar os dados para : %{0}: %{1}",
        3: "Caminho de Rede invÃ¡lido.",
        4: "Tipo de Caminho invÃ¡lido. Somente os tipos %{0} e %{1} sÃ£o suportados.",
        5: "Erro ao escrever o Fiicheiro de Tintagem.",
        6: "Ficheiro de Tintagem criado com sucesso.",
        7: "ImpossÃ­vel encontrar o Corante com o nome: '%{0}' na linha '%{1}'",
        8: "ImpossÃ­vel encontrar a Embalagem com o nome: '%{0}' na linha '%{1}'",
        9: "ImpossÃ­vel encontrar a Base no Produto com o nome: '%{0}' e Base '%{1}' na linha '%{2}'",
        10: "ImpossÃ­vel encontrar a Base na embalagem do Produto com o nome: '%{0}', Base '%{1}' e embalagem '%{2}' na linha '%{3}'",
        11: "ImpossÃ­vel calcular o valor do preÃ§o: '%{0}' na linha '%{1}' da folha '%{2}",
        12: "A preparar dados das Bases â¦",
        13: "A preparar dados das Bases dos Produtos â¦",
        14: "A preparar dados das Embalagens â¦",
        15: "A preparar dados das Cores â¦",
        16: "A preparar dados das Cores nos CatÃ¡logos â¦",
        17: "A preparar dados dos CatÃ¡logos â¦",
        18: "A preparar dados para Procura Global â¦",
        19: "A preparar dados dos Produtos â¦",
        30: "Partial updates can't be applied on database '%{0}'. Update your software to the latest version. Minimal required version is '%{1}'.",
        31: "As actualizaÃ§Ãµes parciais nÃ£o foram aplicadas na base de dados '%{0}'. As versÃµes das bases de dados nÃ£o coincidem. Contate o suporte tÃ©cnico.",
        32: "As actualizaÃ§Ãµes parciais nÃ£o foram aplicadas na base de dados '%{0}'. A versÃ£o da estrutura da base de dados nÃ£o coincide. Contate o suporte tÃ©cnico.",
        33: "As actualizaÃ§Ãµes parciais nÃ£o foram aplicadas na base de dados '%{0}'. A actualizaÃ§Ã£o estÃ¡ corrompida. Contate o suporte tÃ©cnico.",
        34: "Um erro desconhecido ocorreu durante as actualizaÃ§Ãµes parciais. Se o erro persistir contate o suporte tÃ©cnico.",
        35: "Sem actualizaÃ§Ãµes parciais disponÃ­veis. Verifique a sua ligaÃ§Ã£o Ã  internet ou contate o suporte tÃ©cnico.",
        36: "As actualizaÃ§Ãµes parciais para a base de dados '%{0}' sÃ£o para uma versÃ£o mais recente do Redlike. Atualize o Redlike para a versÃ£o mais recente. A versÃ£o mÃ­nima requerida Ã© a '%{1}'.",
        37: "As actualizaÃ§Ãµes parciais nÃ£o podem ser instaladas. NÃ£o existe espaÃ§o em disco suficiente. SÃ£o necessÃ¡rios no mÃ­nimo 20GB de espaÃ§o livre.",
        38: "Partial updates can't be applied on database '%{0}'. The update is invalid. Contact your technical support.",
        39: "Partial updates can't be applied on database '%{0}'. The update can't be downloaded. Contact your technical support.",
        40: "Partial updates can't be applied on database '%{0}'. Downloaded file is corrupted. Contact your technical support."
    },
    serverPlugins: {
        activeServerPlugins: "Plugins de servidor activos",
        currentlyActive: "Plugins actualmente activos",
        plugin: "Plugin",
        pluginName: "Nome do Plugin",
        statusActive: "Activo",
        statusInactive: "Inativo"
    },
    serviceActionsSettings: {
        canisterLevel: "NÃ­veis dos DepÃ³sitos",
        capClose: "Fechar",
        capMiddle: "Centro",
        capOpen: "Abrir",
        cleanAllChannels: "Limpar - Todos",
        cleanChannels: "Limpar",
        computer: "Computador",
        computerReboot: "Reiniciar",
        computerShutdown: "Encerrar",
        connectMachine: "Ligar MÃ¡quina",
        general: "Geral",
        initialize: "Inicializar",
        noMachineIsConnected: "Nenhuma MÃ¡quina Ligada",
        plug: "Ficha",
        plugger: "Conector",
        punch: "Perfurar",
        puncher: "Perfurador",
        purgeChannels: "Purga - Individual",
        recirculate: "Recircular",
        recirculateAllChannels: "Recircular - Todos",
        recirculateChannels: "RecirculaÃ§Ã£o - Individual",
        serviceActions: "AcÃ§Ãµes de ServiÃ§o",
        setCanisterLevel: "NÃ­veis dos DepÃ³sitos de Corantes",
        shelfDown: "Fazer descer a prateleira",
        shelfUp: "Fazer subir a prateleira",
        showServiceWindow: "Mostrar Janela de ServiÃ§o",
        smartPurgeAllChannels: "Purga Inteligente - Todos",
        smartPurgeChannels: "Purga Inteligente - Individual",
        startErrorReset: "ReposiÃ§Ã£o de Erros",
        startHardReset: "Iniciar ReinicializaÃ§Ã£o de Hardware",
        startReset: "Iniciar ReposiÃ§Ã£o",
        stirAllCanisters: "Agitar - Todos",
        stirCanisters: "Agitar",
        stirCanistersMore: "AgitaÃ§Ã£o - Individual"
    },
    spectroMode: {
        eggshell: "Casca de Ovo",
        flat: "Liso",
        gloss: "Brilhante",
        matt: "Fosco",
        matte: "Fosco",
        pearl: "PÃ©rola",
        satin: "Acetinado",
        selectGlossLevel: "Comparar a amostra de cor com a escala de brilho e seleccionar o nÃ­vel de brilho",
        semiGloss: "Semi-Brilho"
    },
    spectroTab: {
        bestMatch: "A Melhor CorrespondÃªncia",
        calibrate: "Calibrar",
        calibrateInstrument: "Calibrar Instrumento",
        connectDevice: "Ligar Instrumento",
        connectedTo: "Ligado a:",
        connectingDevice: "A ligar o seu Instrumento",
        deselectAll: "Desmarcar todos",
        deviceCalibrated: 'O seu Instrumento foi calibrado. JÃ¡ pode iniciar mediÃ§Ãµes."',
        deviceIsNotCalibrated: "O seu Instrumento nÃ£o estÃ¡ calibrado",
        eraseResult: "Resultado do apagamento",
        filter: "Filtro",
        foundInFormulas: "FÃ³rmulas Encontradas",
        inactiveSpectro: "A funÃ§Ã£o EspectrofotÃ³metro estÃ¡ inactiva para a marca seleccionada.",
        instrumentCalibration: "O seu Instrumento precisa de ser calibrado.",
        manualInput: "Entrada manual",
        measure: "MediÃ§Ã£o",
        measurementResult: "Resultado da MediÃ§Ã£o",
        noFilters: "Sem filtros disponÃ­veis",
        noFormulas: "Nenhuma fÃ³rmula encontrada",
        noSelectedSpectro: "Nenhum espectrofotÃ³metro seleccionado",
        notSelected: "NÃ£o seleccionado",
        pressConnectButton: "'Certifique-se de que o seu Instrumento estÃ¡ ligado e prima a tecla ''Ligar'''",
        searchFormulas: "Procurar FÃ³rmulas",
        selectSpectro: "Seleccionar espectrofotÃ³metro",
        showDetails: "Mostrar Detalhes",
        skipCalibration: "Ignorar a CalibraÃ§Ã£o",
        spectroIsConnected: "O EspectrofotÃ³metro estÃ¡ ligado",
        spectroIsReady: "O EspectrofotÃ³metro estÃ¡ pronto",
        spectroReady: "O EspectrofotÃ³metro estÃ¡ pronto para outras tarefas",
        startCalibrateNow: "Iniciar a CalibraÃ§Ã£o agora",
        startMeasureText: "O seu EspectrofotÃ³metro estÃ¡ calibrado â¦ Pode comeÃ§ar a medir.",
        tolerance: "Delta E (CIE 2000)",
        toleranceOfDevitation: "TolerÃ¢ncia Delta E (CIE 2000)"
    },
    statisticsTab: {
        allRecords: "All records",
        customPackageName: "Personalizado %{1} %{2}",
        deleteSelectedRecords: "Eliminar registos seleccionados",
        exportHistory: "HistÃ³rico de ExportaÃ§Ã£o",
        finishFormula: "Terminar FÃ³rmula",
        foundInFormulas: "FÃ³rmulas Encontradas",
        hideHiddenRecords: "NÃ£o mostrar registos ocultos",
        hideSelectedRecord: "Esconder registo seleccionado",
        historicalFormula: "FÃ³rmula histÃ³rica",
        onlyFiltered: "Only filtered",
        restoreSelectedRecord: "Restaurar registo seleccionado",
        showAllRecords: "Mostrar todos os registos",
        standardFormula: "FÃ³rmula PadrÃ£o",
        unknownFormula: "FÃ³rmula desconhecida"
    },
    stirCanisters: {
        selectCanisters: "Seleccionar DepÃ³sitos",
        startStirring: "Iniciar AgitaÃ§Ã£o",
        stirAllCanisters: "Agitar Todos os DepÃ³sitos",
        stirCanisters: "Agitar DepÃ³sitos",
        stirringSpeed: "Velocidade de AgitaÃ§Ã£o",
        stirringTime: "Tempo de AgitaÃ§Ã£o"
    },
    stock: {
        addColorant: "Adicionar Corante",
        addColorantPackagesToStock: "Adicionar embalagens de corantes ao stock",
        addPackagesToStock: "Adicionar emabalagens ao stock",
        addedToStock: "Adicionado ao stock",
        allDatabases: "Todas as Bases de Dados",
        checkStockPackageInventory:
            "Se utilizou uma embalagem do stock, por favor verifique se o seu inventÃ¡rio de stock Ã© vÃ¡lido.",
        clearAllItems: "Limpar todos os itens",
        colorantInventory: "InventÃ¡rio de Corantes",
        colorantsStockInventory: "InventÃ¡rio de Stock de Corantes",
        confirmSendingOrder: "Confirmar Envio do Pedido",
        consumptionPrediction: "PrevisÃ£o do consumo para as prÃ³ximas %{weeks} semanas",
        createOrder: "Criar Pedido (%{sum})",
        expirationDate: "Data de ExpiraÃ§Ã£o",
        inDelivery: "Em Entrega",
        manualOrder: "Pedido Manual",
        manualOrderProgress: "Passo %{step}/%{total}",
        noPackagesFoundInStockForColorant: "NÃ£o existem embalagens em stock para este corante.",
        onStock: "Em stock",
        orderSummary: "Resumo do Pedido",
        prediction: "PrevisÃ£o",
        removePackageFromStock: "Remover do stock embalagem do Corante %{colorantName} ",
        removePackageNameFromStock: "Gostaria de remover do stock uma embalagem %{packageName} ?",
        scanBarcodeOrSelectColorant: "Digitalize cÃ³digo de barras da embalagem ou seleccione corante",
        selectPackageToRemove: "Seleccione a embalagem a remover",
        sendConfirmed: "Envio confirmado",
        setAmountsByPrediction: "Definir quantidades para previsÃ£o",
        sortByColorantName: "Ordenar pelo nome do corante",
        sortByOrderNeed: "Ordenar por necessidade de pedidos",
        sortByStockLevel: "Ordenar por nÃ­vel de stock",
        toOrder: "Para pedir"
    },
    testBarcode: {
        noItemAssigned: "Nenhum item atribuÃ­do ao cÃ³digo de barras %{code}.",
        pleaseScanBarcode: "Por favor, digitalize o cÃ³digo de barras da base, produto, embalagem ou outros itens",
        testBarcodes: "Testar CÃ³digo de Barras"
    },
    ticketing: {
        answer: "Resposta",
        answered: "Respondido",
        chooseType: "Escolher Tipo",
        closeRequest: "Fechar Pedido",
        comment: "ComentÃ¡rio",
        create: "Criar",
        createNewTicket: "Criar Novo Pedido",
        formulaAttached: "The requested formula is attached to the answer. Click the %{loadFormula} button to open it.",
        formulaClaim: "ReclamaÃ§Ã£o de FÃ³rmula",
        formulaRequest: "Pedido de FÃ³rmula",
        formulaUnrealizable: "The requested formula is unrealizable.",
        newTicket: "New ticket",
        noPosInfoFound: "A informaÃ§Ã£o do POS (nome, cidade) nÃ£o foi encontrada.",
        noTicketSelected: "Nenhum Pedido seleccionado",
        openTicket: "Pedido Aberto",
        posName: "Nome do POS",
        posted: "Publicado",
        request: "Pedido",
        requestDate: "Data do Pedido",
        requestId: "ID do Pedido",
        resolvedBy: "Resolvido por",
        responseDate: "Data da Resposta",
        saveToCustomFormula: "Guardar nas FÃ³rmulas Personalizadas",
        sending: "Enviando â¦",
        service: "Service",
        successfulCreation: "Pedido criado com sucesso â¦ Enviando.",
        ticketAnswered: "Um Pedido foi respondido.",
        ticketDelivered: "Um Pedido foi entregue.",
        ticketId: "ID do Pedido",
        ticketType: "Tipo de Pedido",
        waitingForAnswer: "`Ã espera de resposta"
    },
    tutorial: {
        last: "Ãltimo",
        next: "PrÃ³ximo"
    },
    ufiCodeModal: {
        currentStatus: "Estado actual",
        detailedInfoForColorant: "InformaÃ§Ã£o detalhada para o Corante %{colorantName}",
        userSetUfiCode: "CÃ³digo UFI definido pelo utilizador, valor actual"
    },
    ufiCodeSettings: {
        baseUfiCodeValidation: "ValidaÃ§Ã£o do cÃ³digo UFI da Base",
        confirmColorantRefilling: "Confirmar a recarga de corante",
        enableUfiCodes: "Habilitar cÃ³digos UFI",
        printUfiCode: "Imprimir se a quantidade de corante tiver terminado",
        printUfiCodePercentage: "Imprimir percentagem se a quantidade de corante tiver terminado",
        scanOrTypeUfiCode: "Digitalize ou digite o CÃ³digo UFI",
        scanOrTypeUfiCodeOfBase: "Digitalize ou digite o CÃ³digo UFI da embalagem da Base",
        ufiCodesByPercentage: "Utilizar cÃ³digos UFI por percentagem",
        ufiCodesFromDatabase: "Utilizar cÃ³digos UFI da Base de Dados",
        ufiCodesFromLastFilling: "Utilizar os cÃ³digos UFI da Ãºltima recarga"
    },
    userSettings: {
        addUser: "Adicionar Utilizador",
        assignedUserGroups: "Grupos de utilizadores atribuÃ­dos",
        availableUserGroups: "Grupos de utilizadores disponÃ­veis",
        barcode: "CÃ³digo de Barras",
        confirmNewPassword: "Confirmar Palavra-Passe",
        editPassword: "Editar Palavra-Passe",
        editUser: "Editar Utilizador",
        enableAutoLogin: "Activar o login automÃ¡tico",
        newPassword: "Nova Palavra-Passe",
        noChange: "Nenhuma alteraÃ§Ã£o guardada",
        oldPassword: "Palavra-Passe Antiga",
        password: "Palavra-Passe",
        passwordsDoNotMatch: "As Palavras-Passe nÃ£o coincidem",
        restoreUser: "Este utilizador foi eliminado. Quer restaurÃ¡-lo?",
        userGroup: "User Group",
        userGroups: "Grupos de Utilizadores",
        userManagement: "GestÃ£o de Utilizadores",
        userSettings: "DefiniÃ§Ãµes de Utilizador",
        username: "Nome de Utilizador",
        usernameIsMissing: "Falta o nome de Utilizador."
    },
    warningMissingDataModal: {
        continue: "Faltam os mesmos dados ... Continuar?",
        notFoundBase:
            "A Base para este produto nÃ£o estÃ¡ disponÃ­vel. Confirme e tenha o cuidado de obter uma base de produtos compatÃ­vel da prateleira ou cancele o pedido.",
        notFoundProduct:
            "Este Produto nÃ£o estÃ¡ disponÃ­vel. Confirme e tenha o cuidado de obter produto compatÃ­vel da prateleira ou cancele este pedido."
    },
    weekdays: {
        friday: "Sexta-feira",
        monday: "Segunda-feira",
        saturday: "SÃ¡bado",
        sunday: "Domingo",
        thursday: "Quinta-feira",
        tuesday: "TerÃ§a-feira",
        wednesday: "Quarta-feira"
    },
    welcome: {
        availableDatabase:
            "O servidor nÃ£o pode ligar-se Ã  Base de Dados. Por favor, verifique a definiÃ§Ã£o da sua Base de Dados.",
        availableDatabaseLocalError:
            "Erro durante a ligaÃ§Ã£o Ã  Base de Dados local (ficheiro errado ou palavra-passe invÃ¡lida)",
        availableDatabaseLocalMissing: "A Base de Dados local nÃ£o existe.",
        availableDatabaseLocalUpdate: "A Base de Dados local precisa de ser actualizada para a versÃ£o mais recente.",
        availableDatabaseMainAndLocalError:
            "Erro durante a ligaÃ§Ã£o a ambas as Bases de Dados, principal e local (ficheiro errado ou palavra-passe invÃ¡lida)",
        availableDatabaseMainAndLocalMissing: "Faltam os ficheiros principais e locais das Bases de Dados.",
        availableDatabaseMainAndLocalUpdate:
            "Tanto as Bases de Dados principais como locais precisam de ser actualizadas para a versÃ£o mais recente.",
        availableDatabaseMainError:
            "Erro durante a ligaÃ§Ã£o Ã  Base de Dados principal (ficheiro errado ou palavra-passe invÃ¡lida).",
        availableDatabaseMainMissing: "Falta o ficheiro principal da Base de Dados.",
        availableDatabaseMainPartialUpdate:
            "A Base de Dados Principal necessita de ser actualizada para a versÃ£o mais recente atravÃ©s de uma actualizaÃ§Ã£o parcial.",
        availableDatabaseMainPartialUpdateAndLocalUpdate:
            'A Base de Dados Principal necessita de ser actualizada para a versÃ£o mais recente atravÃ©s de uma actualizaÃ§Ã£o parcial e a Base de Dados Local necessita de ser actualizada para a versÃ£o mais recente."',
        availableDatabaseMainUpdate: "A Base de Dados principal precisa de ser actualizada para a versÃ£o mais recente.",
        closing: "A terminar Cliente CCS ",
        compatibility:
            "Por favor verifique a versÃ£o do seu servidor. O seu cliente Ã© compatÃ­vel apenas com servidor %{0} ou superior.",
        compatibilityCheck: "A verificaÃ§Ã£o de compatibilidade em curso â¦",
        compatibilityDatabase:
            "A sua Base de Dados nÃ£o Ã© compatÃ­vel com o servidor. Por favor, verifique a definiÃ§Ã£o da sua Base de Dados.",
        connectingServer: "LigaÃ§Ã£o ao servidor em curso no IP  %{ip}.",
        databaseCompatibility: "A sua Base de Dados nÃ£o Ã© compatÃ­vel com o software actual.",
        databasesCompatibility: "As suas Bases de Dados nÃ£o sÃ£o compatÃ­veis com o software actual.",
        licenseVerification: "A verificaÃ§Ã£o da licenÃ§a estÃ¡ em curso â¦",
        loading: "A carregar â¦",
        lostConnection: "A ligaÃ§Ã£o ao servidor foi perdida!",
        moduleMessage:
            "ATENÃÃO Ã  selecÃ§Ã£o do mÃ³dulo porque a mudanÃ§a futura do mÃ³dulo sÃ³ estarÃ¡ disponÃ­vel para utilizadores privilegiados.",
        refresh: "Actualizar",
        restoring: "A restaurar a ligaÃ§Ã£o",
        selectModule: "Por favor, seleccione um dos mÃ³dulos disponÃ­veis.",
        stopUpdate: "Parar ActualizaÃ§Ã£o",
        updateDatabase: "ActualizaÃ§Ã£o da Base de Dados",
        updatingDatabase: "A Base de Dados estÃ¡ a ser actualizada â¦",
        updatingDatabases: "As Bases de Dados estÃ£o a ser actualizadas â¦",
        updatingWarning: "A estrutura da Base de Dados estÃ¡ a ser actualizada para a versÃ£o mais recente â¦  .",
        updatingWarningInfo:
            "NÃ£o fechar esta janela, pois isso resultarÃ¡ na necessidade de fazer a actualizaÃ§Ã£o a partir do zero."
    }
};
